import type {
  AxiosInstance,
  AxiosRequestConfig,
  HeadersDefaults,
  ResponseType,
} from 'axios';
import axios from 'axios';

/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum SibContractStatus {
  Active = 'active',
  Inactive = 'inactive',
}

export enum VectorApiContractStatus {
  Archived = 'Archived',
  FullyExecuted = 'Fully Executed',
  BillProcessingOnly = 'Bill Processing Only',
}

/** Difficulty level */
export enum Difficulty {
  VeryEasy = 'VeryEasy',
  Easy = 'Easy',
  Neutral = 'Neutral',
  Hard = 'Hard',
  VeryHard = 'VeryHard',
}

export enum DevicePlatform {
  Ios = 'ios',
  Android = 'android',
  Web = 'web',
}

export enum UserType {
  Internal = 'internal',
  External = 'external',
}

export enum SpendInitiator {
  SIB = 'SIB',
  Client = 'Client',
}

export enum InvoicePaymentStatus {
  Paid = 'paid',
  Unpaid = 'unpaid',
  PartiallyPaid = 'partially-paid',
}

export enum SubauditVersionChangeRecordFields {
  VersionAuditId = 'version_auditId',
  VersionOwner = 'version_owner',
  VersionOrganization = 'version_organization',
  VersionVendor = 'version_vendor',
  VersionVendorAccountNumber = 'version_vendorAccountNumber',
  VersionSpendAmount = 'version_spendAmount',
  VersionSubauditStage = 'version_subauditStage',
  VersionUpdatedBy = 'version_updatedBy',
  VersionCreatedBy = 'version_createdBy',
  VersionTeam = 'version_team',
  VersionLocation = 'version_location',
  VersionSubauditName = 'version_subauditName',
  VersionAutoIncrementedId = 'version_autoIncrementedId',
  VersionOnHold = 'version_onHold',
}

export enum SubauditStage {
  New = 'New',
  GatherInfoVendor = 'Gather Info - Vendor',
  NegotiationInProgress = 'Negotiation In Progress',
  NegotiationCompleted = 'Negotiation Completed',
}

export enum EntraGroup {
  Employee = 'employee',
  MicrositeUser = 'microsite-user',
  Cms = 'cms',
}

export enum OrganizationSpecialFilter {
  Membership = 'membership',
  ActiveTasks = 'active-tasks',
}

export enum RecurrenceInterval {
  Day = 'day',
  Week = 'week',
  Month = 'month',
}

export enum NotificationPriority {
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
}

export enum OccurrenceInterval {
  OneTime = 'one_time',
  Monthly = 'monthly',
  Quarterly = 'quarterly',
  Annually = 'annually',
}

/** Whether the value comes from the manual override on the spend category or was computed from completed audits */
export enum AverageAuditDurationSource {
  Manual = 'manual',
  Computed = 'computed',
}

export enum AuditStage {
  MONITORING_SAVINGS = 'MONITORING_SAVINGS',
  SAVINGS_REALIZED = 'SAVINGS_REALIZED',
  SAVINGS_ESTIMATED = 'SAVINGS_ESTIMATED',
  SPEND_ESTIMATED = 'SPEND_ESTIMATED',
  MOBILIZATION = 'MOBILIZATION',
  NEGOTIATIONS = 'NEGOTIATIONS',
}

export enum AuditStatus {
  Open = 'open',
  Pending = 'pending',
  OnHold = 'on_hold',
  Completed = 'completed',
  Cancelled = 'cancelled',
}

export enum DashboardMetricsField {
  LastEditedTask = 'lastEditedTask',
  LastEditedTicket = 'lastEditedTicket',
  Notifications = 'notifications',
  CrmCount = 'crmCount',
  Tickets = 'tickets',
  Tasks = 'tasks',
}

export enum ActionItemType {
  MeetingLink = 'meeting-link',
  Link = 'link',
  FileUpload = 'file-upload',
}

export enum DocumentFieldStatus {
  COMPLETE = 'COMPLETE',
  MISSING_FIELDS = 'MISSING_FIELDS',
  UPLOAD_INVOICES = 'UPLOAD_INVOICES',
  NOT_APPLICABLE_REQUESTED = 'NOT_APPLICABLE_REQUESTED',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
}

export enum LocationStatus {
  Active = 'Active',
  Monitored = 'Monitored',
  Sold = 'Sold',
  Closed = 'Closed',
  UnderConstruction = 'Under Construction',
  NotActive = 'Not Active',
}

export enum BillPayPaymentType {
  Ach = 'ach',
  Cc = 'cc',
  Check = 'check',
}

export enum PaymentRemittanceIdentifier {
  InvoiceNumber = 'invoice_number',
  AccountNumber = 'account_number',
}

/** Vendor lifecycle status from the `vendor_status` column. */
export enum VendorStatus {
  Active = 'active',
  Inactive = 'inactive',
  OnHold = 'on-hold',
}

export enum FundingDetailsSubmissionMethod {
  Email = 'email',
  Sftp = 'sftp',
}

export enum BillPayFundingFrequency {
  Monthly = 'monthly',
  Quarterly = 'quarterly',
}

export enum ClientStatus {
  BillPay = 'bill_pay',
  CustomerSuccess = 'customer_success',
  Dormant = 'dormant',
  Mobilization = 'mobilization',
  Negotiation = 'negotiation',
  PostNegotiation = 'post_negotiation',
  PreNegotiation = 'pre_negotiation',
  Prospect = 'prospect',
  Validation = 'validation',
}

export enum OrganizationStatus {
  Active = 'active',
  Inactive = 'inactive',
}

export enum TicketCommentScope {
  Internal = 'internal',
  External = 'external',
}

export enum TicketCategory {
  Account = 'account',
  Baselines = 'baselines',
  Client = 'client',
  Contract = 'contract',
  CustomerService = 'customer_service',
  Escalation = 'escalation',
  Exceptions = 'exceptions',
  Finance = 'finance',
  FollowUp = 'follow_up',
  InformationRequest = 'information_request',
  Invoice = 'invoice',
  MasterData = 'master_data',
  Negotiation = 'negotiation',
  Others = 'others',
  Payments = 'payments',
  Property = 'property',
  ServiceRequest = 'service_request',
  Transitions = 'transitions',
  VendorLocal = 'vendor_local',
  MissingBill = 'missing_bill',
  UpdateMailingAddress = 'update_mailing_address',
  PotentialLeak = 'potential_leak',
  InvoiceQuestion = 'invoice_question',
}

export enum TicketStatus {
  InProgress = 'in_progress',
  New = 'new',
  Closed = 'closed',
  WorkingWithVendor = 'working_with_vendor',
  AwaitingClientAction = 'awaiting_client_action',
  AwaitingInternalAction = 'awaiting_internal_action',
  Canceled = 'canceled',
  Completed = 'completed',
}

export enum ProjectStatus {
  Unassigned = 'unassigned',
  Unstarted = 'unstarted',
  InProgress = 'in-progress',
  OnHold = 'on-hold',
  ViewOnly = 'view-only',
  InReview = 'in-review',
  Escalated = 'escalated',
  Completed = 'completed',
}

export enum SpendAreaStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  IN_PROGRESS_WITH_SAVINGS = 'IN_PROGRESS_WITH_SAVINGS',
  COMPLETED = 'COMPLETED',
  NOT_ASSIGNED = 'NOT_ASSIGNED',
  REQUESTED = 'REQUESTED',
}

export enum SpendAreaStage {
  MONITORING_SAVINGS = 'MONITORING_SAVINGS',
  SAVINGS_REALIZED = 'SAVINGS_REALIZED',
  SPEND_ESTIMATED = 'SPEND_ESTIMATED',
  MOBILIZATION = 'MOBILIZATION',
  NEGOTIATIONS = 'NEGOTIATIONS',
}

export enum VendorAccountStatus {
  Active = 'active',
  Inactive = 'inactive',
}

export enum BillingType {
  Paper = 'paper',
  Email = 'email',
  Portal = 'portal',
}

export enum InvoiceFrequency {
  BiWeekly = 'bi_weekly',
  Weekly = 'weekly',
  Monthly = 'monthly',
  BiMonthly = 'bi_monthly',
  Quarterly = 'quarterly',
}

export enum TaskTagVersionChangeRecordFields {
  VersionTask = 'version_task',
  VersionRecurringTask = 'version_recurringTask',
  VersionTag = 'version_tag',
  VersionContact = 'version_contact',
  VersionEmployee = 'version_employee',
  VersionType = 'version_type',
  VersionCreatedBy = 'version_createdBy',
  VersionUpdatedBy = 'version_updatedBy',
  VersionDeletedAt = 'version_deletedAt',
}

export enum SubtaskVersionChangeRecordFields {
  VersionTitle = 'version_title',
  VersionDescription = 'version_description',
  VersionPriorityLevel = 'version_priorityLevel',
  VersionCompleted = 'version_completed',
  VersionCreatedBy = 'version_createdBy',
  VersionTask = 'version_task',
  VersionUpdatedBy = 'version_updatedBy',
}

export enum TaskVersionChangeRecordFields {
  VersionTitle = 'version_title',
  VersionDescription = 'version_description',
  VersionPriorityLevel = 'version_priorityLevel',
  VersionReferenceLink = 'version_referenceLink',
  VersionReferenceName = 'version_referenceName',
  VersionCategory = 'version_category',
  VersionAssignee = 'version_assignee',
  VersionOrganization = 'version_organization',
  VersionVendor = 'version_vendor',
  VersionCompleted = 'version_completed',
  VersionCompletedAt = 'version_completedAt',
  VersionDeadline = 'version_deadline',
  VersionSeenAt = 'version_seenAt',
  VersionSeen = 'version_seen',
  VersionFollowUpTaskParent = 'version_followUpTaskParent',
  VersionRecurringTask = 'version_recurringTask',
  VersionSubauditId = 'version_subauditId',
  VersionTimeLogged = 'version_timeLogged',
  VersionEstimatedTime = 'version_estimatedTime',
  VersionHiddenBefore = 'version_hiddenBefore',
  VersionProject = 'version_project',
  VersionTicket = 'version_ticket',
  VersionCreatedBy = 'version_createdBy',
  VersionUpdatedBy = 'version_updatedBy',
  VersionDeletedAt = 'version_deletedAt',
  TagsCreated = 'tags_created',
  TagsDeleted = 'tags_deleted',
}

/** The type of the entity. Usually the name of the entity. */
export enum ChangelogEntityType {
  Task = 'task',
  Subtask = 'subtask',
  TaskTag = 'taskTag',
  Subaudit = 'subaudit',
  SubauditTask = 'subauditTask',
  SubauditComment = 'subauditComment',
}

export enum AuditingAction {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
}

export enum AdditionalColumnsType {
  Select = 'select',
}

export enum TagType {
  Custom = 'custom',
  Contact = 'contact',
  Employee = 'employee',
}

export enum TaskCategory {
  VendorCall = 'Vendor Call',
  ClientCall = 'Client Call',
  InternalOutreach = 'Internal outreach',
  VendorEmail = 'Vendor email',
  ClientEmail = 'Client email',
  DataAnalysis = 'Data analysis',
  ReportBuild = 'Report build',
  DataGathering = 'Data gathering',
  InvoiceCollection = 'Invoice Collection',
  Research = 'Research',
  ProactiveClientOutreach = 'Proactive Client Outreach',
  Other = 'Other',
}

/** Priority of the task */
export enum PriorityLevel {
  Low = 'low',
  Medium = 'medium',
  High = 'high',
}

export enum BillingInvoiceContactCompany {
  Sib = 'Sib',
  Vector = 'Vector',
}

export enum PermissionAction {
  NONE = 0,
  CREATE = 1,
  READ = 2,
  UPDATE = 4,
  DELETE = 8,
}

export enum PermissionResource {
  Admin = 'admin',
  Manager = 'manager',
  Employee = 'employee',
  Client = 'client',
  Crm = 'crm',
  Team = 'team',
  Dashboard = 'dashboard',
  Savings = 'savings',
  ActionItems = 'action_items',
  SpendAreas = 'spend_areas',
  Documents = 'documents',
  SensitiveDocuments = 'sensitive_documents',
  Locations = 'locations',
  Reports = 'reports',
  Tickets = 'tickets',
  Teams = 'teams',
  Billings = 'billings',
  Vendors = 'vendors',
  AccessShare = 'access_share',
  RoleAssignment = 'role_assignment',
  Contacts = 'contacts',
  SibContracts = 'sib_contracts',
  InactiveSibContracts = 'inactive_sib_contracts',
  Organizations = 'organizations',
  Projects = 'projects',
  Audits = 'audits',
  Subaudits = 'subaudits',
  AuditTasks = 'audit_tasks',
  Templates = 'templates',
  Settings = 'settings',
  Diagnostics = 'diagnostics',
  Maintenance = 'maintenance',
  FranzIntegration = 'franz_integration',
}

export enum UserLoginStatus {
  Uncompleted = 'uncompleted',
  Completed = 'completed',
}

export enum DocumentUploadStage {
  Pending = 'pending',
  Failed = 'failed',
  Uploaded = 'uploaded',
  Removed = 'removed',
}

export enum PaymentFrequency {
  Monthly = 'Monthly',
  Quarterly = 'Quarterly',
  Annually = 'Annually',
  SemiAnnual = 'Semi-Annual',
}

export enum ContractType {
  MSA = 'MSA',
  SOW = 'SOW',
  Amendment = 'Amendment',
  Addendum = 'Addendum',
  OrderForm = 'Order Form',
  EndUserLicenseAgreement = 'End User License Agreement',
  NDA = 'NDA',
  DataSecurityAgreement = 'Data Security Agreement',
  Other = 'Other',
}

export enum DocumentUploadStatus {
  Pending = 'pending',
  Failed = 'failed',
  Uploaded = 'uploaded',
  Removed = 'removed',
}

export enum DocumentProvidedBy {
  Client = 'client',
  Sib = 'sib',
  Vector = 'vector',
}

export enum DocumentStage {
  Uploaded = 'uploaded',
  InProgress = 'in-progress',
  ActionNeeded = 'action-needed',
  Approved = 'approved',
  Rejected = 'rejected',
  Expired = 'expired',
}

export enum CategoryManager {
  ErnestoVidal = 'Ernesto Vidal',
  JorgeDiaz = 'Jorge Diaz',
  KayleePolley = 'Kaylee Polley',
  JenniferNorcross = 'Jennifer Norcross',
  GabriellaDion = 'Gabriella Dion',
  WendyRuggiero = 'Wendy Ruggiero',
  JuanBonilla = 'Juan Bonilla',
  FrankMilatta = 'Frank Milatta',
}

export enum DocumentType {
  Invoice = 'invoice',
  Contract = 'contract',
  LetterOfAuthorization = 'letter-of-authorization',
  Other = 'other',
  SiteList = 'site-list',
}

export interface QueueInfoDto {
  /** Queue name */
  name: string;
  /** Number of waiting jobs */
  waiting: number;
  /** Number of active jobs */
  active: number;
  /** Number of completed jobs */
  completed: number;
  /** Number of failed jobs */
  failed: number;
  /** Number of delayed jobs */
  delayed: number;
  /** Number of paused jobs */
  paused: number;
}

export interface ListQueueJobsDto {
  /** Array of jobs in the queue */
  jobs: string[];
  /** Total number of jobs */
  total: number;
}

export interface BulkUpdateDocumentDto {
  /** @uniqueItems true */
  documentIds: string[];
  type?: DocumentType | null;
  /** @uniqueItems true */
  tags?: string[];
  categoryManager?: CategoryManager | null;
  /** @format uuid */
  spendCategory?: string | null;
  vendor?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  renewalDate?: string | null;
  annualContractValue?: number | null;
  notToExceed?: boolean | null;
  annualPriceIncrease?: boolean | null;
  earlyTerminationFee?: boolean | null;
  sensitive?: boolean | null;
  categoryManagerUser?: string | null;
}

export interface PlainExternalUserDto {
  id: string;
  name: string;
  email: string;
  avatarUrl: string | null;
  deletedAt: string | null;
}

export interface SpendCategoryListItemDto {
  id: string;
  name: string;
}

export interface DocumentTagDto {
  uuid: string;
  name: string;
  isPredefined?: boolean;
}

export interface DocumentDto {
  id: string;
  stage: DocumentStage;
  fileUrl: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  name: string;
  sensitive: boolean;
  providedBy: DocumentProvidedBy;
  uploadedBy: PlainExternalUserDto;
  spendCategory?: SpendCategoryListItemDto | null;
  organizationId: string;
  subsidiaryOrganizationName?: string | null;
  tags: DocumentTagDto[] | null;
  uploadStage: DocumentUploadStatus;
  contractType?: ContractType | null;
  categoryManager?: CategoryManager | null;
  categoryManagerUser?: PlainExternalUserDto | null;
  paymentFrequency?: PaymentFrequency | null;
  anomaly?: boolean | null;
  matchingDocuments?: number | null;
  hasVirtualInvoices?: boolean;
  docId?: string | null;
  /** AI-managed fields explicitly edited by a user; Franz sync skips these. */
  userModifiedFields?: string[];
  /**
   * Set when Franz first updates this document; AI-managed fields become read-only for users.
   * @format date-time
   */
  updatedWithAiAt?: string | null;
  vendor: string | null;
  fileSize?: number | null;
  type: string | null;
  /** @format date-time */
  startDate?: string | null;
  /** @format date-time */
  endDate?: string | null;
  /** @format date-time */
  renewalDate?: string | null;
  annualContractValue?: number | null;
  notToExceed?: boolean | null;
  annualPriceIncrease?: boolean | null;
  earlyTerminationFee?: boolean | null;
  cancellationDateNoticePeriod?: string | null;
  autoRenewalClause?: boolean | null;
  autoRenewalLength?: string | null;
  notToExceedPercentage?: number | null;
  additionalColumns?: object | null;
}

export interface FileUploadMetadataDto {
  filename: string;
  filesize: number;
  mimetype: string;
  sensitive: boolean;
  /** MD5 hash of the file content (base64), computed by the client before upload */
  md5Hash?: string;
}

export interface BulkGenerateUploadUrlDto {
  /** @minItems 1 */
  files: FileUploadMetadataDto[];
  batchId: string;
  totalFiles: number;
}

export interface BulkGenerateUploadUrlResponseItemDto {
  filename: string;
  filesize: number;
  mimetype: string;
  sensitive: boolean;
  /** MD5 hash of the file content (base64), computed by the client before upload */
  md5Hash?: string;
  /** Created document ID */
  documentId: string;
  /** SAS URL to upload the file directly to blob storage */
  uploadUrl: string;
  /** Encoded blob path destination */
  destination: string;
}

export interface BulkGenerateUploadUrlFailedItemDto {
  /** Filename that failed to process */
  filename: string;
  /** Error message describing the failure */
  error: string;
}

export interface BulkGenerateUploadUrlResponseDto {
  items: BulkGenerateUploadUrlResponseItemDto[];
  failed: BulkGenerateUploadUrlFailedItemDto[];
}

export interface InitUploadDocumentItemDto {
  filename: string;
  mimetype: string;
  /**
   * File size in bytes from the client File object, validated before upload starts
   * @min 1
   */
  filesize: number;
  /** MD5 hash of the file content (base64), computed by the client before upload */
  md5Hash: string;
  sensitive?: boolean;
  /** Discard any partial blob in storage and start a fresh upload session */
  restart?: boolean;
}

export interface InitUploadDocumentsDto {
  /** @minItems 1 */
  files: InitUploadDocumentItemDto[];
  /** This is ID helps us groupd the files in the same bulk upload */
  batchUploadId?: string;
  /** Total number of files in the batch upload */
  totalFiles: number;
}

export interface InitUploadDocumentResponseItemDto {
  /** Document ID for this upload session */
  uploadId: string;
  /** SAS URL for staging block blobs (Put Block). Client uploads chunks directly to Azure. */
  sasUrl: string;
  /** Recommended block size in bytes for chunk uploads */
  blockSize: number;
  /** Expected number of blocks for this file size */
  maxBlocks: number;
  /** When false, the client must not resume staged blocks from local storage (e.g. after abandoned-upload cleanup moved the session to failed). */
  resumePartialBlocks: boolean;
  /** Filename for this upload session */
  filename: string;
}

export interface InitUploadDocumentFailedItemDto {
  /** Filename that failed to initialize */
  filename: string;
  /** Error message describing the failure */
  error: string;
}

export interface InitUploadDocumentsResponseDto {
  items: InitUploadDocumentResponseItemDto[];
  failed: InitUploadDocumentFailedItemDto[];
}

export interface CompleteUploadDocumentDto {
  /** Document ID returned from POST /upload/init */
  uploadId: string;
  /** Ordered list of block IDs staged in Azure (base64), one per uploaded chunk. Omit (or send an empty array) for single-blob uploads where the whole file was sent via a single Put Blob. */
  blockIds?: string[];
}

export interface UploadDocumentDto {
  stage?: DocumentStage;
  type?: DocumentType | null;
  /** Total number of files in the batch upload */
  totalFiles: number;
  /** MD5 hash of the file content (base64), computed by the client before upload */
  md5Hash?: string;
  contractType?: ContractType | null;
  categoryManagerUser?: string | null;
  categoryManager?: CategoryManager | null;
  paymentFrequency?: PaymentFrequency | null;
  /** This is ID helps us groupd the files in the same bulk upload */
  batchUploadId?: string;
  /**
   * File size in bytes from the client File object, validated before upload starts
   * @min 1
   */
  filesize: number;
  /**
   * The file to upload
   * @format binary
   */
  file: File;
  vendor?: string | null;
  spendCategory?: string | null;
  sensitive?: boolean | null;
  startDate?: string | null;
  endDate?: string | null;
  renewalDate?: string | null;
  annualContractValue?: number | null;
  notToExceed?: boolean | null;
  annualPriceIncrease?: boolean | null;
  earlyTerminationFee?: boolean | null;
  cancellationDateNoticePeriod?: string | null;
  autoRenewalClause?: boolean | null;
  autoRenewalLength?: string | null;
  notToExceedPercentage?: number | null;
  additionalColumns?: object | null;
}

export interface PostprocessUploadedDocumentDto {
  status: DocumentUploadStage;
  filename: string;
}

export interface DocumentListDto {
  /** Array of items */
  items: DocumentDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export type StreamableFile = object;

export interface DocumentColumnMaxValuesDto {
  annualContractValue: number | null;
  notToExceedPercentage: number | null;
}

export interface CheckDocumentContentHashQueryDto {
  /**
   * Unique MD5 hashes of file content (base64), computed by the client before upload
   * @minItems 1
   */
  md5Hashes: string[];
}

export interface CheckDocumentContentHashResultDto {
  /** MD5 hash that was checked */
  md5Hash: string;
  /** Whether an uploaded document with identical content already exists */
  isDuplicate: boolean;
  /** Human-readable reason when isDuplicate is true */
  message?: string;
}

export interface CheckDocumentContentHashResponseDto {
  /** Duplicate check result for each requested MD5 hash */
  results: CheckDocumentContentHashResultDto[];
}

export interface VirtualDocumentDto {
  id: string;
  franzDocId: string;
  name?: string | null;
  type?: string | null;
  subsidiary?: string | null;
  vendor?: string | null;
  providedBy?: DocumentProvidedBy | null;
  stage?: DocumentStage | null;
  categoryManagerUser?: PlainExternalUserDto | null;
  paymentFrequency?: PaymentFrequency | null;
  spendCategory?: SpendCategoryListItemDto | null;
  /** @format date-time */
  startDate?: string | null;
  /** @format date-time */
  endDate?: string | null;
  /** @format date-time */
  renewalDate?: string | null;
  annualContractValue?: number | null;
  notToExceed?: boolean | null;
  annualPriceIncrease?: boolean | null;
  earlyTerminationFee?: boolean | null;
  contractType?: ContractType | null;
  cancellationDateNoticePeriod?: string | null;
  autoRenewalClause?: boolean | null;
  autoRenewalLength?: string | null;
  notToExceedPercentage?: number | null;
  anomaly?: boolean | null;
  matchingDocuments?: number | null;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface VirtualDocumentListDto {
  /** Array of items */
  items: VirtualDocumentDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface UpdateDocumentDto {
  stage?: DocumentStage;
  type?: DocumentType | null;
  contractType?: ContractType | null;
  categoryManagerUser?: string | null;
  categoryManager?: CategoryManager | null;
  paymentFrequency?: PaymentFrequency | null;
  tags?: string[];
  filename?: string;
  vendor?: string | null;
  spendCategory?: string | null;
  sensitive?: boolean | null;
  startDate?: string | null;
  endDate?: string | null;
  renewalDate?: string | null;
  annualContractValue?: number | null;
  notToExceed?: boolean | null;
  annualPriceIncrease?: boolean | null;
  earlyTerminationFee?: boolean | null;
  cancellationDateNoticePeriod?: string | null;
  autoRenewalClause?: boolean | null;
  autoRenewalLength?: string | null;
  notToExceedPercentage?: number | null;
  additionalColumns?: object | null;
}

export interface DocumentUploadStatusDto {
  id: string;
  name: string;
  status: DocumentUploadStage;
  createdAt: string;
  updatedAt: string;
}

export interface DocumentUploadStatusListDto {
  /** Array of items */
  items: DocumentUploadStatusDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface SelectListItemDto {
  id: string;
  name: string;
}

export interface SelectListDto {
  items: SelectListItemDto[];
}

export interface SyncFranzDocumentDto {
  /**
   * Base64 MD5 hash of the uploaded parent document blob
   * @minLength 1
   */
  documentHash: string;
}

export interface DocumentFileUrlDto {
  /** Time-limited SAS URL for reading the document blob */
  fileUrl: string;
}

export interface ExternalUserPartialListDto {
  /** Array of items */
  items: PlainExternalUserDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface UpdateExternalUserDto {
  contactPhoneNumber?: string;
  firstName?: string;
  surname?: string;
  title?: string;
  contactEmail?: string;
  meetingLink?: string;
  userLoginStatus?: UserLoginStatus;
}

export interface PermissionDto {
  resource?: PermissionResource;
  action?: PermissionAction;
}

export interface OrganizationLogoDto {
  fileUrl?: string | null;
  width: number | null;
  height: number | null;
}

export interface ExternalUserDto {
  id: string;
  name: string;
  email: string;
  meetingLink?: string;
  title?: string;
  userLoginStatus?: UserLoginStatus;
  firstName: string | null;
  surname: string | null;
  contactEmail: string | null;
  contactPhoneNumber: string | null;
  avatarUrl: string | null;
  deletedAt: string | null;
}

export interface PowerBiReportDto {
  id: string;
  name?: string;
  groupId: string;
  reportId: string;
  token: string;
  filterQuery?: string;
}

export interface ParentOrganizationDto {
  id: string;
  name: string;
  fileUrl?: string | null;
  logo?: OrganizationLogoDto | null;
  width: number | null;
  height: number | null;
}

export interface OrganizationDto {
  id: string;
  name: string;
  fileUrl?: string | null;
  logo?: OrganizationLogoDto | null;
  createdAt: string;
  updatedAt: string;
  manager?: ExternalUserDto | null;
  powerBiReport?: PowerBiReportDto | null;
  permissions?: Record<string, PermissionAction> | null;
  parentOrganization?: ParentOrganizationDto | null;
  privateEquityFirm?: ParentOrganizationDto | null;
  termsOfServiceAccepted: boolean;
  tosAcceptedAt?: string | null;
  tosAcceptedBy?: PlainExternalUserDto | null;
  domains?: string[] | null;
  vectorClientId: string | null;
  aiEnabled: boolean | null;
  aiPort: string | null;
  aiBrandingAlias: string | null;
  netsuiteCustomerId: string | null;
  width: number | null;
  height: number | null;
}

export interface YourTeamMemberDto {
  id: string;
  name: string;
  email: string;
  meetingLink?: string;
  title?: string;
  userLoginStatus?: UserLoginStatus;
  firstName: string | null;
  surname: string | null;
  contactEmail: string | null;
  contactPhoneNumber: string | null;
  avatarUrl: string | null;
  deletedAt: string | null;
}

export interface BillingContactDto {
  id: string;
  name: string;
  email: string;
  provider: BillingInvoiceContactCompany;
  contactPhoneNumber: string | null;
  meetingLink: string | null;
  title: string | null;
}

export interface YourTeamDto {
  primaryContact: YourTeamMemberDto | null;
  otherSupportingMembers: YourTeamMemberDto[] | null;
  billingContact: BillingContactDto[] | null;
}

export interface TagDto {
  uuid: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  name: string;
  /** @pattern ^#?([0-9A-F]{3}|[0-9A-F]{4}|[0-9A-F]{6}|[0-9A-F]{8})$ */
  color?: string;
  isPredefined?: boolean;
  createdBy: string;
}

export interface ContactDto {
  id: string;
  name?: string;
  email?: string;
  isActive: boolean;
  firstName: string | null;
  lastName: string | null;
  title: string | null;
  phoneNumber: string | null;
  note: string | null;
}

export interface TaskTagDto {
  tag?: TagDto | null;
  contact?: ContactDto | null;
  employee?: ExternalUserDto | null;
  type?: TagType;
}

export interface BaseTaskOrganizationDto {
  id: string;
  name: string;
  logoUrl?: string | null;
}

export interface TaskRelationDto {
  uuid: string;
  title: string;
}

export interface TaskDto {
  /**
   * Unique identifier for the task
   * @example "c56a4180-65aa-42ec-a945-5fd21dec0538"
   */
  uuid: string;
  /**
   * Title of the task
   * @example "Complete project documentation"
   */
  title: string;
  /**
   * Description of the task
   * @example "Finish writing the project documentation by end of the day"
   */
  description?: string | null;
  /**
   * Date when the task was created
   * @format date-time
   * @example "2023-01-01T12:00:00Z"
   */
  createdAt: string;
  /**
   * Date when the task was last updated
   * @format date-time
   * @example "2023-01-02T15:30:00Z"
   */
  updatedAt: string;
  /** Priority of the task */
  priorityLevel: PriorityLevel;
  createdByUser: PlainExternalUserDto;
  assigneeUser: PlainExternalUserDto;
  category?: TaskCategory;
  tags: TaskTagDto[];
  /**
   * Task completion status
   * @example false
   */
  completed: boolean;
  /**
   * Deadline date of the task
   * @format date-time
   * @example "2024-01-02T15:30:00Z"
   */
  deadline: string | null;
  /**
   * Date of the task completion
   * @format date-time
   * @example "2024-01-02T15:30:00Z"
   */
  completedAt: string | null;
  unfinishedSubtasksCount: number;
  organization?: BaseTaskOrganizationDto;
  vendor?: BaseTaskOrganizationDto | null;
  followUpTask?: TaskRelationDto | null;
  parentTask?: TaskRelationDto | null;
  /**
   * Time logged on this task in minutes
   * @min 0
   * @example 120
   */
  timeLogged?: number | null;
  /** @format uuid */
  recurringTaskUuid: string | null;
  /** @format date-time */
  seenAt: string | null;
  seen: boolean | null;
  /** @format uuid */
  subauditId: string | null;
  isDelegated: boolean | null;
  /** @format uuid */
  projectId: string | null;
  /** @format uuid */
  ticketId: string | null;
  commentsCount: number | null;
  filesCount: number | null;
  referenceLink: string | null;
  referenceName: string | null;
  /**
   * Estimated time to complete the task in minutes
   * @min 1
   * @example 120
   */
  estimatedTime: number | null;
}

export interface TaskListDto {
  /** Array of items */
  items: TaskDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
  newItemsCount?: number;
}

export interface AllowedDomainListDto {
  items: string[];
}

export interface SpendCategoryListDto {
  /** Array of items */
  items: SpendCategoryListItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface AdditionalColumnValueDto {
  value: string;
  label: string | null;
}

export interface AdditionalColumnsDto {
  id: string;
  tableName: string;
  label: string;
  key: string;
  /** @example "select" */
  type: AdditionalColumnsType;
  values?: AdditionalColumnValueDto[] | null;
}

export interface AdditionalColumnsListDto {
  /** List of additional columns */
  items: AdditionalColumnsDto[];
}

export interface CreateTaskTagDto {
  /**
   * ID of the tag (can be either contact ID or tag UUID)
   * @format uuid
   * @example "a1b2c3d4-e5f6-7890-1234-567890abcdef"
   */
  id: string;
  /**
   * Type of the tag
   * @example "contact"
   */
  type: TagType;
}

export interface CreateTaskDto {
  title: string;
  priorityLevel?: PriorityLevel;
  category: TaskCategory;
  /**
   * The ID of the user to assign the task to
   * @format uuid
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  assignee?: string;
  /**
   * Estimated time to complete the task in minutes
   * @min 1
   * @example 120
   */
  estimatedTime?: number;
  /**
   * @format date-time
   * @example "2024-12-31T23:59:59Z"
   */
  deadline: string;
  completed?: boolean;
  seen?: boolean;
  tags?: CreateTaskTagDto[] | null;
  /**
   * @min 0
   * @example 120
   */
  timeLogged?: number;
  /** @format uuid */
  subauditId?: string | null;
  /** @format uuid */
  followUpParentTaskId?: string | null;
  /** @format uuid */
  projectId?: string | null;
  /** @format uuid */
  ticketId?: string | null;
  description?: string | null;
  referenceLink?: string | null;
  referenceName?: string | null;
  organizationId?: string | null;
  /** The ID of the vendor organization to associate with the task */
  vendorId?: string | null;
}

export interface AssignedUserTaskSummaryDto {
  /** ID of the user the task is assigned to */
  id: string;
  /** Full name of the user the task is assigned to */
  name: string;
  /**
   * Number of tasks created by current user and assigned to this user
   * @min 0
   * @example 5
   */
  taskCount: number;
  /** Time-limited URL for the assignee profile picture */
  avatarUrl: string | null;
}

export interface AssignedUserTaskSummaryListDto {
  /** Array of items */
  items: AssignedUserTaskSummaryDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface LogTimeDto {
  /**
   * @min 1
   * @example 30
   */
  timeMinutes: number;
}

export interface UpdateTaskDto {
  priorityLevel?: PriorityLevel;
  category?: TaskCategory | null;
  /**
   * The ID of the user to assign the task to
   * @format uuid
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  assignee?: string;
  /**
   * Estimated time to complete the task in minutes
   * @min 1
   * @example 120
   */
  estimatedTime?: number;
  completed?: boolean;
  seen?: boolean;
  tags?: CreateTaskTagDto[] | null;
  /**
   * @min 0
   * @example 120
   */
  timeLogged?: number;
  /** @format date-time */
  deadline?: string | null;
  /** @format uuid */
  subauditId?: string | null;
  /** @format uuid */
  followUpParentTaskId?: string | null;
  /** @format uuid */
  projectId?: string | null;
  /** @format uuid */
  ticketId?: string | null;
  /** @minLength 1 */
  title?: string | null;
  description?: string | null;
  referenceLink?: string | null;
  referenceName?: string | null;
  organizationId?: string | null;
  /** The ID of the vendor organization to associate with the task */
  vendorId?: string | null;
}

export type DeleteResult = object;

export interface ImportTasksDto {
  /**
   * The excel to upload
   * @format binary
   */
  file: File;
}

export interface TaskVersionChangeRecordDto {
  prevValue: string;
  newValue: string;
  fieldName: TaskVersionChangeRecordFields;
}

export interface TaskVersionChangelogItemDto {
  /** The ID of the version after the changes. Might be useful in the future for reverting to previous versions. */
  afterChangesVersionId: string;
  modifiedBy: PlainExternalUserDto;
  /** @format date-time */
  modifiedAt: string;
  action: AuditingAction;
  /** The ID of the parent entity. */
  parent: string;
  /** The type of the entity. Usually the name of the entity. */
  type: ChangelogEntityType;
  /** String that helps represent the entity in the UI. */
  display: string;
  /** The changes made to the entity. */
  changes: TaskVersionChangeRecordDto[];
}

export interface TaskVersionChangelogList {
  /** Array of items */
  items: TaskVersionChangelogItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface SubtaskVersionChangeRecordDto {
  prevValue: string;
  newValue: string;
  fieldName: SubtaskVersionChangeRecordFields;
}

export interface SubtaskVersionChangelogItemDto {
  /** The ID of the version after the changes. Might be useful in the future for reverting to previous versions. */
  afterChangesVersionId: string;
  modifiedBy: PlainExternalUserDto;
  /** @format date-time */
  modifiedAt: string;
  action: AuditingAction;
  /** The ID of the parent entity. */
  parent: string;
  /** The type of the entity. Usually the name of the entity. */
  type: ChangelogEntityType;
  /** String that helps represent the entity in the UI. */
  display: string;
  /** The changes made to the entity. */
  changes: SubtaskVersionChangeRecordDto[];
}

export interface SubtaskVersionChangelogList {
  /** Array of items */
  items: SubtaskVersionChangelogItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface TaskTagVersionChangeRecordDto {
  prevValue: string;
  newValue: string;
  fieldName: TaskTagVersionChangeRecordFields;
}

export interface TaskTagVersionChangelogItemDto {
  /** The ID of the version after the changes. Might be useful in the future for reverting to previous versions. */
  afterChangesVersionId: string;
  modifiedBy: PlainExternalUserDto;
  /** @format date-time */
  modifiedAt: string;
  action: AuditingAction;
  /** The ID of the parent entity. */
  parent: string;
  /** The type of the entity. Usually the name of the entity. */
  type: ChangelogEntityType;
  /** String that helps represent the entity in the UI. */
  display: string;
  /** The changes made to the entity. */
  changes: TaskTagVersionChangeRecordDto[];
}

export interface TaskTagVersionChangelogList {
  /** Array of items */
  items: TaskTagVersionChangelogItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface DelegateDto {
  /** Delegate user email if set */
  email?: string;
  /** Delegate user name if set */
  fullName?: string;
  /** Delegate user ID if set */
  id: string | null;
}

export interface UserSettingsResponseDto {
  /** User ID */
  userId: string;
  /** Delegate settings */
  delegate: DelegateDto;
  /** Additional email address for notifications */
  additionalEmail?: string | null;
}

export interface UpdateUserSettingsDto {
  /**
   * Additional email address for notifications. Set to null to disable.
   * @format email
   * @example "delegate@aboutsib.com"
   */
  additionalEmail?: string | null;
  /** ID of the user to delegate to. Set to null to disable delegation. */
  delegateId?: string | null;
}

export interface CreateSubtaskDto {
  /**
   * Title of the subtask, providing a short summary of what needs to be done
   * @maxLength 64
   * @example "Write project documentation"
   */
  title: string;
  /**
   * Detailed description of the subtask, outlining specific requirements or instructions
   * @maxLength 256
   * @example "Document all key features and user stories for the project"
   */
  description?: string | null;
  /**
   * Priority level of the subtask, indicating its importance relative to other tasks
   * @example "high"
   */
  priorityLevel?: PriorityLevel;
  /**
   * UUID of the task to which this subtask belongs, linking it to a parent task
   * @format uuid
   * @example "c56a4180-65aa-42ec-a945-5fd21dec0538"
   */
  taskUuid?: string;
}

export interface SubtaskDto {
  /**
   * Unique identifier for the Subtask
   * @example "c56a4180-65aa-42ec-a945-5fd21dec0538"
   */
  uuid: string;
  /**
   * Title of the subtask
   * @example "Complete project documentation"
   */
  title: string;
  /**
   * Description of the subtask
   * @example "Finish writing the project documentation by end of the day"
   */
  description?: string | null;
  /**
   * Subtask completion status
   * @example false
   */
  completed: boolean;
  /**
   * Date when the task was created
   * @format date-time
   * @example "2023-01-01T12:00:00Z"
   */
  createdAt: string;
  /**
   * Date when the task was last updated
   * @format date-time
   * @example "2023-01-02T15:30:00Z"
   */
  updatedAt: string;
  /** Priority of the subtask */
  priorityLevel: PriorityLevel;
  /** @format uuid */
  taskUuid: string;
}

export interface SubtaskListDto {
  /** Array of items */
  items: SubtaskDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface UpdateSubtaskDto {
  /**
   * Title of the subtask, providing a short summary of what needs to be done
   * @minLength 1
   * @maxLength 64
   * @example "Write project documentation"
   */
  title?: string | null;
  /**
   * Detailed description of the subtask, outlining specific requirements or instructions
   * @maxLength 256
   * @example "Document all key features and user stories for the project"
   */
  description?: string | null;
  /**
   * Priority level of the subtask, indicating its importance relative to other tasks
   * @example "high"
   */
  priorityLevel?: PriorityLevel;
  /** Defines if subtask was finished */
  completed?: boolean;
}

export interface TeamUserDto {
  id: string;
  name: string;
  email: string;
  avatarUrl: string | null;
  deletedAt: string | null;
  /** Whether the user can be removed from this team */
  isRemovable: boolean | null;
}

export interface TeamDto {
  /** @format uuid */
  uuid: string;
  name: string;
  activeTaskCount?: number;
  allTaskCount?: number;
  userCount: number;
  /** @format uuid */
  createdBy: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** For list To populate this field you need to pass query parameter "withUsers=true" */
  users?: TeamUserDto[] | null;
  canEdit?: boolean;
  description: string | null;
  subtitle: string | null;
  teamLogo: string | null;
}

export interface TeamListDto {
  /** Array of items */
  items: TeamDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface TeamMemberDto {
  id: string;
  name: string;
  email: string;
  teamRole: string;
  activeTaskCount: number;
  overdueTaskCount: number;
  avatarUrl: string | null;
  deletedAt: string | null;
}

export interface TeamMemberListDto {
  /** Array of items */
  items: TeamMemberDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface TeamTaskCountDto {
  dueToday: number;
  overdue: number;
  upcoming: number;
  past: number;
}

export interface UpdateTeamMembersDto {
  /** @uniqueItems true */
  userIds: string[];
}

export interface UpdateTeamMembersResponseDto {
  added: string[];
  removed: string[];
  total: number;
}

export interface CreateContactDto {
  name: string;
  /** @format email */
  email: string;
  vendorId: string;
  organizationId?: string | null;
  phone?: string;
  firstName?: string;
  lastName?: string;
  title?: string;
  note?: string | null;
  isActive?: boolean;
}

export interface UpdateContactDto {
  name?: string;
  /** @format email */
  email?: string;
  vendorId?: string;
  phone?: string;
  firstName?: string;
  lastName?: string;
  title?: string;
  note?: string | null;
  isActive?: boolean;
}

export interface PlainDto {
  id: string;
  name: string;
}

export interface VendorAccountDto {
  id: string;
  vendor: PlainDto;
  accountNumber: string;
  name?: string | null;
  note?: string | null;
  invoiceFrequency?: InvoiceFrequency | null;
  serviceType?: string | null;
  summaryAccountNumber?: string | null;
  glCode?: string | null;
  customGlField?: string | null;
  glAllocations?: string | null;
  usageLimit?: number | null;
  dollarLimit?: number | null;
  paymentTerms?: number | null;
  invoiceDay?: number | null;
  billingType?: BillingType | null;
  portalLoginEmailId?: string | null;
  status: VendorAccountStatus;
  /** Number of audits linked to this vendor account. */
  auditsCount: number;
  /** Names of spend categories linked to this vendor account. */
  spendCategories: string[];
  /** Locations assigned to this vendor account. */
  locations: PlainDto[];
  /** Whether the vendor account was attached from the organization vendor accounts list. Only present in audit context. */
  attachedFromVendorAccountsList?: boolean;
  /** Whether the vendor account is linked to this audit (picker). */
  linkedToThisAudit?: boolean;
}

export interface VendorAccountListDto {
  /** Array of items */
  items: VendorAccountDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateVendorAccountDto {
  /** Vendor account number for bill pay. */
  accountNumber?: string;
  name?: string | null;
  note?: string | null;
  invoiceFrequency?: InvoiceFrequency | null;
  serviceType?: string | null;
  summaryAccountNumber?: string | null;
  glCode?: string | null;
  customGlField?: string | null;
  glAllocations?: string | null;
  /** @min 0 */
  usageLimit?: number | null;
  /** @min 0 */
  dollarLimit?: number | null;
  /** @min 0 */
  paymentTerms?: number | null;
  /**
   * @min 1
   * @max 31
   */
  invoiceDay?: number | null;
  billingType?: BillingType | null;
  portalLoginEmailId?: string | null;
  /** @default "active" */
  status?: VendorAccountStatus;
  /** Vendor organization id for the new account. */
  vendorId: string;
  /** IDs of spend categories to associate with this vendor account. */
  spendCategoryIds?: string[];
  /**
   * When set, links the new vendor account to this audit with attachedFromVendorAccountsList=false.
   * @format uuid
   */
  auditId?: string;
  /**
   * IDs of locations to assign to this vendor account.
   * @uniqueItems true
   */
  locationIds?: string[];
}

export interface UpdateVendorAccountDto {
  accountNumber?: string;
  name?: string | null;
  note?: string | null;
  invoiceFrequency?: InvoiceFrequency | null;
  serviceType?: string | null;
  summaryAccountNumber?: string | null;
  glCode?: string | null;
  customGlField?: string | null;
  glAllocations?: string | null;
  /** @min 0 */
  usageLimit?: number | null;
  /** @min 0 */
  dollarLimit?: number | null;
  /** @min 0 */
  paymentTerms?: number | null;
  /**
   * @min 1
   * @max 31
   */
  invoiceDay?: number | null;
  billingType?: BillingType | null;
  portalLoginEmailId?: string | null;
  /** @default "active" */
  status?: VendorAccountStatus;
  /** Vendor organization id to reassign the account to for this organization. */
  vendorId?: string;
  /** Spend category IDs to link to this vendor account. */
  addSpendCategoryIds?: string[];
  /** Spend category IDs to unlink from this vendor account. */
  removeSpendCategoryIds?: string[];
  /**
   * Location IDs to assign to this vendor account.
   * @uniqueItems true
   */
  addLocationIds?: string[];
  /**
   * Location IDs to unassign from this vendor account.
   * @uniqueItems true
   */
  removeLocationIds?: string[];
}

export interface AuditWithSpendAndSavingsDto {
  /**
   * Unique identifier for the audit
   * @example "a09VX000006yT8uYAE"
   */
  id: string;
  /**
   * Audit stage
   * @example "Audit Complete - Finalized Savings"
   */
  auditStage: string;
  /**
   * Audit type
   * @example "Waste - Solid / Recycling / Compost"
   */
  auditType: string;
  /**
   * Annual spend for the audit
   * @example 166381
   */
  auditAnnualSpend: number;
  /**
   * Annual inscope spend for the audit
   * @example 166381
   */
  annualInscopeSpend: number;
  /**
   * Monthly savings identified for the audit
   * @example 2965.56
   */
  monthlySavingsIdentified: number;
  /**
   * Monthly savings approved for the audit
   * @example 2965.56
   */
  monthlySavingsApproved: number;
  /**
   * Annual savings identified for the audit
   * @example 35586.72
   */
  annualSavingsIdentified: number;
  /**
   * Annual savings approved for the audit
   * @example 35586.72
   */
  annualSavingsApproved: number;
  /**
   * Percentage of savings identified against annual spend
   * @example 21.39
   */
  savingsPercentageIdentified: number;
  /**
   * Percentage of savings approved against annual spend
   * @example 21.39
   */
  savingsPercentageApproved: number;
  /**
   * Opportunity count for the audit
   * @example 2
   */
  opportunityCount: number;
  /**
   * Contract length for the audit
   * @example 36
   */
  contractLength: number;
  /**
   * Annual spend analysis complete for the audit
   * @example 166381
   */
  annualSpendAnalysisComplete: number;
  /**
   * Annual spend analysis in progress for the audit
   * @example 0
   */
  annualSpendAnalysisInProgress: number;
  /**
   * Normalized name for the audit type
   * @example "Waste - Solid / Recycling / Compost"
   */
  normalizedName: string;
}

export interface SavingsDto {
  /**
   * Savings value in dollars
   * @example 214943.4
   */
  value: number;
  /**
   * Savings percentage
   * @example 36.97
   */
  percentage: number;
}

export interface SpendAreasSavingsSpendItemTotalsDto {
  /**
   * Annual spend in dollars for the category
   * @example 166381
   */
  annualSpendAnalysisComplete: number;
  /**
   * Spend currently in progress for analysis
   * @example 0
   */
  annualSpendAnalysisInProgress: number;
  /**
   * Spend in scope for the category
   * @example 166381
   */
  inscopeSpend: number;
  /** Savings identified for the category */
  savingsIdentified: SavingsDto;
  /** Savings approved for the category */
  savingsApproved: SavingsDto;
}

export interface SpendAreasSavingsSpendItemDto {
  /**
   * SpendArea name
   * @example "Waste"
   */
  spendArea: string;
  /**
   * Unique identifier for the Spend area
   * @example ""
   */
  id: string;
  /**
   * Description for the Spend Area
   * @example ""
   */
  description: string;
  /** List of audits related to the Spend Area */
  audits: AuditWithSpendAndSavingsDto[];
  /** Total values for the Spend Area */
  totals: SpendAreasSavingsSpendItemTotalsDto;
}

export interface SpendAreasSavingsSpendTotalsDto {
  /**
   * Total annual spend in dollars
   * @example 581414
   */
  annualSpendAnalysisComplete: number;
  /**
   * Total spend currently in progress for analysis
   * @example 5619481
   */
  annualSpendAnalysisInProgress: number;
  /**
   * Total spend in scope
   * @example 6200895
   */
  inscopeSpend: number;
  /** Total savings identified */
  savingsIdentified: SavingsDto;
  /** Total savings approved */
  savingsApproved: SavingsDto;
}

export interface SpendAreasSavingsSpendResponseDto {
  /** List of spend areas with their audit details */
  spendAreas: SpendAreasSavingsSpendItemDto[];
  /** Aggregated totals for all spend areas */
  totals: SpendAreasSavingsSpendTotalsDto;
}

export interface TotalSavingsDto {
  /**
   * Annual savings value in dollars
   * @example 2559.12
   */
  annualSaving: number;
  /**
   * Monthly savings value in dollars
   * @example 213
   */
  monthlySaving: number;
  /**
   * Savings percentage
   * @example 1.42
   */
  percentage: number;
}

export interface AnnualSavingsDto {
  /**
   * Annual savings value in dollars
   * @example 2559.12
   */
  value: number;
  /**
   * Savings percentage
   * @example 100
   */
  percentage: number;
}

export interface AnnualSavingsForSpendAreaSpendCategoryDto {
  /**
   * Spend category name
   * @example "Maintenance - Elevator / Escalator"
   */
  name: string;
  /** Annual savings details for the category */
  annualSavings: AnnualSavingsDto;
}

export interface SpendAndAnalysisSpendAreaDto {
  /**
   * Spend area name
   * @example "Maintenance"
   */
  name: string;
  /**
   * Flag indicating if savings are made in this area
   * @example true
   */
  areSavingsMade: boolean;
  /** Total savings details for the spend area */
  totalSavings: TotalSavingsDto;
  /** List of spend categories within this spend area */
  spendCategories: AnnualSavingsForSpendAreaSpendCategoryDto[];
}

export interface AnnualSavingsForSpendAreaResponseDto {
  /** List of spend areas and their details */
  items: SpendAndAnalysisSpendAreaDto[];
}

export interface VectorClientInfoDto {
  clientId: number | null;
  clientName: string | null;
  oldCost: number | null;
  newCostNegotiated: number | null;
  newCostContracted: number | null;
  grossSavings: number | null;
  clientNo: string | null;
  clientLegalName: string | null;
  contractVersion: string | null;
  managementFee: number | null;
  discountPercentage: number | null;
  clientStatus: string | null;
  vertical: string | null;
  currency: string | null;
  zeroToThirty: number | null;
  thirtyOneToSixty: number | null;
  sixtyOneToNinety: number | null;
  ninetyPlus: number | null;
  termMonths: number | null;
  autoPay: boolean | null;
  unPaidInvoiceCount: number | null;
}

export interface FinancialDetailsDto {
  annual: number;
  monthly: number;
  totalLifetime: number;
}

export interface SavingSummaryResponseDto {
  spend: FinancialDetailsDto;
  saving: FinancialDetailsDto;
  percentSaved: number;
  moreThanYearOfSavings: boolean;
  spendAreasCount: number;
  assignedSpendAreasCount: number;
}

export interface SpendCategorySummaryDto {
  spend: FinancialDetailsDto;
  savingsApproved: FinancialDetailsDto;
  savingsIdentified: FinancialDetailsDto;
  approvedPercentSaved: number;
  identifiedPercentSaved: number;
}

export interface SpendCategoryDto {
  id: string;
  name: string;
  summary: SpendCategorySummaryDto;
}

export interface SpendAreaCategoryVideoDto {
  /** Display label shown in SpendBrain when this category video is expanded */
  categorySpendbrainTitle: string;
  /** @format uri */
  videoUrl: string;
  spendCategoryId?: string;
}

export interface SpendAreaDto {
  id: string;
  spendArea: string;
  description: string;
  spendCategory: SpendCategoryDto[];
  stage: SpendAreaStage[];
  status: SpendAreaStatus;
  summary: SpendCategorySummaryDto;
  categoryVideos?: SpendAreaCategoryVideoDto[];
}

export interface SpendAreaDetailsDto {
  items: SpendAreaDto[];
}

export interface SavingsValueDto {
  /** @example 214943.4 */
  value: number;
  /** @example 36.97 */
  percentage: number;
}

export interface SpendAreasOverviewItemTotalsDto {
  /** @example 166381 */
  annualSpendAnalysisComplete: number;
  /** @example 0 */
  annualSpendAnalysisInProgress: number;
  /** @example 166381 */
  inscopeSpend: number;
  savingsIdentified: SavingsValueDto;
  savingsApproved: SavingsValueDto;
}

export interface SpendAreaSpendCategoryItemDto {
  id: string;
  name: string;
  totals: SpendAreasOverviewItemTotalsDto;
}

export interface SpendAreasOverviewItemDto {
  id: string;
  /** @example "Waste" */
  spendArea: string;
  description: string;
  spendCategories: SpendAreaSpendCategoryItemDto[];
  totals: SpendAreasOverviewItemTotalsDto;
}

export interface SpendAreasOverviewTotalsDto {
  /** @example 166381 */
  annualSpendAnalysisComplete: number;
  /** @example 0 */
  annualSpendAnalysisInProgress: number;
  /** @example 166381 */
  inscopeSpend: number;
  savingsIdentified: SavingsValueDto;
  savingsApproved: SavingsValueDto;
}

export interface SpendAreasOverviewResponseDto {
  spendAreas: SpendAreasOverviewItemDto[];
  totals: SpendAreasOverviewTotalsDto;
}

export interface AnnualSavingsTotalsDto {
  /** @example 2559.12 */
  annualSaving: number;
  /** @example 213 */
  monthlySaving: number;
  /**
   * Percentage of global total annual savings
   * @example 1.42
   */
  percentage: number;
}

export interface AnnualSavingsValueDto {
  /** @example 2559.12 */
  value: number;
  /**
   * Percentage within the spend area
   * @example 100
   */
  percentage: number;
}

export interface AnnualSavingsBreakdownSpendCategoryDto {
  /** @example "Maintenance - Elevator / Escalator" */
  name: string;
  annualSavings: AnnualSavingsValueDto;
}

export interface AnnualSavingsBreakdownItemDto {
  /** @example "Maintenance" */
  name: string;
  /** @example true */
  areSavingsMade: boolean;
  totalSavings: AnnualSavingsTotalsDto;
  spendCategories: AnnualSavingsBreakdownSpendCategoryDto[];
}

export interface AnnualSavingsBreakdownResponseDto {
  items: AnnualSavingsBreakdownItemDto[];
}

export interface VectorClientInfoItemDto {
  clientId: number | null;
  clientName: string | null;
  oldCost: number | null;
  newCostNegotiated: number | null;
  newCostContracted: number | null;
  grossSavings: number | null;
  clientNo: string | null;
  clientLegalName: string | null;
  contractVersion: string | null;
  managementFee: number | null;
  discountPercentage: number | null;
  clientStatus: string | null;
  vertical: string | null;
  currency: string | null;
  zeroToThirty: number | null;
  thirtyOneToSixty: number | null;
  sixtyOneToNinety: number | null;
  ninetyPlus: number | null;
  termMonths: number | null;
  autoPay: boolean | null;
  unPaidInvoiceCount: number | null;
  totalDues: number | null;
  savingsIdentified: number | null;
  analysisInProgress: number | null;
  analysisComplete: number | null;
}

export interface VectorClientInfoResponseDto {
  items: VectorClientInfoItemDto[];
}

export interface SpendAreaListItemDto {
  id: string;
  name: string;
  description: string | null;
  status: SpendAreaStatus;
}

export interface SpendAreasListResponseDto {
  items: SpendAreaListItemDto[];
  assignedCount: number;
  requestedCount: number;
  notAssignedCount: number;
}

export interface TicketFileDto {
  id: string;
  fileName: string;
  fileType?: string;
  fileUrl: string;
  showInDocumentsRepo: boolean;
  fileSize?: number;
}

export interface TicketFileListDto {
  /** Array of items */
  items: TicketFileDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface ProjectFileDto {
  id: string;
  fileName: string;
  fileType?: string | null;
  /** @format uri */
  fileUrl: string;
  fileSize?: number | null;
  createdAt: string;
  createdBy?: PlainExternalUserDto | null;
  uploadStage: DocumentUploadStage;
}

export interface ProjectFileListDto {
  /** Array of items */
  items: ProjectFileDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface FileBatchStatusDto {
  id: string;
  filename: string;
  uploadStage: DocumentUploadStage;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface FileBatchStatusListDto {
  items: FileBatchStatusDto[];
}

export interface GenerateFileUploadUrlDto {
  filename: string;
  mimeType: string;
  filesize: number;
}

export interface GenerateBulkFileUploadUrlDto {
  /** @minItems 1 */
  files: GenerateFileUploadUrlDto[];
}

export interface FileBulkUploadUrlFileDto {
  filename: string;
  fileId: string | null;
  uploadUrl: string | null;
  /** Error message if file preparation failed */
  error?: string | null;
}

export interface FileBulkUploadUrlResponseDto {
  /** Unique identifier for this upload batch */
  batchId: string;
  files: FileBulkUploadUrlFileDto[];
}

export interface UploadFileDto {
  /** @format binary */
  file: File;
}

export interface FileUploadResultDto {
  id: string;
  fileName: string;
  fileType?: string;
  fileSize?: number;
  uploadStage: DocumentUploadStage;
  createdAt: string;
}

export interface PostprocessFileDto {
  filename: string;
}

export interface PostprocessFilesDto {
  /** Batch ID to postprocess */
  batchId?: string;
  successfulFilenames: string[];
  failedFilenames: string[];
}

export interface PostprocessFilesResultDto {
  items: FileUploadResultDto[];
}

export interface CreateProjectDto {
  name: string;
  /** @format uuid */
  teamId: string;
  projectStatus?: CreateProjectDtoProjectStatusEnum;
  startDate?: string;
  targetEndDate?: string;
  /** @format uuid */
  assigneeId?: string;
}

export interface PlainTeamDto {
  id: string;
  name: string;
}

export interface ProjectDto {
  id: string;
  name: string;
  projectStatus: ProjectStatus;
  team: PlainTeamDto;
  owner: PlainExternalUserDto;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  startDate?: string | null;
  /** @format date-time */
  targetEndDate?: string | null;
  assignee?: PlainExternalUserDto | null;
}

export interface ProjectInTeamSummaryDto {
  id: string;
  name: string;
  projectStatus: ProjectStatus;
  owner: PlainExternalUserDto;
  /** @format date-time */
  startDate?: string | null;
  /** @format date-time */
  targetEndDate?: string | null;
}

export interface TeamWithProjectsDto {
  id: string;
  name: string;
  projectsCount: number;
  projects: ProjectInTeamSummaryDto[];
}

export interface TeamWithProjectsListDto {
  items: TeamWithProjectsDto[];
}

export interface UpdateProjectDto {
  name?: string;
  /** @format uuid */
  teamId?: string;
  projectStatus?: UpdateProjectDtoProjectStatusEnum;
  startDate?: string;
  targetEndDate?: string;
  /** @format uuid */
  assigneeId?: string;
  /** @format uuid */
  ownerId?: string;
}

export interface FileDto {
  id: string;
  fileName: string;
  fileType?: string | null;
  /** @format uri */
  fileUrl: string;
  fileSize?: number | null;
  createdAt: string;
  createdBy?: PlainExternalUserDto | null;
  uploadStage: DocumentUploadStage;
}

export interface FileListDto {
  /** Array of items */
  items: FileDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface PlainOrganizationDto {
  id: string;
  name: string;
}

export interface TicketVendorDto {
  id: string;
  name: string;
}

export interface TicketDto {
  id: string;
  ticketNumber?: string | null;
  vectorTicketId?: number | null;
  clientId?: string | null;
  subject: string;
  description?: string | null;
  status?: TicketStatus | null;
  priority?: PriorityLevel | null;
  category?: TicketCategory | null;
  vendorName?: string | null;
  location?: string | null;
  requestor?: PlainExternalUserDto | null;
  assignee?: PlainExternalUserDto | null;
  /** @format date-time */
  dueDate?: string | null;
  /** @format date-time */
  followUpDate?: string | null;
  contractVersion?: string | null;
  accessToExternalUser?: boolean | null;
  locationId?: string | null;
  locationName?: string | null;
  zip?: string | null;
  state?: string | null;
  address?: string | null;
  city?: string | null;
  subStatus?: string | null;
  updatedBy?: string | null;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  receiveEmailNotifications?: boolean | null;
  organization?: PlainOrganizationDto | null;
  vendor?: TicketVendorDto | null;
  participants?: PlainExternalUserDto[] | null;
  savingsAmount?: number | null;
  project?: string | null;
}

export interface TicketListDto {
  /** Array of items */
  items: TicketDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface UpdateTicketDto {
  /** @maxLength 256 */
  subject?: string;
  /** @maxLength 1024 */
  description?: string;
  status?: TicketStatus;
  priority?: PriorityLevel;
  category?: TicketCategory;
  /**
   * Supported formats: image/jpeg, image/png, image/webp, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/pdf, text/csv, text/plain, message/rfc822, application/vnd.ms-outlook, application/octet-stream, video/webm, video/mp4, video/quicktime, audio/mpeg files. Max size: 200MB. Max count: 10 files.
   * @maxItems 10
   * @default null
   */
  files?: File[] | null;
  /**
   * Show in Documents Repository for each file (must match files array length)
   * @maxItems 10
   * @default null
   */
  showInDocumentsRepo?: boolean[] | null;
  /** @default null */
  receiveEmailNotifications?: boolean | null;
  /**
   * If true, ticket is external (accessible to clients). If false, ticket is internal.
   * @default null
   */
  accessToExternalUser?: boolean | null;
  assigneeId?: string;
  /** @format uuid */
  projectId?: string;
  /** The ID of the vendor organization to associate with the ticket */
  vendorId?: string | null;
  /**
   * Array of user IDs to set as participants
   * @uniqueItems true
   */
  participantIds?: string[];
  /**
   * Savings amount (only visible when category is Finance, Invoice, or Payments). For non-vector tickets only.
   * @min 0
   * @default null
   */
  savingsAmount?: number | null;
  /**
   * Due date of the ticket
   * @format date-time
   */
  dueDate?: string | null;
  /**
   * @maxLength 255
   * @default null
   */
  city?: string | null;
  /**
   * @maxLength 255
   * @default null
   */
  state?: string | null;
  /**
   * @maxLength 255
   * @default null
   */
  address?: string | null;
  /**
   * @maxLength 255
   * @default null
   */
  zip?: string | null;
  /**
   * Array of file IDs to remove from the ticket
   * @uniqueItems true
   */
  filesToDelete?: string[];
  /**
   * IDs of files to move FROM the ticket TO the Documents Repository
   * @uniqueItems true
   */
  filesToMoveToDocumentsRepo?: string[];
  /**
   * IDs of files to remove FROM the Documents Repository back TO the ticket
   * @uniqueItems true
   */
  filesToRemoveFromDocumentsRepo?: string[];
  /** Client organisation (optional). When creating from the vendor portal, set to link a client; omit for vendor-only tickets. On POST /organization/:organizationId/tickets this value is ignored — the URL segment is used. */
  organizationId?: string;
}

export interface CreateTicketCommentDto {
  text: string;
  /** @default "external" */
  scope?: TicketCommentScope;
  /**
   * List of external users IDs to notify
   * @uniqueItems true
   */
  notifyUsers?: string[];
}

export interface CreateTicketCommentResponseDto {
  message: string;
}

export interface TicketCommentDto {
  id: string;
  source: TicketCommentDtoSourceEnum;
  comment: string;
  /** @default "external" */
  scope?: TicketCommentScope;
  createdBy: PlainExternalUserDto;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface TicketCommentListDto {
  /** Array of items */
  items: TicketCommentDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface OrganizationPrimaryContactDto {
  id: string;
  name: string;
  email?: string | null;
}

export interface OrganizationFinancialMetricsDto {
  /** Total in-scope spend in dollars */
  inScopeSpend: number;
  /** Savings identified in dollars */
  savingsIdentified: number;
  /** Savings approved in dollars */
  savingsApproved: number;
}

export interface OrganizationListItemDto {
  id: string;
  name: string;
  status: OrganizationStatus;
  clientStatus?: ClientStatus | null;
  /** Whether the client status is considered active */
  isActive?: boolean | null;
  primaryContact?: OrganizationPrimaryContactDto | null;
  /** Number of locations */
  locationsCount: number;
  financialMetrics: OrganizationFinancialMetricsDto;
  /** Number of open audits */
  openAuditsCount: number;
  parentOrganization?: PlainOrganizationDto | null;
}

export interface OrganizationListDto {
  /** Array of items */
  items: OrganizationListItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface OrganizationOverviewDto {
  id: string;
  name: string;
  clientStatus?: ClientStatus | null;
  /** Whether the client status is considered active */
  isActive?: boolean | null;
  totalInscopeSpend: number;
  totalSavingsIdentified: number;
  totalSavingsApproved: number;
  logo?: OrganizationLogoDto | null;
  mainPointOfContact?: ContactDto | null;
  parentOrganization?: PlainOrganizationDto | null;
  subsidiaryOrganizations: PlainOrganizationDto[];
  billingAddressDetails?: string | null;
  mailingAddressDetails?: string | null;
  billPayFundingFrequency?: BillPayFundingFrequency | null;
  fundingDetailsSubmissionMethod?: FundingDetailsSubmissionMethod | null;
  /** @format uuid */
  assignedBpos?: string | null;
  permissions?: Record<string, PermissionAction> | null;
}

export interface CreateOrganizationDto {
  name: string;
  status: OrganizationStatus;
  clientStatus?: ClientStatus | null;
  /**
   * ID of the primary contact
   * @format uuid
   */
  primaryContactId?: string | null;
  /**
   * ID of the parent organization
   * @format uuid
   */
  parentOrganizationId?: string | null;
}

export interface UpdateOrganizationDto {
  clientStatus?: ClientStatus | null;
  aiBrandingAlias?: string | null;
  /**
   * ID of the main point of contact
   * @format uuid
   */
  mainPointOfContactId?: string | null;
  /** @format uuid */
  assignedBpos?: string | null;
  mailingAddressDetails?: string | null;
  billingAddressDetails?: string | null;
  billPayFundingFrequency?: BillPayFundingFrequency | null;
  fundingDetailsSubmissionMethod?: FundingDetailsSubmissionMethod | null;
  /**
   * Vendor IDs to link to this client organization.
   * @uniqueItems true
   */
  addVendorIds?: string[];
  /**
   * Vendor IDs to unlink from this client organization. Unlinking removes the vendor–organization relationship and permanently deletes all related vendor accounts (database ON DELETE CASCADE).
   * @uniqueItems true
   */
  removeVendorIds?: string[];
}

export interface VendorDetailSummaryDto {
  contractsCount: number;
  /** US dollars */
  totalSpend: number;
  clientOrganisationsCount: number;
  /** Open ticket count (`ticket.vendor_id` = vendor org): excludes status closed, canceled, completed; NULL status counts as open. */
  openTicketsCount: number;
  /** Open task count (`task.vendor_id` = vendor org): `completed` false and `deleted_at` IS NULL. */
  openTasksCount: number;
  /** Count of audits where `audit.vendor` references this vendor organization. */
  auditsCount: number;
  /** Count of `contact` rows with `organization_id` set to this vendor organization. */
  contactsCount: number;
}

export interface VendorClientListItemDto {
  id: string;
  name: string;
  /** Spend categories from `vendor_spend_category` → `spend_category`. */
  spendCategories: SpendCategoryListItemDto[];
  /** Spend area names from linked `spend_category` → `spend_area`. */
  spendAreas: string[];
  /** Vendor lifecycle status from the `vendor_status` column. */
  status: VendorStatus;
  /** ISO 8601 */
  lastUpdated: string;
  summary: VendorDetailSummaryDto;
  /** Vendor account numbers for this organization–vendor relationship. */
  vendorAccounts: string[];
}

export interface VendorClientListDto {
  /** Array of items */
  items: VendorClientListItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface IpOrganizationTaskDto {
  id: string;
  completed: boolean;
  title: string;
  description?: string | null;
  category: TaskCategory;
  assignee?: PlainExternalUserDto | null;
  /** @format date-time */
  deadline?: string | null;
  priorityLevel: PriorityLevel;
  referenceName?: string | null;
  ticketId?: string | null;
  ticketNumber?: string | null;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface IpOrganizationTaskListDto {
  /** Array of items */
  items: IpOrganizationTaskDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface IpOrganizationTicketDto {
  id: string;
  ticketNumber: string;
  status?: TicketStatus | null;
  subject: string;
  priority?: PriorityLevel | null;
  assignee?: PlainExternalUserDto | null;
  category?: TicketCategory | null;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface IpOrganizationTicketListDto {
  /** Array of items */
  items: IpOrganizationTicketDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface VendorListItemDto {
  id: string;
  name: string;
  /** Spend categories from `vendor_spend_category` → `spend_category`. */
  spendCategories: SpendCategoryListItemDto[];
  /** Spend area names from linked `spend_category` → `spend_area`. */
  spendAreas: string[];
  /** Vendor lifecycle status from the `vendor_status` column. */
  status: VendorStatus;
  /** ISO 8601 */
  lastUpdated: string;
  summary: VendorDetailSummaryDto;
}

export interface VendorListDto {
  /** Array of items */
  items: VendorListItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface VendorInformationDto {
  /** ISO 8601 */
  createdAt: string;
  /** @example "https://www.loremipsum.com" */
  websiteUrl: string;
  /** @example "https://www.portal.loremipsum.com" */
  portalUrl: string;
  /**
   * Billing address synced from Salesforce; UI may render line breaks.
   * @example "8016 Riverside Drive
   * Jackson Heights, NY 11372"
   */
  billingAddress: string;
  /**
   * Shipping address synced from Salesforce; UI may render line breaks.
   * @example "8016 Riverside Drive
   * Jackson Heights, NY 11372"
   */
  shippingAddress: string;
  /** Free-text vendor note. */
  note: string;
}

export interface VendorDetailDto {
  id: string;
  name: string;
  /** Spend categories from `vendor_spend_category` → `spend_category` (internal portal M2M). */
  spendCategories: SpendCategoryListItemDto[];
  /** Spend area names from M2M-linked `spend_category` → `spend_area` (read-only; not in create/update body). */
  spendAreas: string[];
  /** Vendor lifecycle status from the `vendor_status` column. */
  status: VendorStatus;
  /** ISO 8601 */
  lastUpdated: string;
  /** SIB assignee for this vendor (`external-user` linked on organization). */
  assignee?: PlainExternalUserDto | null;
  summary: VendorDetailSummaryDto;
  information: VendorInformationDto;
  emailInvoiceCapability?: boolean | null;
  ediApiInvoiceCapability?: boolean | null;
  paymentMethodCardAccepted?: boolean | null;
  /** @min 0 */
  cardFee?: number | null;
  paymentMethodAchAccepted?: boolean | null;
  paymentRemittanceEmail?: string | null;
  paymentRemittanceIdentifier?: PaymentRemittanceIdentifier | null;
  earlyPayDiscount?: boolean | null;
  paymentType?: BillPayPaymentType | null;
  /** Vendor W9 file (`vendor.w9_document_id` → `file`). */
  w9Document?: FileDto | null;
}

export interface VendorOrganizationSelectListDto {
  /** Array of items */
  items: SelectListItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface VendorClientDetailDto {
  id: string;
  name: string;
  /** Spend categories from `vendor_spend_category` → `spend_category` (internal portal M2M). */
  spendCategories: SpendCategoryListItemDto[];
  /** Spend area names from M2M-linked `spend_category` → `spend_area` (read-only; not in create/update body). */
  spendAreas: string[];
  /** Vendor lifecycle status from the `vendor_status` column. */
  status: VendorStatus;
  /** ISO 8601 */
  lastUpdated: string;
  /** SIB assignee for this vendor (`external-user` linked on organization). */
  assignee?: PlainExternalUserDto | null;
  summary: VendorDetailSummaryDto;
  information: VendorInformationDto;
  emailInvoiceCapability?: boolean | null;
  ediApiInvoiceCapability?: boolean | null;
  paymentMethodCardAccepted?: boolean | null;
  /** @min 0 */
  cardFee?: number | null;
  paymentMethodAchAccepted?: boolean | null;
  paymentRemittanceEmail?: string | null;
  paymentRemittanceIdentifier?: PaymentRemittanceIdentifier | null;
  earlyPayDiscount?: boolean | null;
  paymentType?: BillPayPaymentType | null;
  /** Vendor W9 file (`vendor.w9_document_id` → `file`). */
  w9Document?: FileDto | null;
  /** Count of client subsidiary organisations linked via parent, referral, or private-equity firm. */
  clientSubsidiaryOrganisationsCount: number;
  /** Vendor account numbers for this organization–vendor relationship. */
  vendorAccounts: string[];
}

export interface CreateVendorDto {
  name: string;
  vendorStatus: VendorStatus;
  portalUrl?: string;
  websiteUrl?: string;
  billingAddress?: string;
  shippingAddress?: string;
  note?: string;
  /**
   * ID of the external user to assign as vendor assignee.
   * @format uuid
   */
  assigneeId?: string | null;
  /**
   * IDs of spend categories to associate with this vendor (Payload `spend_category` id).
   * @minItems 1
   * @uniqueItems true
   */
  spendCategoryIds: string[];
  /**
   * IDs of client organizations to link to this vendor (vendor_client relationship).
   * @uniqueItems true
   */
  clientIds?: string[];
}

export interface UpdateVendorDto {
  name?: string;
  vendorStatus?: VendorStatus;
  portalUrl?: string;
  websiteUrl?: string;
  billingAddress?: string;
  shippingAddress?: string;
  note?: string;
  /**
   * ID of the external user to assign as vendor assignee.
   * @format uuid
   */
  assigneeId?: string | null;
  /**
   * IDs of spend categories to associate with this vendor (Payload `spend_category` id).
   * @minItems 1
   * @uniqueItems true
   */
  spendCategoryIds?: string[];
  emailInvoiceCapability?: boolean | null;
  ediApiInvoiceCapability?: boolean | null;
  paymentMethodCardAccepted?: boolean | null;
  /** @min 0 */
  cardFee?: number | null;
  paymentMethodAchAccepted?: boolean | null;
  paymentRemittanceEmail?: string | null;
  paymentRemittanceIdentifier?: PaymentRemittanceIdentifier | null;
  earlyPayDiscount?: boolean | null;
  paymentType?: BillPayPaymentType | null;
  /**
   * Client organization IDs to add to this vendor.
   * @uniqueItems true
   */
  addClientIds?: string[];
  /**
   * Client organization IDs to remove from this vendor. Unlinking removes the vendor–organization relationship and permanently deletes all related vendor accounts (database ON DELETE CASCADE).
   * @uniqueItems true
   */
  removeClientIds?: string[];
}

export interface FileUploadDto {
  /**
   * File to upload
   * @format binary
   */
  file: File;
}

export interface SpreadsheetRow {
  /** 1-based spreadsheet row number */
  row: number;
  data: object;
}

export interface SpreadsheetFieldError {
  /** DTO property name */
  field: string;
  /** Original spreadsheet column name */
  column: string;
  /** Validation error messages */
  messages: string[];
}

export interface SpreadsheetRowError {
  /** 1-based spreadsheet row number (2 = first data row, since row 1 is headers) */
  row: number;
  /** The mapped DTO that failed validation */
  data: object;
  errors: SpreadsheetFieldError[];
}

export interface VendorImportResultDto {
  isValid: boolean;
  /** Mapped DTOs that passed validation (with original row number) */
  validData: SpreadsheetRow[];
  /** Rows that failed validation (includes the DTO + error details) */
  invalidRows: SpreadsheetRowError[];
  totalRows: number;
}

export interface VendorCreateManyDto {
  items: CreateVendorDto[];
}

export interface UpdateVendorBillPayDto {
  /**
   * Vendor W9 file (.pdf, .doc). Upload a file part to add or replace. Send null to remove the existing W9.
   * @format binary
   */
  file?: File | null;
  /**
   * Optional; when provided, must match uploaded file bytes.
   * @min 1
   */
  filesize?: number;
  emailInvoiceCapability?: boolean | null;
  ediApiInvoiceCapability?: boolean | null;
  paymentMethodCardAccepted?: boolean | null;
  /** @min 0 */
  cardFee?: number | null;
  paymentMethodAchAccepted?: boolean | null;
  paymentRemittanceEmail?: string | null;
  paymentRemittanceIdentifier?: PaymentRemittanceIdentifier | null;
  earlyPayDiscount?: boolean | null;
  paymentType?: BillPayPaymentType | null;
}

export interface ContactsListDto {
  /** Array of items */
  items: ContactDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateTicketDto {
  /** @maxLength 256 */
  subject: string;
  /** @maxLength 1024 */
  description?: string;
  status?: TicketStatus;
  priority?: PriorityLevel;
  category?: TicketCategory;
  /**
   * Supported formats: image/jpeg, image/png, image/webp, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/pdf, text/csv, text/plain, message/rfc822, application/vnd.ms-outlook, application/octet-stream, video/webm, video/mp4, video/quicktime, audio/mpeg files. Max size: 200MB. Max count: 10 files.
   * @maxItems 10
   * @default null
   */
  files?: File[] | null;
  /**
   * Show in Documents Repository for each file (must match files array length)
   * @maxItems 10
   * @default null
   */
  showInDocumentsRepo?: boolean[] | null;
  /** @default null */
  receiveEmailNotifications?: boolean | null;
  /**
   * If true, ticket is external (accessible to clients). If false, ticket is internal.
   * @default null
   */
  accessToExternalUser?: boolean | null;
  assigneeId?: string;
  /** @format uuid */
  projectId?: string;
  /** The ID of the vendor organization to associate with the ticket */
  vendorId?: string | null;
  /**
   * Array of user IDs to set as participants
   * @uniqueItems true
   */
  participantIds?: string[];
  /**
   * Savings amount (only visible when category is Finance, Invoice, or Payments). For non-vector tickets only.
   * @min 0
   * @default null
   */
  savingsAmount?: number | null;
  /**
   * Due date of the ticket
   * @format date-time
   */
  dueDate?: string | null;
  /**
   * @maxLength 255
   * @default null
   */
  city?: string | null;
  /**
   * @maxLength 255
   * @default null
   */
  state?: string | null;
  /**
   * @maxLength 255
   * @default null
   */
  address?: string | null;
  /**
   * @maxLength 255
   * @default null
   */
  zip?: string | null;
  /** Client organisation (optional). When creating from the vendor portal, set to link a client; omit for vendor-only tickets. On POST /organization/:organizationId/tickets this value is ignored — the URL segment is used. */
  organizationId: string;
}

export interface TicketWithDetailsDto {
  id: string;
  ticketNumber?: string | null;
  vectorTicketId?: number | null;
  clientId?: string | null;
  subject: string;
  description?: string | null;
  status?: TicketStatus | null;
  priority?: PriorityLevel | null;
  category?: TicketCategory | null;
  vendorName?: string | null;
  location?: string | null;
  requestor?: PlainExternalUserDto | null;
  assignee?: PlainExternalUserDto | null;
  /** @format date-time */
  dueDate?: string | null;
  /** @format date-time */
  followUpDate?: string | null;
  contractVersion?: string | null;
  accessToExternalUser?: boolean | null;
  locationId?: string | null;
  locationName?: string | null;
  zip?: string | null;
  state?: string | null;
  address?: string | null;
  city?: string | null;
  subStatus?: string | null;
  updatedBy?: string | null;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  receiveEmailNotifications?: boolean | null;
  organization?: PlainOrganizationDto | null;
  vendor?: TicketVendorDto | null;
  participants?: PlainExternalUserDto[] | null;
  savingsAmount?: number | null;
  project?: string | null;
  documents?: TicketFileDto[];
  comments?: TicketCommentDto[];
}

export interface LocationItemDto {
  id: string;
  displayName?: string | null;
  mainPointOfContact?: ContactDto | null;
  status?: LocationStatus | null;
  spendAreas: string[];
  stages: string;
  savings: number;
  documentFieldStatus?: DocumentFieldStatus | null;
  activeAudits: number;
  isMissingRow: boolean;
  squareFootage?: number | null;
  weatherStation?: string | null;
  hoursOfOperation?: string | null;
  units?: number | null;
  name: string | null;
  address: string | null;
  locationIdentifier: string | null;
  city: string | null;
  state: string | null;
  zip: string | null;
  taxId: string | null;
  subsidiaryOrganizationName: string | null;
}

export interface LocationsDto {
  /** Array of items */
  items: LocationItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
  missingFieldsCount: number;
}

export interface LocationOrganizationDto {
  id: string;
  name: string;
}

export interface LocationDetailDto {
  id: string;
  displayName?: string | null;
  mainPointOfContact?: ContactDto | null;
  status?: LocationStatus | null;
  spendAreas: string[];
  stages: string;
  savings: number;
  documentFieldStatus?: DocumentFieldStatus | null;
  activeAudits: number;
  isMissingRow: boolean;
  squareFootage?: number | null;
  weatherStation?: string | null;
  hoursOfOperation?: string | null;
  units?: number | null;
  organization: LocationOrganizationDto;
  name: string | null;
  address: string | null;
  locationIdentifier: string | null;
  city: string | null;
  state: string | null;
  zip: string | null;
  taxId: string | null;
  subsidiaryOrganizationName: string | null;
}

export interface IpUpdateLocationDto {
  locationIdentifier?: string;
  address?: string;
  city?: string;
  state?: string;
  zip?: string;
  /** @format uuid */
  mainPointOfContactId?: string;
  status?: LocationStatus;
  /** @min 0 */
  squareFootage?: number | null;
  weatherStation?: string | null;
  hoursOfOperation?: string | null;
  /** @min 0 */
  units?: number | null;
  name?: string | null;
  taxId?: string | null;
}

export interface ImportLocationDto {
  locationIdentifier: string;
  name?: string | null;
  address?: string;
  city?: string;
  state?: string;
  zip?: string;
  taxId?: string | null;
  status?: LocationStatus;
  /** @min 0 */
  squareFootage?: number | null;
  weatherStation?: string | null;
  hoursOfOperation?: string | null;
  /** @min 0 */
  units?: number | null;
  mainPointOfContactId?: string;
}

export interface LocationCompareRecordDto {
  number: string;
  name: string;
  address: string;
}

export interface LocationDuplicatedPairRowDto {
  /** @example "duplicated-0" */
  id: string;
  /** 1-based spreadsheet row number (2 = first data row, since row 1 is headers) */
  row: number;
  /** Mapped import DTO for this row (used when resolving duplicates) */
  data: ImportLocationDto;
  imported: LocationCompareRecordDto;
  existing: LocationCompareRecordDto;
  /** @example ["number","name","address"] */
  duplicateColumns: string[];
}

export interface LocationImportResultDto {
  isValid: boolean;
  /** Mapped DTOs that passed validation (with original row number) */
  validData: SpreadsheetRow[];
  /** Rows that failed validation (includes the DTO + error details) */
  invalidRows: SpreadsheetRowError[];
  totalRows: number;
  /** True when at least one importable row has an empty or missing imported field */
  hasMissingFields: boolean;
  /** Rows that match an existing location in the organization (excluded from validData) */
  duplicatedRows: LocationDuplicatedPairRowDto[];
}

export interface CreateLocationManyItemDto {
  locationIdentifier: string;
  name?: string | null;
  address?: string;
  city?: string;
  state?: string;
  zip?: string;
  taxId?: string | null;
  status?: LocationStatus;
  /** @min 0 */
  squareFootage?: number | null;
  weatherStation?: string | null;
  hoursOfOperation?: string | null;
  /** @min 0 */
  units?: number | null;
  /** @format uuid */
  mainPointOfContactId?: string;
}

export interface LocationCreateManyDto {
  items: CreateLocationManyItemDto[];
}

export interface IpCreateLocationDto {
  locationIdentifier: string;
  address: string;
  city: string;
  state: string;
  zip: string;
  /** @format uuid */
  mainPointOfContactId?: string;
  status?: LocationStatus;
  /** @min 0 */
  squareFootage?: number | null;
  weatherStation?: string | null;
  hoursOfOperation?: string | null;
  /** @min 0 */
  units?: number | null;
  name?: string | null;
  taxId?: string | null;
}

export interface ActionItemListItemDto {
  id: string;
  title: string;
  description?: string | null;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deadline?: string | null;
  /** @format date-time */
  completedAt?: string | null;
  spendAreaStage: SpendAreaStage;
  priorityLevel: PriorityLevel;
  actionType?: ActionItemType | null;
  /** Action details associated with the step. */
  actionDetails?:
    | MeetingLinkActionTypeDto
    | FileUploadActionTypeDto
    | LinkActionTypeDto;
  createdBy?: PlainExternalUserDto | null;
  assignee?: PlainExternalUserDto | null;
}

export interface IPActionItemListDto {
  /** Array of items */
  items: ActionItemListItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface IpTaskDto {
  id: string;
  completed: boolean;
  title: string;
  description?: string | null;
  category: TaskCategory;
  assignee?: PlainExternalUserDto | null;
  /** @format date-time */
  deadline?: string | null;
  priorityLevel: PriorityLevel;
  referenceName?: string | null;
  ticketId?: string | null;
  ticketNumber?: string | null;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  organizationId?: string | null;
}

export interface IpTicketDto {
  id: string;
  ticketNumber: string;
  status?: TicketStatus | null;
  subject: string;
  priority?: PriorityLevel | null;
  assignee?: PlainExternalUserDto | null;
  category?: TicketCategory | null;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  organizationId?: string | null;
}

export interface TicketMetricsDto {
  openTotal: number;
  openLowPriority: number;
  openMediumPriority: number;
  openHighPriority: number;
}

export interface TaskMetricsDto {
  openTotal: number;
  openLowPriority: number;
  openMediumPriority: number;
  openHighPriority: number;
  dueTodayTotal: number;
  dueTodayLowPriority: number;
  dueTodayMediumPriority: number;
  dueTodayHighPriority: number;
}

export interface DashboardMetricsDto {
  lastEditedTask?: IpTaskDto;
  lastEditedTicket?: IpTicketDto;
  notifications?: number;
  crmCount?: number;
  tickets?: TicketMetricsDto;
  tasks?: TaskMetricsDto;
}

export interface ProjectListDto {
  /** Array of items */
  items: ProjectDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface IpTeamDto {
  /** @format uuid */
  id: string;
  name: string;
  activeTaskCount?: number;
  allTaskCount?: number;
  userCount: number;
}

export interface IpTeamListDto {
  /** Array of items */
  items: IpTeamDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface UpsertPreferenceBodyDto {
  /**
   * Any valid JSON value to be stored (string, number, boolean, array, object, null)
   * @example ["org1","org2"]
   */
  value: string | number | boolean | any[] | object | null;
}

export interface PreferenceDto {
  /** @example "user" */
  type: PreferenceDtoTypeEnum;
  userId?: string;
  organizationId?: string;
  key: string;
  /** @example {"columns":["id","name","created"]} */
  value: string | number | boolean | any[] | object | null;
}

export interface PreferenceListDto {
  /** List of preferences */
  items: PreferenceDto[];
}

export interface IncludedLocationsDto {
  count: number;
  matched: string[];
  matchCount: number;
}

export interface AuditItemDto {
  id: string;
  name?: string | null;
  status?: AuditStatus | null;
  stage?: AuditStage | null;
  spendCategory?: PlainDto | null;
  spendArea?: PlainDto | null;
  vendor?: PlainDto | null;
  includedLocations: IncludedLocationsDto;
  /** Locations assigned to this audit via its optimization subject. Only populated when fetching a single audit. */
  locations?: PlainDto[];
  dueDate?: string | null;
  createdAt: string;
  baselineSpend: number;
  invoicesAttachedCount: number;
  createdBy?: PlainExternalUserDto | null;
  assignedTeam?: PlainDto | null;
  owner?: PlainExternalUserDto | null;
  contract?: PlainDto | null;
  subsidiaryOrganization?: PlainDto | null;
}

export interface AuditListDto {
  /** Array of items */
  items: AuditItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateAuditDto {
  /**
   * Spend category that scopes the audit
   * @format uuid
   */
  spendCategoryId: string;
  /**
   * SIB contract id
   * @format uuid
   */
  contractId: string;
  dueDate: string;
  /** Vendor id */
  vendorId: string;
  /**
   * Vendor point of contact ids
   * @uniqueItems true
   */
  contactIds?: string[];
  /**
   * Assigned team id
   * @format uuid
   */
  teamId: string;
  /**
   * Owner external user id; must be a member of the team
   * @format uuid
   */
  ownerId?: string;
}

export interface AverageAuditDurationDto {
  /** Average audit duration in days for the spend category; null when there is no manual value and no completed audits to compute from */
  averageDurationDays?: number | null;
  /** Whether the value comes from the manual override on the spend category or was computed from completed audits */
  source?: AverageAuditDurationSource | null;
}

export interface UpdateAuditDto {
  dueDate?: string;
  /** Vendor id */
  vendorId?: string;
  /**
   * Assigned team id
   * @format uuid
   */
  teamId?: string;
  /**
   * Owner external user id; must be a member of the team. Pass null to unassign the owner.
   * @format uuid
   */
  ownerId?: string | null;
  status?: AuditStatus;
  stage?: SpendAreaStage;
}

export interface AuditDocumentDto {
  id: string;
  stage: DocumentStage;
  fileUrl: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  name: string;
  sensitive: boolean;
  providedBy: DocumentProvidedBy;
  uploadedBy: PlainExternalUserDto;
  spendCategory?: SpendCategoryListItemDto | null;
  organizationId: string;
  subsidiaryOrganizationName?: string | null;
  tags: DocumentTagDto[] | null;
  uploadStage: DocumentUploadStatus;
  contractType?: ContractType | null;
  categoryManager?: CategoryManager | null;
  categoryManagerUser?: PlainExternalUserDto | null;
  paymentFrequency?: PaymentFrequency | null;
  anomaly?: boolean | null;
  matchingDocuments?: number | null;
  hasVirtualInvoices?: boolean;
  docId?: string | null;
  /** AI-managed fields explicitly edited by a user; Franz sync skips these. */
  userModifiedFields?: string[];
  /**
   * Set when Franz first updates this document; AI-managed fields become read-only for users.
   * @format date-time
   */
  updatedWithAiAt?: string | null;
  /** Whether the document is linked to this audit (picker). */
  linkedToThisAudit?: boolean;
  attachedFromDocumentsRepo?: boolean;
  uploadedAuditStage?: AuditStage | null;
  vendor: string | null;
  fileSize?: number | null;
  type: string | null;
  /** @format date-time */
  startDate?: string | null;
  /** @format date-time */
  endDate?: string | null;
  /** @format date-time */
  renewalDate?: string | null;
  annualContractValue?: number | null;
  notToExceed?: boolean | null;
  annualPriceIncrease?: boolean | null;
  earlyTerminationFee?: boolean | null;
  cancellationDateNoticePeriod?: string | null;
  autoRenewalClause?: boolean | null;
  autoRenewalLength?: string | null;
  notToExceedPercentage?: number | null;
  additionalColumns?: object | null;
}

export interface AuditDocumentListDto {
  /** Array of items */
  items: AuditDocumentDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface AttachAuditDocumentsDto {
  /**
   * @minItems 1
   * @uniqueItems true
   */
  documentIds: string[];
}

export interface AttachAuditDocumentsResultDto {
  successfullyAttached: number;
}

export interface DetachAuditDocumentsDto {
  /**
   * @minItems 1
   * @uniqueItems true
   */
  documentIds: string[];
}

export interface DetachAuditDocumentsResultDto {
  successfullyDetached: number;
}

export interface DeleteAuditDocumentsResultDto {
  successfullyDeleted: number;
}

export interface AuditVendorAccountListDto {
  /** Array of items */
  items: VendorAccountDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface AttachAuditVendorAccountsDto {
  /**
   * @minItems 1
   * @uniqueItems true
   */
  vendorAccountIds: string[];
}

export interface AttachAuditVendorAccountsResultDto {
  successfullyAttached: number;
}

export interface DetachAuditVendorAccountsDto {
  /**
   * @minItems 1
   * @uniqueItems true
   */
  vendorAccountIds: string[];
}

export interface DetachAuditVendorAccountsResultDto {
  successfullyDetached: number;
}

export interface SpendEstimatedSpendDto {
  /** @format uuid */
  id: string;
  name: string;
  vendorAccountNumber: string;
  unit: string;
  quantity: number;
  pricePerUnit: number;
  total: number;
  occurrenceInterval: OccurrenceInterval;
  /** @format uuid */
  locationId?: string;
  locationName?: string;
}

export interface SpendEstimatedListDto {
  /** Array of items */
  items: SpendEstimatedSpendDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
  /** Sum of line totals for all rows matching the current filters (not just the current page). */
  totalSpend: number;
}

export interface ImportSpendEstimatedItemDto {
  vendorAccountNumber: string;
  name: string;
  unit: string;
  /** @min 0 */
  quantity: number;
  /** @min 0 */
  pricePerUnit: number;
  occurrenceInterval?: OccurrenceInterval;
  /** Location identifier. When the location name is unique for the organization it may be used as the identifier; otherwise use the location UUID. Resolved to a UUID before persist. */
  locationId?: string;
}

export interface SpendEstimatedSpendCompareDto {
  name: string;
  vendorAccountNumber: string;
  unit: string;
  quantity: number;
  pricePerUnit: number;
  total: number;
  occurrenceInterval: OccurrenceInterval;
}

export interface SpendEstimatedDuplicatedSpendDto {
  /** @example "dup-spend-0" */
  id: string;
  /** 1-based spreadsheet row number for this spend */
  row: number;
  data: ImportSpendEstimatedItemDto;
  imported: SpendEstimatedSpendCompareDto;
  existing: SpendEstimatedSpendCompareDto;
  /**
   * Fields that differ between imported and existing spend values
   * @example ["quantity","total"]
   */
  changedFields: string[];
}

export interface SpendEstimatedImportResultDto {
  isValid: boolean;
  /** Mapped DTOs that passed validation (with original row number) */
  validData: SpreadsheetRow[];
  /** Rows that failed validation (includes the DTO + error details) */
  invalidRows: SpreadsheetRowError[];
  totalRows: number;
  /** True when at least one importable row is missing an optional location */
  hasMissingFields: boolean;
  /** Imported spends that match existing spends by name and vendor account number but differ in values (excluded from validData) */
  duplicatedItems: SpendEstimatedDuplicatedSpendDto[];
}

export interface ConfirmSpendEstimatedDto {
  /**
   * @maxItems 500
   * @minItems 1
   */
  items: ImportSpendEstimatedItemDto[];
}

export interface ConfirmSpendEstimatedResultDto {
  importedCount: number;
  totalSpend: number;
}

export interface SpendEstimatedVendorAccountOptionDto {
  /** @format uuid */
  id: string;
  accountNumber?: string | null;
  label: string;
}

export interface CreateSpendEstimatedSpendDto {
  name: string;
  vendorAccountNumber: string;
  unit: string;
  /** @min 0 */
  quantity: number;
  /** @min 0 */
  pricePerUnit: number;
  occurrenceInterval: OccurrenceInterval;
  /** @format uuid */
  locationId?: string;
}

export interface BulkUpdateSpendEstimatedSpendsDto {
  name?: string;
  vendorAccountNumber?: string;
  unit?: string;
  /** @min 0 */
  quantity?: number;
  /** @min 0 */
  pricePerUnit?: number;
  occurrenceInterval?: OccurrenceInterval;
  /**
   * Omit to leave unchanged; null clears location (organization-wide)
   * @format uuid
   */
  locationId?: string | null;
  /**
   * @minItems 1
   * @uniqueItems true
   */
  spendIds: string[];
}

export interface BulkUpdateSpendEstimatedResultDto {
  successfullyUpdated: number;
}

export interface UpdateSpendEstimatedSpendDto {
  name?: string;
  vendorAccountNumber?: string;
  unit?: string;
  /** @min 0 */
  quantity?: number;
  /** @min 0 */
  pricePerUnit?: number;
  occurrenceInterval?: OccurrenceInterval;
  /**
   * Omit to leave unchanged; null clears location (organization-wide)
   * @format uuid
   */
  locationId?: object | null;
}

export interface BulkDeleteSpendEstimatedSpendsDto {
  /**
   * @minItems 1
   * @uniqueItems true
   */
  spendIds: string[];
}

export interface DeleteSpendEstimatedResultDto {
  successfullyDeleted: number;
}

export interface VendorContactDto {
  id: string;
  name?: string;
  email?: string;
  isActive: boolean;
  serviceProvider: string;
  firstName: string | null;
  lastName: string | null;
  title: string | null;
  phoneNumber: string | null;
  note: string | null;
}

export interface VendorContactsListDto {
  /** Array of items */
  items: VendorContactDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface NotificationDto {
  uuid: string;
  title: string;
  description?: string;
  type: string;
  priority: NotificationPriority;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  actionMetadata?: any;
  /** @format date-time */
  seenAt: string | null;
}

export interface NotificationListDto {
  /** Array of items */
  items: NotificationDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
  newItemsCount?: number;
}

export interface UpdateNotificationDto {
  seen?: boolean;
}

export interface NotificationCountDto {
  count: number;
}

export interface CreateRecurringTaskDto {
  title: string;
  priorityLevel?: PriorityLevel;
  category: TaskCategory;
  /**
   * The ID of the user to assign the task to
   * @format uuid
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  assignee?: string;
  /**
   * Estimated time to complete the task in minutes
   * @min 1
   * @example 120
   */
  estimatedTime?: number;
  timeToComplete: RecurrenceInterval;
  timeToCompleteAmount: number;
  /**
   * Start date for the recurring task
   * @format date-time
   */
  repeatStartDate?: string;
  /**
   * End date for the recurring task
   * @format date-time
   */
  repeatEndDate?: string;
  /** Recurrence interval - day, week, month */
  repeatInterval?: RecurrenceInterval;
  /** Interval amount for the recurrence */
  repeatIntervalAmount?: number | null;
  /** Days of the week for the recurrence (1-5) */
  repeatOnWeekDays?: number[] | null;
  /** Day of the month for the recurrence (1-31) */
  repeatOnMonthDay?: number | null;
  /** Weekday order for the recurrence (1-5) */
  repeatOnMonthWeekdayOrder?: number | null;
  /** Weekday for the recurrence (1-5) */
  repeatOnMonthWeekdayDay?: number | null;
  tags?: CreateTaskTagDto[] | null;
  description?: string | null;
  referenceLink?: string | null;
  referenceName?: string | null;
  organizationId?: string | null;
  /** The ID of the vendor organization to associate with the task */
  vendorId?: string | null;
}

export interface RecurringTaskDto {
  /**
   * Unique identifier for the task
   * @example "c56a4180-65aa-42ec-a945-5fd21dec0538"
   */
  uuid: string;
  /**
   * Title of the task
   * @example "Complete project documentation"
   */
  title: string;
  /**
   * Description of the task
   * @example "Finish writing the project documentation by end of the day"
   */
  description?: string | null;
  /**
   * Date when the task was created
   * @format date-time
   * @example "2023-01-01T12:00:00Z"
   */
  createdAt: string;
  /**
   * Date when the task was last updated
   * @format date-time
   * @example "2023-01-02T15:30:00Z"
   */
  updatedAt: string;
  /** Priority of the task */
  priorityLevel: PriorityLevel;
  createdByUser: PlainExternalUserDto;
  assigneeUser: PlainExternalUserDto;
  category?: TaskCategory;
  tags: TaskTagDto[];
  timeToComplete: RecurrenceInterval;
  timeToCompleteAmount: number;
  /**
   * Start date for the recurring task
   * @format date-time
   */
  repeatStartDate?: string;
  /**
   * End date for the recurring task
   * @format date-time
   */
  repeatEndDate?: string;
  /** Recurrence interval - day, week, month */
  repeatInterval?: RecurrenceInterval;
  /** Interval amount for the recurrence */
  repeatIntervalAmount?: number;
  /** Days of the week for the recurrence (1-5) */
  repeatOnWeekDays?: number[];
  /** Day of the month for the recurrence (1-31) */
  repeatOnMonthDay?: number;
  /** Weekday order for the recurrence (1-5) */
  repeatOnMonthWeekdayOrder?: number;
  /** Weekday for the recurrence (1-5) */
  repeatOnMonthWeekdayDay?: number;
  referenceLink: string | null;
  referenceName: string | null;
  /**
   * Estimated time to complete the task in minutes
   * @min 1
   * @example 120
   */
  estimatedTime: number | null;
}

export interface RecurringTaskListDto {
  /** Array of items */
  items: RecurringTaskDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export type Date = object;

export interface UpdateRecurringTaskDto {
  priorityLevel?: PriorityLevel;
  category?: TaskCategory | null;
  /**
   * The ID of the user to assign the task to
   * @format uuid
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  assignee?: string;
  /**
   * Estimated time to complete the task in minutes
   * @min 1
   * @example 120
   */
  estimatedTime?: number;
  timeToComplete?: RecurrenceInterval;
  timeToCompleteAmount?: number;
  /**
   * Start date for the recurring task
   * @format date-time
   */
  repeatStartDate?: string | null;
  /**
   * End date for the recurring task
   * @format date-time
   */
  repeatEndDate?: string | null;
  /** Recurrence interval - day, week, month */
  repeatInterval?: RecurrenceInterval | null;
  /** Interval amount for the recurrence */
  repeatIntervalAmount?: number | null;
  /** Days of the week for the recurrence (1-5) */
  repeatOnWeekDays?: number[] | null;
  /** Day of the month for the recurrence (1-31) */
  repeatOnMonthDay?: number | null;
  /** Weekday order for the recurrence (1-5) */
  repeatOnMonthWeekdayOrder?: number | null;
  /** Weekday for the recurrence (1-5) */
  repeatOnMonthWeekdayDay?: number | null;
  tags?: CreateTaskTagDto[] | null;
  /** @minLength 1 */
  title?: string | null;
  description?: string | null;
  referenceLink?: string | null;
  referenceName?: string | null;
  organizationId?: string | null;
  /** The ID of the vendor organization to associate with the task */
  vendorId?: string | null;
}

export interface OrganizationMemberDto {
  id: string;
  name: string;
  email: string;
  /** @example "3" */
  taskCount?: number;
  avatarUrl: string | null;
  deletedAt: string | null;
}

export interface MemberListDto {
  /** Array of items */
  items: OrganizationMemberDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface OrganizationSummaryWithCountsDto {
  /** @example "123e4567-e89b-12d3-a456-426614174000" */
  id: string;
  /** @example "Acme Corp" */
  organizationName: string;
  /** @example "Acme Corp" */
  organizationLogoUrl: string;
  /** @example 5 */
  membersCount: number;
  /** @example 3 */
  activeTasksCount: number;
}

export interface OrganizationSummaryWithCountsListDto {
  /** Array of items */
  items: OrganizationSummaryWithCountsDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface OrganizationSummaryWithMyActiveTasksCountDto {
  /** @example "123e4567-e89b-12d3-a456-426614174000" */
  id: string;
  /** @example "Acme Corp" */
  organizationName: string;
  /** @example "Acme Corp" */
  organizationLogoUrl: string;
  /** @example 5 */
  myActiveTasksCount: number;
}

export interface OrganizationSummaryWithMyActiveTasksCountListDto {
  /** Array of items */
  items: OrganizationSummaryWithMyActiveTasksCountDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface OrganizationSummaryWithActionItemsCountDto {
  /** @example "123e4567-e89b-12d3-a456-426614174000" */
  id: string;
  /** @example "Acme Corp" */
  organizationName: string;
  /** @example "Acme Corp" */
  organizationLogoUrl: string;
  /** @example 5 */
  actionItems: number;
  permissions: Record<string, PermissionAction>;
}

export interface OrganizationSummaryWithActionItemsCountListDto {
  /** Array of items */
  items: OrganizationSummaryWithActionItemsCountDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
  /** @example 100 */
  allActionItems: number;
  /** @example 40 */
  myOrganizationsActionItems: number;
}

export interface CurrentUserOrganizationDto {
  id: string;
  name: string;
}

export interface CurrentUserDto {
  id: string;
  name: string;
  email: string;
  meetingLink?: string;
  title?: string;
  userLoginStatus?: UserLoginStatus;
  organizations: CurrentUserOrganizationDto[] | null;
  /** @deprecated */
  isSibEmployee: boolean;
  hasGlobalAccess: boolean;
  /**
   * @deprecated
   * @example "employee"
   */
  roles: EntraGroup[];
  firstName: string | null;
  surname: string | null;
  contactEmail: string | null;
  contactPhoneNumber: string | null;
  avatarUrl: string | null;
  deletedAt: string | null;
}

export interface PlainOrganizationListDto {
  /** Array of items */
  items: PlainOrganizationDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface TaskCommentDto {
  id: string;
  comment: string;
  taskId: string;
  createdBy: PlainExternalUserDto;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface TaskCommentListDto {
  /** Array of items */
  items: TaskCommentDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateTaskCommentDto {
  comment: string;
}

export interface AuditDto {
  id: string;
  name: string;
  type: string;
  stage: string;
}

export interface LocationSelectListItemDto {
  id: string;
  name: string;
}

export interface TeamReferenceDto {
  /** @format uuid */
  uuid: string;
  name: string;
  photoUrl: string;
}

export interface SubauditDto {
  id: string;
  onHold: boolean;
  subauditName: string;
  autoIncrementedId: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  audit: AuditDto;
  owner: PlainExternalUserDto;
  organization: PlainOrganizationDto;
  location: LocationSelectListItemDto;
  spendArea: string;
  vendor: PlainOrganizationDto;
  vendorAccountIdentifier: string;
  spendAmount: number;
  subAuditStage: SubauditStage;
  team: TeamReferenceDto;
}

export interface SubauditsListDto {
  /** Array of items */
  items: SubauditDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateSubauditDto {
  onHold?: boolean;
  subauditName: string;
  auditId: string;
  /** @format uuid */
  ownerId: string;
  vendorId: string;
  /** @format uuid */
  locationId: string;
  vendorAccountNumber: string;
  spendAmount: number;
  subauditStage: SubauditStage;
  /** @format uuid */
  teamId: string;
}

export interface UpdateSubauditDto {
  onHold?: boolean;
  subauditName?: string;
  auditId?: string;
  /** @format uuid */
  ownerId?: string;
  vendorId?: string;
  /** @format uuid */
  locationId?: string;
  vendorAccountNumber?: string;
  spendAmount?: number;
  subauditStage?: SubauditStage;
  /** @format uuid */
  teamId?: string;
}

export interface AuditsListDto {
  /** Array of items */
  items: AuditDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface SubauditCommentDto {
  /** @format uuid */
  id: string;
  content: string;
  topic: string;
  /** @format uuid */
  subauditId: string;
  createdBy: PlainExternalUserDto;
  createdAt: string;
}

export interface SubauditCommentListDto {
  /** Array of items */
  items: SubauditCommentDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateSubauditCommentDto {
  topic: string;
  content: string;
}

export interface UpdateSubauditCommentDto {
  topic?: string;
  content?: string;
}

export interface SubauditVersionChangeRecordDto {
  prevValue: string;
  newValue: string;
  fieldName: SubauditVersionChangeRecordFields;
}

export interface SubauditVersionChangelogItemDto {
  /** The ID of the version after the changes. Might be useful in the future for reverting to previous versions. */
  afterChangesVersionId: string;
  modifiedBy: PlainExternalUserDto;
  /** @format date-time */
  modifiedAt: string;
  action: AuditingAction;
  /** The ID of the parent entity. */
  parent: string;
  /** The type of the entity. Usually the name of the entity. */
  type: ChangelogEntityType;
  /** String that helps represent the entity in the UI. */
  display: string;
  /** The changes made to the entity. */
  changes: SubauditVersionChangeRecordDto[];
}

export interface SubauditVersionChangelogList {
  /** Array of items */
  items: SubauditVersionChangelogItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface FileUploadActionTypeDto {
  /**
   * Type of the action, indicating file upload.
   * @example "file-upload"
   */
  type: ActionItemType;
  /**
   * Public URL to the uploaded file
   * @example "/api/document/file/001XYZ_file.png"
   */
  url: string;
  /**
   * Original filename of the uploaded document
   * @example "001XYZ_file.png"
   */
  filename: string;
  id: string;
}

export interface PutFileUploadActionTypeDto {
  /** @example "file-upload" */
  type: ActionItemType;
}

export interface MeetingLinkActionTypeDto {
  /** @example "meeting-link" */
  type: ActionItemType;
  /** Meeting link URL. */
  url: string;
  /**
   * Date of the meeting.
   * @format date-time
   */
  date: string;
}

export interface LinkActionTypeDto {
  /** @example "link" */
  type: ActionItemType;
  url: string;
}

export interface ActionItemDto {
  id: string;
  title: string;
  description?: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  spendAreaStage: SpendAreaStage;
  organization: PlainOrganizationDto;
  priorityLevel: PriorityLevel;
  actionType: ActionItemType | null;
  /** Action details associated with the step. */
  actionDetails?:
    | MeetingLinkActionTypeDto
    | FileUploadActionTypeDto
    | LinkActionTypeDto;
  createdBy: PlainExternalUserDto;
  assignee: PlainExternalUserDto;
  notifyExternalClient: boolean;
  /** @format date-time */
  deadline?: string | null;
  /** @format date-time */
  completedAt: string | null;
}

export interface ActionItemListDto {
  /** Array of items */
  items: ActionItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateActionItemDto {
  title: string;
  description?: string;
  /** @example "MOBILIZATION" */
  spendAreaStage: SpendAreaStage;
  /** @example "high" */
  priorityLevel: PriorityLevel;
  /** @format uuid */
  projectId?: string;
  /**
   * Action details associated with the step. Must be a valid JSON string in multipart/form-data.
   *
   * file-upload type:
   * {"type": "file-upload"}
   *
   * meeting-link type:
   * {
   * "type": "meeting-link",
   * "url": "https://meet.google.com/example",
   * "date": "2025-03-11T17:46:33.200Z"
   * }
   * @example "{"type": "file-upload"}"
   */
  action?:
    | MeetingLinkActionTypeDto
    | PutFileUploadActionTypeDto
    | LinkActionTypeDto
    | null;
  /**
   * File to upload (only required if action.type = file-upload)
   * @format binary
   */
  file?: File;
  /**
   * Send notification email to external client when assigned
   * @default false
   */
  notifyExternalClient?: boolean;
  /**
   * @format date-time
   * @example "2024-12-31T23:59:59Z"
   */
  deadline: string | null;
  /** @format uuid */
  assignee?: string | null;
}

export interface UpdateActionItemDto {
  title?: string;
  description?: string;
  /** @example "MOBILIZATION" */
  spendAreaStage?: SpendAreaStage;
  /** @example "high" */
  priorityLevel?: PriorityLevel;
  /** @format uuid */
  projectId?: string;
  /**
   * Action details associated with the step. Must be a valid JSON string in multipart/form-data.
   *
   * file-upload type:
   * {"type": "file-upload"}
   *
   * meeting-link type:
   * {
   * "type": "meeting-link",
   * "url": "https://meet.google.com/example",
   * "date": "2025-03-11T17:46:33.200Z"
   * }
   * @example "{"type": "file-upload"}"
   */
  action?:
    | MeetingLinkActionTypeDto
    | PutFileUploadActionTypeDto
    | LinkActionTypeDto
    | null;
  /**
   * File to upload (only required if action.type = file-upload)
   * @format binary
   */
  file?: File;
  /**
   * Send notification email to external client when assigned
   * @default false
   */
  notifyExternalClient?: boolean;
  completed?: boolean;
  /**
   * @format date-time
   * @example "2024-12-31T23:59:59Z"
   */
  deadline?: string | null;
  /** @format uuid */
  assignee?: string | null;
}

export interface LocationDto {
  id: string;
  dba: string;
  address: string;
  city: string;
  state: string;
  zip: string;
  taxId: string;
  fullLegalName: string;
  /** The status of the location */
  status: LocationDtoStatusEnum;
  spendArea: string;
  /** List of stages associated with the location */
  spendAreaStage: LocationDtoSpendAreaStageEnum[];
  savingsApproved?: number;
  spendApproved?: number;
  /** Additional information as key-value pairs */
  additionalInfo?: object;
  /** Status of the document field */
  documentFieldStatus?: LocationDtoDocumentFieldStatusEnum;
  name: string;
  locationIdentifier: string;
  salesforceId: string;
  requestedChange?: LocationDtoRequestedChangeEnum;
}

export interface LocationListDto {
  /** Array of items */
  items: LocationDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface FileMetadataDto {
  /**
   * Unique ID of the uploaded file
   * @example "file_abc123"
   */
  id: string;
  /**
   * Original name of the uploaded file
   * @example "site-list.xlsx"
   */
  filename: string;
  /**
   * Signed URL to access the uploaded file
   * @example "https://s3.bucket.com/documents/site-list.xlsx?..."
   */
  url: string;
  /**
   * Timestamp when the file was uploaded
   * @example "2025-06-05T10:20:30.000Z"
   */
  uploadedAt?: string;
}

export interface GetFilesUnderValidationResponseDto {
  /** Array of unique uploaded files under validation */
  items: FileMetadataDto[];
  /** Most recently uploaded file, or an empty object if none found */
  lastUploadedFile?: FileMetadataDto;
}

export interface ExcelUploadResponseDto {
  /**
   * Informacja, czy plik Excel pochodzi ze standardowego szablonu
   * @example true
   */
  isExcelFileFromTemplate: boolean;
  /** Uploaded file URL */
  fileUrl: string;
  /**
   * List of created location UUIDs
   * @example ["550e8400-e29b-41d4-a716-446655440000"]
   */
  createdLocationIds: string[];
}

export interface LocationActionBodyDto {
  /**
   * The type of action to perform on the locations
   * @example "exclude_from_audit"
   */
  actionType: LocationActionBodyDtoActionTypeEnum;
  /**
   * Array of location IDs to apply the action to
   * @minItems 1
   * @uniqueItems true
   * @example ["location_1","location_2","location_3"]
   */
  locationIds: string[];
}

export interface LocationActionResponseDto {
  /**
   * Confirmation message for the action request
   * @example "Change request created successfully"
   */
  message: string;
  /**
   * Array of location IDs that were processed
   * @example ["location_1","location_2"]
   */
  updatedLocations: string[];
}

export interface UpdateLocationDto {
  dba?: string;
  address?: string;
  city?: string;
  state?: string;
  zip?: string;
  taxId?: string;
  legalName?: string;
  status?: LocationStatus;
  spendArea?: string;
  /** List of stages associated with the location */
  spendAreaStage?: UpdateLocationDtoSpendAreaStageEnum[];
  /** Additional information as key-value pairs */
  additionalInfo?: object;
  documentFieldStatus?: UpdateLocationDtoDocumentFieldStatusEnum;
  locationIdentifier?: string;
  /** The requested change action, can be one of LocationAction values or an empty string */
  requestedChange?: UpdateLocationDtoRequestedChangeEnum | null;
}

export interface TemplateActionItemFileDto {
  filename: string;
  url: string;
  size: number;
  mimeType: string;
}

export interface TemplateActionItemDto {
  id: string;
  title: string;
  spendAreaStage: SpendAreaStage;
  priorityLevel: PriorityLevel;
  actionType?: ActionItemType | null;
  /** @format date-time */
  dueDate?: string | null;
  file?: TemplateActionItemFileDto | null;
  description?: string | null;
  link?: string | null;
  dueDateInDays?: number | null;
}

export interface ActionItemTemplateDto {
  id: string;
  name: string;
  actionItems: TemplateActionItemDto[];
  description?: string | null;
}

export interface ActionItemTemplateListDto {
  /** Array of items */
  items: ActionItemTemplateDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface RequestSpendAreaResponseDto {
  /** Ids of "requested spend areas" */
  createdRequestSpendAreasIds: string[];
  /** List of "spend areas" that were created */
  createdSpendAreasIds: string[];
  /** List of spend areas that were not created */
  skippedSpendAreasIds: string[];
}

export interface RequestSpendAreaBodyDto {
  /** @uniqueItems true */
  spendAreaIds: string[];
}

export interface PowerBiReportListItemDto {
  id: string;
  name?: string;
  groupId: string;
  reportId: string;
}

export interface PowerBiReportListDto {
  /** Array of items */
  items: PowerBiReportListItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface ChildOrganizationDto {
  id: string;
  name: string;
  savingsApproved: number;
  savingsIdentified: number;
  inScopeSpend: number;
}

export interface ChildOrganizationListDto {
  /** Array of items */
  items: ChildOrganizationDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface InvoiceFileDto {
  id: string;
  name: string;
  url: string;
  fileSize: number;
  messageDate: string;
}

export interface NetsuiteInvoiceDto {
  id: string;
  date: string;
  dueDate: string;
  amount: number;
  balance: number;
  status: InvoicePaymentStatus;
  /** Link to the main PDF file of the invoice */
  fileUrl: string;
  internalId: string;
  paymentUrl: string;
  /** Additional files associated with the netsuite invoice */
  files: InvoiceFileDto[];
}

export interface InvoiceSummaryDto {
  thirtyDays: number;
  sixtyDays: number;
  ninetyDays: number;
  overNinetyDays: number;
  total: number;
  totalUnpaidInvoices: number;
}

export interface NetsuiteInvoiceListDto {
  /** Array of items */
  items: NetsuiteInvoiceDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface VectorInvoiceDto {
  id: string;
  date: string;
  dueDate: string;
  amount: number;
  balance: number;
  status: InvoicePaymentStatus;
  /** Link to the main PDF file of the invoice */
  fileUrl: string;
  vendorName: string;
  locationId?: number;
  locationName?: string;
  accountNumber?: string;
}

export interface VectorInvoiceListResponseDto {
  /** Array of items */
  items: VectorInvoiceDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateZipNetsuiteRequestDto {
  /**
   * Array of invoice IDs to include in the ZIP archive
   * @minItems 1
   * @uniqueItems true
   */
  invoiceIds: string[];
}

export interface FailedDownloadDocumentDto {
  url: string;
  name: string;
}

export interface CreateBillingsZipResponseDto {
  sasUrl: string;
  failedDownloads: FailedDownloadDocumentDto[];
  successDownloadsCount: number;
}

export interface CreateZipVectorRequestDto {
  /**
   * Array of invoice download urls take from vector api to include in the ZIP archive
   * @minItems 1
   */
  downloadUrls: string[];
}

export interface FaqCategoryDto {
  id: string;
  name: string;
  description?: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface FaqIconDto {
  id: string;
  url: string;
  alt?: string;
  filename: string;
  mimeType: string;
  filesize: number;
  width?: number;
  height?: number;
}

export interface FaqFileDto {
  id: string;
  fileName: string;
  fileType?: string;
  url: string;
}

export interface FaqDto {
  id: string;
  title: string;
  description: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** FAQ category information */
  category: FaqCategoryDto;
  /** FAQ icon/image */
  icon?: FaqIconDto;
  /** FAQ file attachment (PDF) */
  file?: FaqFileDto;
}

export interface FaqListDto {
  /** Array of items */
  items: FaqDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface ParcelPayInvoiceDto {
  /** @default "" */
  carrier: string;
  /** @default "" */
  status: string;
  /** @default "" */
  invoiceNo: string;
  /** @default "" */
  accountNumber: string;
  /** @default "" */
  invoiceDate: string;
  /** @default "" */
  dueDate: string;
  /** @default 0 */
  netCharge: number;
  /** @default null */
  paymentDate?: object | null;
}

export interface ParcelPayInvoiceListDto {
  data: ParcelPayInvoiceDto[];
  total: number;
}

export interface ApproveInvoicesRequestDto {
  action: ApproveInvoicesRequestDtoActionEnum;
  user: string;
  accountIds?: string[];
  invoiceDates?: string[];
  selectedInvoiceIds?: number[];
}

export interface ApproveInvoicesResponseItemDto {
  /** @default false */
  resultStatus: boolean;
  /** @default "" */
  resultMessage: string;
  /** @default "" */
  resultDate: string;
}

export interface ShipwareAccessTokenDto {
  accessToken: string;
}

export interface BlobBrowserConnectivityResponseDto {
  url: string;
}

export interface SpendOptimizationSubjectDto {
  id: string;
}

export interface SpendVendorContractDto {
  id: string;
}

export interface SpendItemDto {
  id: string;
  optimizationSubject: SpendOptimizationSubjectDto;
  previousSpend?: object | null;
  nextSpend?: object | null;
  vendorContract?: SpendVendorContractDto | null;
  initiator: SpendInitiator;
  unit?: object | null;
  quantity?: object | null;
  pricePerUnit?: object | null;
  baselineSpend?: object | null;
  occurrenceInterval: OccurrenceInterval;
}

export interface SpendListDto {
  /** Array of items */
  items: SpendItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateSpendDto {
  /** @format uuid */
  optimizationSubjectId: string;
  /** @format uuid */
  vendorContractId?: object | null;
  initiator: SpendInitiator;
  unit?: object | null;
  /** @min 0 */
  quantity?: object | null;
  /** @min 0 */
  pricePerUnit: number;
  /** @format uuid */
  baselineSpendId?: object | null;
  occurrenceInterval: OccurrenceInterval;
}

export interface OptimizationSubjectItemDto {
  id: string;
  organization: PlainDto;
  spendCategory: PlainDto;
}

export interface OptimizationSubjectListDto {
  /** Array of items */
  items: OptimizationSubjectItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateOptimizationSubjectDto {
  /** @format uuid */
  locationId?: object | null;
  /** @format uuid */
  spendCategoryId: string;
}

export interface ContractNegotiationRefDto {
  id: string;
}

export interface ContractNegotiationVendorDto {
  id: string;
  name: string;
}

export interface ContractNegotiationItemDto {
  id: string;
  audit: ContractNegotiationRefDto;
  vendorContract?: ContractNegotiationRefDto | null;
  vendor: ContractNegotiationVendorDto;
  startedAt?: object | null;
  closedAt?: object | null;
  notes?: object | null;
}

export interface ContractNegotiationListDto {
  /** Array of items */
  items: ContractNegotiationItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateContractNegotiationDto {
  /** @format uuid */
  auditId: string;
  /** @format uuid */
  vendorContractId?: object | null;
  /** @format uuid */
  vendorId: string;
  startedAt?: object | null;
  closedAt?: object | null;
  notes?: object | null;
}

export interface InvoiceItemDto {
  id: string;
  value: number;
  issueDate: string;
  billingPeriodFrom: string;
  billingPeriodTo: string;
}

export interface InvoiceListDto {
  /** Array of items */
  items: InvoiceItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateInvoiceDto {
  vendorId: string;
  invoiceNumber: string;
  /** @min 0 */
  value: number;
  issueDate: string;
  billingPeriodFrom: string;
  billingPeriodTo: string;
}

export interface SpendLineItemRefDto {
  id: string;
}

export interface SpendLineItemItemDto {
  id: string;
  spend: SpendLineItemRefDto;
  invoice?: SpendLineItemRefDto | null;
  unit?: object | null;
  quantity?: object | null;
  pricePerUnit?: object | null;
}

export interface SpendLineItemListDto {
  /** Array of items */
  items: SpendLineItemItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateSpendLineItemDto {
  /** @format uuid */
  spendId: string;
  /** @format uuid */
  invoiceId?: object | null;
  unit?: object | null;
  /** @min 0 */
  quantity?: object | null;
  /** @min 0 */
  pricePerUnit: number;
}

export interface VendorContractVendorDto {
  id: string;
  name: string;
}

export interface VendorContractItemDto {
  id: string;
  name: string;
  vendor: VendorContractVendorDto;
  validFrom: string;
  validTo: string;
}

export interface VendorContractListDto {
  /** Array of items */
  items: VendorContractItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateVendorContractDto {
  name: string;
  vendorId: string;
  validFrom: string;
  validTo: string;
}

export interface InvitedUserDto {
  /**
   * User ID (OID)
   * @example "ad8ff82f-9ab9-4009-8364-513c030c83c8"
   */
  oid: string;
  /**
   * User display name
   * @example "John Doe"
   */
  name: string;
  /**
   * User email
   * @format email
   * @example "john.doe@example.com"
   */
  email: string;
  /**
   * User creation timestamp
   * @example "2025-03-21T06:30:15Z"
   */
  createdDateTime: string;
  userLoginStatus: UserLoginStatus;
  organizations: PlainOrganizationDto[];
  userType: UserType;
}

export interface InviteUserBodyDto {
  /** List of emails to invite to the organization */
  emails: string[];
}

export interface EntraUserPartialDto {
  /**
   * User ID (OID)
   * @example "ad8ff82f-9ab9-4009-8364-513c030c83c8"
   */
  oid: string;
  /**
   * User display name
   * @example "John Doe"
   */
  name: string;
  /**
   * User email
   * @format email
   * @example "john.doe@example.com"
   */
  email: string;
  /**
   * User creation timestamp
   * @example "2025-03-21T06:30:15Z"
   */
  createdDateTime: string;
  userLoginStatus: UserLoginStatus;
}

export interface InviteUserResponseDto {
  /** List of successfully invited users */
  success: EntraUserPartialDto[];
  /**
   * List of failed invitations with error messages
   * @example [{"email":"invalid@example.com","error":"Inviting and invited emails must be in the same domain"},{"email":"another@example.com","error":"IDX10612: Decryption failed. Header.Enc is null or empty, it must be specified."}]
   */
  failed: string[];
}

export interface RegisterDeviceTokenDto {
  /**
   * @maxLength 512
   * @example "fMwqR9p0TXa..."
   */
  token: string;
  /** @example "ios" */
  platform: DevicePlatform;
  /**
   * @maxLength 512
   * @example "iPhone 15 Pro"
   */
  deviceName?: string;
}

export interface DeviceTokenDto {
  id: string;
  /** @example "ios" */
  platform: DevicePlatform;
  isActive: boolean;
  /** @format date-time */
  createdAt: string;
  deviceName?: string | null;
  /** @format date-time */
  lastUsedAt?: string | null;
}

export interface UnregisterTokenDto {
  message: string;
}

export interface DeviceTokensListDto {
  /** Array of items */
  items: DeviceTokenDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateReviewDto {
  /**
   * Difficulty level
   * @example "Neutral"
   */
  gettingStarted: Difficulty;
  /**
   * Difficulty level
   * @example "VeryEasy"
   */
  navigationEase: Difficulty;
  improvementSuggestion?: string;
}

export interface TagsListDto {
  /** Array of items */
  items: TagDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateTagDto {
  name: string;
  /**
   * Hexadecimal color value (e.g., #FF0000, #f00)
   * @pattern ^#?([0-9A-F]{3}|[0-9A-F]{4}|[0-9A-F]{6}|[0-9A-F]{8})$
   * @example "#FF0000"
   */
  color?: string;
  isPredefined?: boolean;
}

export interface UpdateTagDto {
  name?: string;
  /**
   * Hexadecimal color value (e.g., #FF0000, #f00)
   * @pattern ^#?([0-9A-F]{3}|[0-9A-F]{4}|[0-9A-F]{6}|[0-9A-F]{8})$
   * @example "#FF0000"
   */
  color?: string;
  isPredefined?: boolean;
}

export interface VendorSelectListItemDto {
  id: string;
  name: string;
}

export interface VendorSelectListDto {
  /** Array of items */
  items: VendorSelectListItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface ServiceCategoryDto {
  id: string;
  categoryName: string;
}

export interface VendorDto {
  id: string;
  salesforceId: string;
  vendorName: string;
  recordType: string;
  serviceCategory?: ServiceCategoryDto;
  pointOfContact?: string;
  pointOfContactDetails?: VendorContactDto;
  subauditId: string;
  contractsCount?: number;
  vectorVendorId?: number;
}

export interface VendorsListDto {
  /** Array of items */
  items: VendorDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface LocationSelectListDto {
  /** Array of items */
  items: LocationSelectListItemDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface DocumentTagsListDto {
  /** Array of items */
  items: DocumentTagDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateDocumentTagDto {
  name: string;
}

export interface UpdateDocumentTagDto {
  name?: string;
}

export interface CreateArchiveDocumentsRequestDto {
  /**
   * Array of document IDs to include in the ZIP archive
   * @minItems 1
   * @uniqueItems true
   * @example ["550e8400-e29b-41d4-a716-446655440000","550e8400-e29b-41d4-a716-446655440001"]
   */
  documentIds: string[];
}

export interface ArchiveDocumentsResponseDto {
  sasUrl: string;
  failedDownloads: FailedDownloadDocumentDto[];
  successDownloadsCount: number;
}

export interface VectorLocationDto {
  id: number;
  name: string;
  address: string;
  city: string;
  state: string;
  zipCode: string;
  status: string;
  savings: number;
  autoPay: boolean;
  cost: number;
  ledgerNo: string | null;
}

export interface VectorLocationListDto {
  /** Array of items */
  items: VectorLocationDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface VectorContractDto {
  id: string;
  negotiationNo: string;
  locationName: string;
  vendorName: string;
  status: VectorApiContractStatus;
  /** @format date-time */
  effectiveDate: string;
  isVetted: boolean;
  fileUrl: string;
}

export interface VectorContractsListDto {
  /** Array of items */
  items: VectorContractDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface UpdateProfilePictureDto {
  /** @format binary */
  file: File;
}

export interface OrganizationUserDto {
  /**
   * User ID
   * @example "ad8ff82f-9ab9-4009-8364-513c030c83c8"
   */
  id: string;
  /**
   * User display name
   * @example "John Doe"
   */
  name: string;
  /**
   * User email
   * @format email
   * @example "john.doe@example.com"
   */
  email: string;
  /** Active (completed) or Inactive (uncompleted — not logged in yet) */
  status: UserLoginStatus;
  /** Organization role: Customer Admin or Common Customer */
  role: OrganizationUserDtoRoleEnum;
  /** User job title */
  title: string | null;
  /**
   * User phone number
   * @example "+1234567890"
   */
  phone: string | null;
  /** Profile picture URL */
  avatarUrl: string | null;
}

export interface OrganizationUsersGroupedDto {
  admins: OrganizationUserDto[];
  standardUsers: OrganizationUserDto[];
}

export interface UpdateUserRoleDto {
  /** The new role to assign */
  role: UpdateUserRoleDtoRoleEnum;
}

export interface CreateTicketCommentExternalDto {
  text: string;
  /**
   * List of external users IDs to notify
   * @uniqueItems true
   */
  notifyUsers?: string[];
}

export interface OrganizationTicketCountDto {
  /** @example "123e4567-e89b-12d3-a456-426614174000" */
  id: string;
  /** @example "Acme Corp" */
  organizationName: string;
  /** @example "Acme Corp" */
  organizationLogoUrl: string;
  ticketCount: number;
}

export interface OrganizationTicketCountListDto {
  items: OrganizationTicketCountDto[];
}

export interface AssigneeTicketGroupingDto {
  id: string;
  name: string;
  email: string;
  ticketCount: number;
  avatarUrl: string | null;
  deletedAt: string | null;
}

export interface AssigneeTicketGroupingListDto {
  /** Array of items */
  items: AssigneeTicketGroupingDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface StatusTicketGroupingDto {
  status: string;
  ticketCount: number;
}

export interface StatusTicketGroupingListDto {
  items: StatusTicketGroupingDto[];
}

export interface CategoryTicketGroupingDto {
  category: string;
  ticketCount: number;
}

export interface CategoryTicketGroupingListDto {
  items: CategoryTicketGroupingDto[];
}

export interface TosContentResponseDto {
  /** Lexical editor richtext document (freeform JSON) */
  tosContent: object;
}

export interface SibContractSpendCategoryDto {
  /**
   * Linked spend category identifier
   * @format uuid
   */
  id: string;
  name: string;
}

export interface SibContractSpendCategoryListDto {
  /** Array of items */
  items: SibContractSpendCategoryDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateSibContractSpendCategoryDto {
  /** @format uuid */
  spendCategoryId: string;
}

export interface SensitiveDocumentsPermissionDto {
  canAccess: boolean;
}

export interface CreateIntegrationTicketDto {
  /**
   * @maxLength 256
   * @example "Invoice mismatch for account 1042"
   */
  subject: string;
  /**
   * @maxLength 1024
   * @example "Invoice #INV-123 does not match the agreed rate card."
   */
  description?: string;
  /** @default "medium" */
  priority?: PriorityLevel;
  /** @default "others" */
  category?: TicketCategory;
  /**
   * If true, ticket is external (accessible to the client organization users). If false, ticket is internal.
   * @default false
   */
  accessToExternalUser?: boolean;
  /**
   * Due date of the ticket
   * @format date-time
   */
  dueDate?: string | null;
  /**
   * @maxLength 255
   * @default null
   */
  city?: string | null;
  /**
   * @maxLength 255
   * @default null
   */
  state?: string | null;
  /**
   * @maxLength 255
   * @default null
   */
  address?: string | null;
  /**
   * @maxLength 255
   * @default null
   */
  zip?: string | null;
}

export interface IntegrationTicketResponseDto {
  /** @format uuid */
  id: string;
  /**
   * Human-readable ticket number
   * @example "T-000123"
   */
  ticketNumber: object | null;
  status: TicketStatus;
  /** @format date-time */
  createdAt: string;
}

export interface MobileVersionsDto {
  /**
   * Minimum supported Android version
   * @example "1.0.0"
   */
  minAndroidVersion: string;
  /**
   * Minimum supported iOS version
   * @example "1.0.0"
   */
  minIosVersion: string;
  /**
   * Latest available Android version
   * @example "2.1.0"
   */
  latestAndroidVersion: string;
  /**
   * Latest available iOS version
   * @example "2.1.0"
   */
  latestIosVersion: string;
}

export interface SibContractPeriodDto {
  /** @format uuid */
  id: string;
  /**
   * Contract ID
   * @format uuid
   */
  contract: string;
  /** Term length */
  term: number | null;
  /** Fee amount */
  fee: number | null;
  order: number;
  updatedAt: string;
  createdAt: string;
  /** Start date of the period */
  startDate: string | null;
}

export interface SibContractDto {
  /** @format uuid */
  id: string;
  /** Contract name from the database. New IP-created contracts are auto-generated as SIB Contract-###### with a 6-digit pad (existing contracts keep their original names). */
  name: string;
  organization: string;
  status: SibContractStatus;
  /** Contingency fee percentage from the latest contract period */
  fee?: number | null;
  /** @format date-time */
  startDate?: string | null;
  /** @format date-time */
  endDate?: string | null;
  /** Contract term in months from the latest contract period */
  termMonths?: number | null;
  autoRenewal: boolean;
  /** @format date-time */
  autoRenewalDate?: string | null;
  auditsCount: number;
  totalContractValue?: number | null;
  /**
   * Latest contract file upload timestamp
   * @format date-time
   */
  uploadDate?: string | null;
  /** SAS URL of the first (oldest) contract file */
  fileUrl?: object | null;
  salesRepresentative?: PlainExternalUserDto | null;
  contractPeriods: SibContractPeriodDto[];
  updatedAt: string;
  createdAt: string;
  salesforceId: string | null;
  salesforceSalesId: string | null;
}

export interface SibContractListDto {
  /** Array of items */
  items: SibContractDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateSibContractDto {
  /**
   * Total Contract Value
   * @min 0
   */
  totalContractValue?: number | null;
  /** @default false */
  autoRenewal?: boolean;
  autoRenewalDate?: object | null;
  /** @format uuid */
  salesRepresentativeId?: object | null;
  /** Spend category IDs to link to this contract on create. */
  spendCategoryIds?: string[];
}

export interface SibContractDetailDto {
  /** @format uuid */
  id: string;
  /** Contract name from the database. New IP-created contracts are auto-generated as SIB Contract-###### with a 6-digit pad (existing contracts keep their original names). */
  name: string;
  organization: string;
  status: SibContractStatus;
  /** Contingency fee percentage from the latest contract period */
  fee?: number | null;
  /** @format date-time */
  startDate?: string | null;
  /** @format date-time */
  endDate?: string | null;
  /** Contract term in months from the latest contract period */
  termMonths?: number | null;
  autoRenewal: boolean;
  /** @format date-time */
  autoRenewalDate?: string | null;
  auditsCount: number;
  totalContractValue?: number | null;
  /**
   * Latest contract file upload timestamp
   * @format date-time
   */
  uploadDate?: string | null;
  /** SAS URL of the first (oldest) contract file */
  fileUrl?: object | null;
  salesRepresentative?: PlainExternalUserDto | null;
  contractPeriods: SibContractPeriodDto[];
  updatedAt: string;
  createdAt: string;
  spendCategories: SpendCategoryListItemDto[];
  files: FileDto[];
  salesforceId: string | null;
  salesforceSalesId: string | null;
}

export interface UpdateSibContractDto {
  /**
   * Total Contract Value
   * @min 0
   */
  totalContractValue?: number | null;
  /** @default false */
  autoRenewal?: boolean;
  autoRenewalDate?: object | null;
  /** @format uuid */
  salesRepresentativeId?: object | null;
  /** Spend category IDs to link to this contract. */
  addSpendCategoryIds?: string[];
  /** Spend category IDs to unlink from this contract. */
  removeSpendCategoryIds?: string[];
}

export interface SibContractPeriodListDto {
  /** Array of items */
  items: SibContractPeriodDto[];
  /** Total number of items */
  totalItems: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  size: number;
  /** Indicates if there is a previous page */
  hasPreviousPage: boolean;
  /** Indicates if there is a next page */
  hasNextPage: boolean;
}

export interface CreateSibContractPeriodDto {
  /** Start date of the period */
  startDate?: string;
  /**
   * Term length in months
   * @min 1
   */
  term?: number;
  /**
   * Fee percentage
   * @min 0
   * @max 100
   */
  fee?: number;
  /**
   * Order/sequence number (cannot be negative). Defaults to the next available order for the contract.
   * @min 0
   */
  order?: number;
}

export interface UpdateSibContractPeriodDto {
  /** Start date of the period */
  startDate?: string;
  /**
   * Term length in months
   * @min 1
   */
  term?: number;
  /**
   * Fee percentage
   * @min 0
   * @max 100
   */
  fee?: number;
  /**
   * Order/sequence number (cannot be negative). Defaults to the next available order for the contract.
   * @min 0
   */
  order?: number;
}

export enum CreateProjectDtoProjectStatusEnum {
  Unassigned = 'unassigned',
  Unstarted = 'unstarted',
  InProgress = 'in-progress',
  OnHold = 'on-hold',
  ViewOnly = 'view-only',
  InReview = 'in-review',
  Escalated = 'escalated',
  Completed = 'completed',
}

export enum UpdateProjectDtoProjectStatusEnum {
  Unassigned = 'unassigned',
  Unstarted = 'unstarted',
  InProgress = 'in-progress',
  OnHold = 'on-hold',
  ViewOnly = 'view-only',
  InReview = 'in-review',
  Escalated = 'escalated',
  Completed = 'completed',
}

export enum TicketCommentDtoSourceEnum {
  Vector = 'vector',
  Spendbrain = 'spendbrain',
}

/** @example "user" */
export enum PreferenceDtoTypeEnum {
  User = 'user',
  Organization = 'organization',
  Global = 'global',
}

/** The status of the location */
export enum LocationDtoStatusEnum {
  Active = 'Active',
  Monitored = 'Monitored',
  Sold = 'Sold',
  Closed = 'Closed',
  UnderConstruction = 'Under Construction',
  NotActive = 'Not Active',
}

export enum LocationDtoSpendAreaStageEnum {
  MONITORING_SAVINGS = 'MONITORING_SAVINGS',
  SAVINGS_REALIZED = 'SAVINGS_REALIZED',
  SPEND_ESTIMATED = 'SPEND_ESTIMATED',
  MOBILIZATION = 'MOBILIZATION',
  NEGOTIATIONS = 'NEGOTIATIONS',
}

/** Status of the document field */
export enum LocationDtoDocumentFieldStatusEnum {
  COMPLETE = 'COMPLETE',
  MISSING_FIELDS = 'MISSING_FIELDS',
  UPLOAD_INVOICES = 'UPLOAD_INVOICES',
  NOT_APPLICABLE_REQUESTED = 'NOT_APPLICABLE_REQUESTED',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
}

export enum LocationDtoRequestedChangeEnum {
  ExcludeFromAudit = 'exclude_from_audit',
  IncludeInAudit = 'include_in_audit',
  ChangeSpendArea = 'change_spend_area',
  Create = 'create',
}

/**
 * The type of action to perform on the locations
 * @example "exclude_from_audit"
 */
export enum LocationActionBodyDtoActionTypeEnum {
  ExcludeFromAudit = 'exclude_from_audit',
  IncludeInAudit = 'include_in_audit',
  ChangeSpendArea = 'change_spend_area',
}

export enum UpdateLocationDtoSpendAreaStageEnum {
  MONITORING_SAVINGS = 'MONITORING_SAVINGS',
  SAVINGS_REALIZED = 'SAVINGS_REALIZED',
  SPEND_ESTIMATED = 'SPEND_ESTIMATED',
  MOBILIZATION = 'MOBILIZATION',
  NEGOTIATIONS = 'NEGOTIATIONS',
}

export enum UpdateLocationDtoDocumentFieldStatusEnum {
  COMPLETE = 'COMPLETE',
  MISSING_FIELDS = 'MISSING_FIELDS',
  UPLOAD_INVOICES = 'UPLOAD_INVOICES',
  NOT_APPLICABLE_REQUESTED = 'NOT_APPLICABLE_REQUESTED',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
}

/** The requested change action, can be one of LocationAction values or an empty string */
export enum UpdateLocationDtoRequestedChangeEnum {
  ExcludeFromAudit = 'exclude_from_audit',
  IncludeInAudit = 'include_in_audit',
  ChangeSpendArea = 'change_spend_area',
  Create = 'create',
}

export enum ApproveInvoicesRequestDtoActionEnum {
  APPROVE = 'APPROVE',
  APPROVE_PARTIAL = 'APPROVE_PARTIAL',
  APPROVE_INDIVIDUAL = 'APPROVE_INDIVIDUAL',
  APPROVE_INDIVIDUAL_PARTIAL = 'APPROVE_INDIVIDUAL_PARTIAL',
}

/** Organization role: Customer Admin or Common Customer */
export enum OrganizationUserDtoRoleEnum {
  CustomerAdmin = 'Customer Admin',
  CommonCustomer = 'Common Customer',
}

/** The new role to assign */
export enum UpdateUserRoleDtoRoleEnum {
  CustomerAdmin = 'Customer Admin',
  CommonCustomer = 'Common Customer',
}

/** @example "user" */
export enum PreferenceControllerUpsertPreferencesParamsTypeEnum {
  User = 'user',
  Organization = 'organization',
  Global = 'global',
}

/** @example "user" */
export enum PreferenceControllerGetPreferencesParamsTypeEnum {
  User = 'user',
  Organization = 'organization',
  Global = 'global',
}

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  'body' | 'method' | 'query' | 'path'
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = 'application/json',
  JsonApi = 'application/vnd.api+json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || '/api',
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem)
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<T> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === 'object'
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== 'string'
    ) {
      body = JSON.stringify(body);
    }

    return this.instance
      .request({
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type ? { 'Content-Type': type } : {}),
        },
        params: query,
        responseType: responseFormat,
        data: body,
        url: path,
      })
      .then(response => response.data);
  };
}

/**
 * @title SIB service
 * @version 1.0
 * @baseUrl /api
 * @contact
 *
 * SIB service API
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  healthCheck = {
    /**
     * No description
     *
     * @tags Health-Check
     * @name ApiControllerHealthCheck
     * @request GET:/health-check
     */
    apiControllerHealthCheck: (params: RequestParams = {}) =>
      this.request<StreamableFile, any>({
        path: `/health-check`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  queues = {
    /**
     * @description Get information about all available queues including job counts
     *
     * @tags Queues
     * @name QueueControllerGetAllQueues
     * @summary List all queues
     * @request GET:/queues
     * @secure
     */
    queueControllerGetAllQueues: (params: RequestParams = {}) =>
      this.request<QueueInfoDto[], void>({
        path: `/queues`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get all jobs (waiting, active, completed, failed, delayed) in a specific queue
     *
     * @tags Queues
     * @name QueueControllerGetQueueJobs
     * @summary List jobs in a queue
     * @request GET:/queues/{queueName}/jobs
     * @secure
     */
    queueControllerGetQueueJobs: (
      queueName: string,
      params: RequestParams = {}
    ) =>
      this.request<ListQueueJobsDto, void>({
        path: `/queues/${queueName}/jobs`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retry a specific failed job in a queue
     *
     * @tags Queues
     * @name QueueControllerRetryJob
     * @summary Retry a failed job
     * @request POST:/queues/{queueName}/jobs/{jobId}/retry
     * @secure
     */
    queueControllerRetryJob: (
      queueName: string,
      jobId: string,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/queues/${queueName}/jobs/${jobId}/retry`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * @description Delete a specific job from a queue
     *
     * @tags Queues
     * @name QueueControllerDeleteJob
     * @summary Delete a job from a queue
     * @request DELETE:/queues/{queueName}/jobs/{jobId}
     * @secure
     */
    queueControllerDeleteJob: (
      queueName: string,
      jobId: string,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/queues/${queueName}/jobs/${jobId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  organization = {
    /**
     * No description
     *
     * @tags Documents
     * @name DocumentControllerBulkUpdate
     * @request PATCH:/organization/{organizationId}/document/bulk-update
     * @secure
     */
    documentControllerBulkUpdate: (
      organizationId: string,
      data: BulkUpdateDocumentDto,
      params: RequestParams = {}
    ) =>
      this.request<DocumentDto[], void>({
        path: `/organization/${organizationId}/document/bulk-update`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentControllerGetUploadUrl
     * @summary Use POST /upload with multipart streaming instead.
     * @request POST:/organization/{organizationId}/document/upload-url
     * @deprecated
     * @secure
     */
    documentControllerGetUploadUrl: (
      organizationId: string,
      data: BulkGenerateUploadUrlDto,
      params: RequestParams = {}
    ) =>
      this.request<BulkGenerateUploadUrlResponseDto, void>({
        path: `/organization/${organizationId}/document/upload-url`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentControllerInitUploadSession
     * @summary Initialize a direct-to-Azure upload session (metadata only). Supports both chunked (Put Block) and single-blob (Put Blob) uploads via the returned SAS URL.
     * @request POST:/organization/{organizationId}/document/upload/init
     * @secure
     */
    documentControllerInitUploadSession: (
      organizationId: string,
      data: InitUploadDocumentsDto,
      params: RequestParams = {}
    ) =>
      this.request<InitUploadDocumentsResponseDto, void>({
        path: `/organization/${organizationId}/document/upload/init`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentControllerCompleteUploadSession
     * @summary Finalize an upload: commit staged blocks (chunked) or verify an already-committed blob (single-blob, when blockIds is omitted)
     * @request POST:/organization/{organizationId}/document/upload/complete
     * @secure
     */
    documentControllerCompleteUploadSession: (
      organizationId: string,
      data: CompleteUploadDocumentDto,
      params: RequestParams = {}
    ) =>
      this.request<DocumentDto, void>({
        path: `/organization/${organizationId}/document/upload/complete`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentControllerUploadFile
     * @summary Deprecated: use POST /upload/init + direct Azure blocks + POST /upload/complete instead.
     * @request POST:/organization/{organizationId}/document/upload
     * @deprecated
     * @secure
     */
    documentControllerUploadFile: (
      organizationId: string,
      data: UploadDocumentDto,
      params: RequestParams = {}
    ) =>
      this.request<DocumentDto, void>({
        path: `/organization/${organizationId}/document/upload`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentControllerPostprocessUploadedFile
     * @summary No longer required when uploading via POST /upload. Kept for SAS URL uploads.
     * @request POST:/organization/{organizationId}/document/postprocess
     * @deprecated
     * @secure
     */
    documentControllerPostprocessUploadedFile: (
      organizationId: string,
      data: PostprocessUploadedDocumentDto,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/organization/${organizationId}/document/postprocess`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentControllerGetAllDocuments
     * @request GET:/organization/{organizationId}/document
     * @secure
     */
    documentControllerGetAllDocuments: (
      organizationId: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - stage
         * - vendor
         * - name
         * - createdAt
         * - updatedAt
         * - providedBy
         * - type
         * - spendCategory
         * - id
         * - uploadedBy
         * - startDate
         * - endDate
         * - renewalDate
         * - annualContractValue
         * - notToExceed
         * - annualPriceIncrease
         * - earlyTerminationFee
         * - contractType
         * - additionalColumns.key
         * - categoryManager
         * - categoryManagerUser
         * - paymentFrequency
         * - cancellationDateNoticePeriod
         * - autoRenewalClause
         * - autoRenewalLength
         * - notToExceedPercentage
         * - anomaly
         * - matchingDocuments
         * - hasVirtualInvoices
         * - sensitive
         * - tags
         * - subsidiaryOrganizationName
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | stage                        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | vendor                       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | name                         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | createdAt                    | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | updatedAt                    | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | providedBy                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | type                         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | spendCategory                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | id                           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | uploadedBy                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | startDate                    | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | endDate                      | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | renewalDate                  | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | annualContractValue          | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty |  |
         * | notToExceed                  | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty |  |
         * | annualPriceIncrease          | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty |  |
         * | earlyTerminationFee          | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty |  |
         * | contractType                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | additionalColumns.key        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | categoryManager              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | categoryManagerUser          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | paymentFrequency             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | cancellationDateNoticePeriod | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | autoRenewalClause            | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty |  |
         * | autoRenewalLength            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | notToExceedPercentage        | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty |  |
         * | anomaly                      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | matchingDocuments            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | tags                         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | sensitive                    | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty |  |
         * | hasVirtualInvoices           | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty |  |
         * | subsidiaryOrganizationName   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /** Searching by: tag.name, filename */
        searchTerm?: string;
        /** Filters contracts by active status. A contract is active when current date is between startDate and endDate. If startDate is undefined, only checks currentDate <= endDate. If endDate is undefined, only checks currentDate >= startDate. If both are undefined, the contract is included. */
        isContractActive?: boolean;
        /** Excludes documents matching the given type (e.g. "Invoice"), including documents with null type in the results. */
        excludeType?: string;
        /** When true for parent organizations, includes documents from subsidiaries in list results. */
        withSubsidiaries?: boolean;
      },
      params: RequestParams = {}
    ) =>
      this.request<DocumentListDto, void>({
        path: `/organization/${organizationId}/document`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentControllerExportDocuments
     * @request GET:/organization/{organizationId}/document/export
     * @secure
     */
    documentControllerExportDocuments: (
      organizationId: string,
      query: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - stage
         * - vendor
         * - name
         * - createdAt
         * - updatedAt
         * - providedBy
         * - type
         * - spendCategory
         * - id
         * - uploadedBy
         * - startDate
         * - endDate
         * - renewalDate
         * - annualContractValue
         * - notToExceed
         * - annualPriceIncrease
         * - earlyTerminationFee
         * - contractType
         * - additionalColumns.key
         * - categoryManager
         * - categoryManagerUser
         * - paymentFrequency
         * - cancellationDateNoticePeriod
         * - autoRenewalClause
         * - autoRenewalLength
         * - notToExceedPercentage
         * - anomaly
         * - matchingDocuments
         * - hasVirtualInvoices
         * - sensitive
         * - tags
         * - subsidiaryOrganizationName
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | stage                        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | vendor                       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | name                         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | createdAt                    | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | updatedAt                    | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | providedBy                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | type                         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | spendCategory                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | id                           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | uploadedBy                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | startDate                    | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | endDate                      | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | renewalDate                  | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | annualContractValue          | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty |  |
         * | notToExceed                  | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty |  |
         * | annualPriceIncrease          | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty |  |
         * | earlyTerminationFee          | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty |  |
         * | contractType                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | additionalColumns.key        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | categoryManager              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | categoryManagerUser          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | paymentFrequency             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | cancellationDateNoticePeriod | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | autoRenewalClause            | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty |  |
         * | autoRenewalLength            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | notToExceedPercentage        | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty |  |
         * | anomaly                      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | matchingDocuments            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | tags                         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | sensitive                    | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty |  |
         * | hasVirtualInvoices           | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty |  |
         * | subsidiaryOrganizationName   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /** Searching by: tag.name, filename */
        searchTerm?: string;
        /** Filters contracts by active status. A contract is active when current date is between startDate and endDate. If startDate is undefined, only checks currentDate <= endDate. If endDate is undefined, only checks currentDate >= startDate. If both are undefined, the contract is included. */
        isContractActive?: boolean;
        /** Excludes documents matching the given type (e.g. "Invoice"), including documents with null type in the results. */
        excludeType?: string;
        /** When true for parent organizations, includes documents from subsidiaries in list results. */
        withSubsidiaries?: boolean;
        /** JSON array of column paths. Headers are auto-generated from keys. Example: ["name","status"] */
        columns: string;
        /** Custom filename for the CSV download (without extension). */
        filename?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<StreamableFile, void>({
        path: `/organization/${organizationId}/document/export`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentControllerGetColumnMaxValues
     * @request GET:/organization/{organizationId}/document/column-max-values
     * @secure
     */
    documentControllerGetColumnMaxValues: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<DocumentColumnMaxValuesDto, void>({
        path: `/organization/${organizationId}/document/column-max-values`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentControllerCheckContentHash
     * @summary Check whether uploaded document content already exists by MD5 hashes
     * @request POST:/organization/{organizationId}/document/check-content-hash
     * @secure
     */
    documentControllerCheckContentHash: (
      organizationId: string,
      data: CheckDocumentContentHashQueryDto,
      params: RequestParams = {}
    ) =>
      this.request<CheckDocumentContentHashResponseDto, void>({
        path: `/organization/${organizationId}/document/check-content-hash`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentControllerGetVirtualInvoices
     * @request GET:/organization/{organizationId}/document/{id}/virtual-invoices
     * @secure
     */
    documentControllerGetVirtualInvoices: (
      id: string,
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - franzDocId
         * - name
         * - type
         * - subsidiary
         * - vendor
         * - providedBy
         * - stage
         * - categoryManagerUser
         * - paymentFrequency
         * - spendCategory
         * - startDate
         * - endDate
         * - renewalDate
         * - annualContractValue
         * - notToExceed
         * - annualPriceIncrease
         * - earlyTerminationFee
         * - contractType
         * - cancellationDateNoticePeriod
         * - autoRenewalClause
         * - autoRenewalLength
         * - notToExceedPercentage
         * - anomaly
         * - matchingDocuments
         * - createdAt
         * - updatedAt
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                          | Type                     | Allowed Rules                                                                | Possible Values                                                                                            |
         * | ---------------------------- | ------------------------ | ---------------------------------------------------------------------------- | ---------------------------------------------------------------------------------------------------------- |
         * | id                           | string                   | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                            |
         * | franzDocId                   | string                   | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                            |
         * | name                         | string                   | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                            |
         * | type                         | string                   | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                            |
         * | subsidiary                   | string                   | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                            |
         * | vendor                       | string                   | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                            |
         * | providedBy                   | object                   |                                                                              | client, sib, vector                                                                                        |
         * | stage                        | object                   |                                                                              | uploaded, in-progress, action-needed, approved, rejected, expired                                          |
         * | categoryManagerUser          | plainexternaluserdto     |                                                                              |                                                                                                            |
         * | paymentFrequency             | object                   |                                                                              | Monthly, Quarterly, Annually, Semi-Annual                                                                  |
         * | spendCategory                | spendcategorylistitemdto |                                                                              |                                                                                                            |
         * | startDate                    | date                     | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                                                                                                            |
         * | endDate                      | date                     | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                                                                                                            |
         * | renewalDate                  | date                     | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                                                                                                            |
         * | annualContractValue          | number                   | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                            |
         * | notToExceed                  | boolean                  | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                                                                            |
         * | annualPriceIncrease          | boolean                  | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                                                                            |
         * | earlyTerminationFee          | boolean                  | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                                                                            |
         * | contractType                 | object                   |                                                                              | MSA, SOW, Amendment, Addendum, Order Form, End User License Agreement, NDA, Data Security Agreement, Other |
         * | cancellationDateNoticePeriod | string                   | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                            |
         * | autoRenewalClause            | boolean                  | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                                                                            |
         * | autoRenewalLength            | string                   | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                            |
         * | notToExceedPercentage        | number                   | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                            |
         * | anomaly                      | boolean                  | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                                                                            |
         * | matchingDocuments            | number                   | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                            |
         * | createdAt                    | date                     | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                                                                                                            |
         * | updatedAt                    | date                     | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                                                                                                            |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<VirtualDocumentListDto, void>({
        path: `/organization/${organizationId}/document/${id}/virtual-invoices`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentControllerGetOneDocument
     * @request GET:/organization/{organizationId}/document/{id}
     * @secure
     */
    documentControllerGetOneDocument: (
      id: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<DocumentDto, void>({
        path: `/organization/${organizationId}/document/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentControllerDeleteDocuement
     * @request DELETE:/organization/{organizationId}/document/{id}
     * @secure
     */
    documentControllerDeleteDocuement: (
      id: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<string, void>({
        path: `/organization/${organizationId}/document/${id}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentControllerUpdate
     * @request PATCH:/organization/{organizationId}/document/{id}
     * @secure
     */
    documentControllerUpdate: (
      id: string,
      organizationId: string,
      data: UpdateDocumentDto,
      params: RequestParams = {}
    ) =>
      this.request<DocumentDto, void>({
        path: `/organization/${organizationId}/document/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentControllerGetUploadStatus
     * @request GET:/organization/{organizationId}/document/batch/{batchId}/status
     * @secure
     */
    documentControllerGetUploadStatus: (
      organizationId: string,
      batchId: string,
      params: RequestParams = {}
    ) =>
      this.request<DocumentUploadStatusListDto, void>({
        path: `/organization/${organizationId}/document/batch/${batchId}/status`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentControllerGetDocumentTypeSelectList
     * @request GET:/organization/{organizationId}/document/select-list/document-types
     * @secure
     */
    documentControllerGetDocumentTypeSelectList: (
      organizationId: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - id
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | name | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | id   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         *
         *
         *
         *
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<SelectListDto, void>({
        path: `/organization/${organizationId}/document/select-list/document-types`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentControllerGetVendorSelectList
     * @request GET:/organization/{organizationId}/document/select-list/vendors
     * @secure
     */
    documentControllerGetVendorSelectList: (
      organizationId: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - id
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | name | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | id   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         *
         *
         *
         *
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<SelectListDto, void>({
        path: `/organization/${organizationId}/document/select-list/vendors`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentControllerGetCategoryManagerSelectList
     * @request GET:/organization/{organizationId}/document/select-list/category-managers
     * @secure
     */
    documentControllerGetCategoryManagerSelectList: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SelectListDto, void>({
        path: `/organization/${organizationId}/document/select-list/category-managers`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization
     * @name OrganizationControllerGetOrganizationById
     * @request GET:/organization/{organizationId}
     * @secure
     */
    organizationControllerGetOrganizationById: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<OrganizationDto, void>({
        path: `/organization/${organizationId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization
     * @name OrganizationControllerAcceptMicrositeTermsOfService
     * @request POST:/organization/{organizationId}/terms-of-service/accept
     * @secure
     */
    organizationControllerAcceptMicrositeTermsOfService: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<OrganizationDto, void>({
        path: `/organization/${organizationId}/terms-of-service/accept`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization
     * @name OrganizationControllerGetYourTeam
     * @request GET:/organization/{organizationId}/your-team
     * @secure
     */
    organizationControllerGetYourTeam: (
      organizationId: string,
      query?: {
        billingContactProvider?: BillingInvoiceContactCompany;
      },
      params: RequestParams = {}
    ) =>
      this.request<YourTeamDto, void>({
        path: `/organization/${organizationId}/your-team`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization
     * @name OrganizationControllerFindAllTasks
     * @request GET:/organization/{organizationId}/tasks
     * @secure
     */
    organizationControllerFindAllTasks: (
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - title
         * - description
         * - completed
         * - priorityLevel
         * - createdAt
         * - updatedAt
         * - deadline
         * - completedAt
         * - timeLogged
         * - estimatedTime
         * - category
         * - referenceLink
         * - referenceName
         * - organizationId
         * - vendorId
         * - seenAt
         * - seen
         * - taskTags.tag.name
         * - taskTags.tag.color
         * - taskTags.tag.createdBy
         * - taskTags.contactId
         * - taskTags.employeeId
         * - taskTags.type
         * - assignee
         * - subauditId
         * - projectId
         * - ticketId
         * - commentsCount
         * - unfinishedSubtasksCount
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                     | Type    | Allowed Rules                                                                | Possible Values |
         * | ----------------------- | ------- | ---------------------------------------------------------------------------- | --------------- |
         * | id                      | object  |                                                                              |                 |
         * | title                   | object  |                                                                              |                 |
         * | description             | object  |                                                                              |                 |
         * | completed               | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | priorityLevel           | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdAt               | object  |                                                                              |                 |
         * | updatedAt               | object  |                                                                              |                 |
         * | deadline                | object  |                                                                              |                 |
         * | completedAt             | object  |                                                                              |                 |
         * | timeLogged              | object  |                                                                              |                 |
         * | estimatedTime           | object  |                                                                              |                 |
         * | category                | object  |                                                                              |                 |
         * | referenceLink           | object  |                                                                              |                 |
         * | referenceName           | object  |                                                                              |                 |
         * | organizationId          | object  |                                                                              |                 |
         * | vendorId                | object  |                                                                              |                 |
         * | seenAt                  | object  |                                                                              |                 |
         * | seen                    | object  |                                                                              |                 |
         * | taskTags.tag.name       | object  |                                                                              |                 |
         * | taskTags.tag.color      | object  |                                                                              |                 |
         * | taskTags.tag.createdBy  | object  |                                                                              |                 |
         * | taskTags.contactId      | object  |                                                                              |                 |
         * | taskTags.employeeId     | object  |                                                                              |                 |
         * | taskTags.type           | object  |                                                                              |                 |
         * | assignee                | object  |                                                                              |                 |
         * | subauditId              | object  |                                                                              |                 |
         * | projectId               | object  |                                                                              |                 |
         * | ticketId                | object  |                                                                              |                 |
         * | commentsCount           | object  |                                                                              |                 |
         * | unfinishedSubtasksCount | object  |                                                                              |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - title
         * - description
         * - category
         * - assignee.name
         * - assignee.emailAddress
         * - createdBy.name
         * - createdBy.emailAddress
         * - subtasks.title
         * - subtasks.description
         * - taskTagss.tag.name
         * - taskTagss.contact.name
         * - taskTagss.employee.name
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<TaskListDto, void>({
        path: `/organization/${organizationId}/tasks`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization
     * @name OrganizationControllerFindAllUsers
     * @request GET:/organization/{organizationId}/users
     * @secure
     */
    organizationControllerFindAllUsers: (
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - email
         * - deletedAt
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key       | Type   | Allowed Rules                                                                | Possible Values |
         * | --------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | email     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | deletedAt | object |                                                                              |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         * - emailAddress
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<ExternalUserPartialListDto, void>({
        path: `/organization/${organizationId}/users`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization
     * @name OrganizationControllerFindAllowedDomains
     * @request GET:/organization/{organizationId}/allowed-domains
     * @secure
     */
    organizationControllerFindAllowedDomains: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<AllowedDomainListDto, void>({
        path: `/organization/${organizationId}/allowed-domains`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization
     * @name OrganizationControllerGetAllSpendCategoriesDeprecated
     * @summary Use GET /spend-categories instead
     * @request GET:/organization/{organizationId}/spend-categories
     * @deprecated
     * @secure
     */
    organizationControllerGetAllSpendCategoriesDeprecated: (
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - spendAreaId
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type   | Allowed Rules                                                                | Possible Values |
         * | ----------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | spendAreaId | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<SpendCategoryListDto, void>({
        path: `/organization/${organizationId}/spend-categories`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization
     * @name OrganizationControllerGetAdditionalColumns
     * @request GET:/organization/{organizationId}/additional-columns/{tableName}
     * @secure
     */
    organizationControllerGetAdditionalColumns: (
      tableName: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<AdditionalColumnsListDto, void>({
        path: `/organization/${organizationId}/additional-columns/${tableName}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contacts
     * @name OrganizationContactsControllerGetOrganizationContacts
     * @request GET:/organization/{organizationId}/contacts
     * @secure
     */
    organizationContactsControllerGetOrganizationContacts: (
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - email
         * - firstName
         * - lastName
         * - title
         * - isActive
         * - phoneNumber
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type    | Allowed Rules                                                                | Possible Values |
         * | ----------- | ------- | ---------------------------------------------------------------------------- | --------------- |
         * | id          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | email       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | firstName   | object  |                                                                              |                 |
         * | lastName    | object  |                                                                              |                 |
         * | title       | object  |                                                                              |                 |
         * | isActive    | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | phoneNumber | object  |                                                                              |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         * - email
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<ContactsListDto, void>({
        path: `/organization/${organizationId}/contacts`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contacts
     * @name OrganizationContactsControllerGetAllVendorContactsOfOrganization
     * @request GET:/organization/{organizationId}/contacts/vendors
     * @secure
     */
    organizationContactsControllerGetAllVendorContactsOfOrganization: (
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - email
         * - firstName
         * - lastName
         * - title
         * - isActive
         * - phoneNumber
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type    | Allowed Rules                                                                | Possible Values |
         * | ----------- | ------- | ---------------------------------------------------------------------------- | --------------- |
         * | id          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | email       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | firstName   | object  |                                                                              |                 |
         * | lastName    | object  |                                                                              |                 |
         * | title       | object  |                                                                              |                 |
         * | isActive    | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | phoneNumber | object  |                                                                              |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         * - email
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<VendorContactsListDto, void>({
        path: `/organization/${organizationId}/contacts/vendors`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subaudits
     * @name SubauditsControllerFindAll
     * @request GET:/organization/{organizationId}/subaudits
     * @secure
     */
    subauditsControllerFindAll: (
      organizationId: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - spendAmount
         * - subauditStage
         * - vendorAccountNumber
         * - createdAt
         * - updatedAt
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | id                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | createdAt           | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | updatedAt           | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | spendAmount         | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty |  |
         * | subauditStage       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | vendorAccountNumber | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | onHold              | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /** Search by subaudit name or related fields */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<SubauditsListDto, void>({
        path: `/organization/${organizationId}/subaudits`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subaudits
     * @name SubauditsControllerCreate
     * @request POST:/organization/{organizationId}/subaudits
     * @secure
     */
    subauditsControllerCreate: (
      organizationId: string,
      data: CreateSubauditDto,
      params: RequestParams = {}
    ) =>
      this.request<SubauditDto, void>({
        path: `/organization/${organizationId}/subaudits`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subaudits
     * @name SubauditsControllerUpdate
     * @request PATCH:/organization/{organizationId}/subaudits/{id}
     * @secure
     */
    subauditsControllerUpdate: (
      organizationId: string,
      id: string,
      data: UpdateSubauditDto,
      params: RequestParams = {}
    ) =>
      this.request<SubauditDto, void>({
        path: `/organization/${organizationId}/subaudits/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subaudits
     * @name SubauditsControllerFindOne
     * @request GET:/organization/{organizationId}/subaudits/{id}
     * @secure
     */
    subauditsControllerFindOne: (
      organizationId: string,
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<SubauditDto, void>({
        path: `/organization/${organizationId}/subaudits/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subaudits
     * @name SubauditsControllerDeleteOne
     * @request DELETE:/organization/{organizationId}/subaudits/{id}
     * @secure
     */
    subauditsControllerDeleteOne: (
      organizationId: string,
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<SubauditDto, void>({
        path: `/organization/${organizationId}/subaudits/${id}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SubauditComments
     * @name SubauditCommentsControllerGetSubauditComments
     * @request GET:/organization/{organizationId}/subaudit/{subauditId}/comments
     * @secure
     */
    subauditCommentsControllerGetSubauditComments: (
      subauditId: string,
      organizationId: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - createdAt
         * - topic
         * - content
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | id        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | content   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | topic     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | createdAt | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | updatedAt | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<SubauditCommentListDto, void>({
        path: `/organization/${organizationId}/subaudit/${subauditId}/comments`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SubauditComments
     * @name SubauditCommentsControllerCreateSubauditComment
     * @request POST:/organization/{organizationId}/subaudit/{subauditId}/comments
     * @secure
     */
    subauditCommentsControllerCreateSubauditComment: (
      subauditId: string,
      organizationId: string,
      data: CreateSubauditCommentDto,
      params: RequestParams = {}
    ) =>
      this.request<SubauditCommentDto, void>({
        path: `/organization/${organizationId}/subaudit/${subauditId}/comments`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SubauditComments
     * @name SubauditCommentsControllerGetSubauditComment
     * @request GET:/organization/{organizationId}/subaudit/{subauditId}/comments/{commentId}
     * @secure
     */
    subauditCommentsControllerGetSubauditComment: (
      subauditId: string,
      commentId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SubauditCommentDto, void>({
        path: `/organization/${organizationId}/subaudit/${subauditId}/comments/${commentId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SubauditComments
     * @name SubauditCommentsControllerUpdateSubauditComment
     * @request PATCH:/organization/{organizationId}/subaudit/{subauditId}/comments/{commentId}
     * @secure
     */
    subauditCommentsControllerUpdateSubauditComment: (
      subauditId: string,
      commentId: string,
      organizationId: string,
      data: UpdateSubauditCommentDto,
      params: RequestParams = {}
    ) =>
      this.request<SubauditCommentDto, void>({
        path: `/organization/${organizationId}/subaudit/${subauditId}/comments/${commentId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SubauditComments
     * @name SubauditCommentsControllerDeleteSubauditComment
     * @request DELETE:/organization/{organizationId}/subaudit/{subauditId}/comments/{commentId}
     * @secure
     */
    subauditCommentsControllerDeleteSubauditComment: (
      subauditId: string,
      commentId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SubauditCommentDto, void>({
        path: `/organization/${organizationId}/subaudit/${subauditId}/comments/${commentId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Action Item
     * @name ActionItemControllerFindAllActionItems
     * @request GET:/organization/{organizationId}/action-items
     * @secure
     */
    actionItemControllerFindAllActionItems: (
      organizationId: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - title
         * - description
         * - deadline
         * - completedAt
         * - spendAreaStage
         * - priorityLevel
         * - actionType
         * - createdAt
         * - updatedAt
         * - createdBy
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | title          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | description    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | deadline       | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | completedAt    | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | spendAreaStage | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | priorityLevel  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | actionType     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | createdAt      | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | updatedAt      | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | createdBy      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<ActionItemListDto, void>({
        path: `/organization/${organizationId}/action-items`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Action Item
     * @name ActionItemControllerCreateActionItem
     * @request POST:/organization/{organizationId}/action-items
     * @secure
     */
    actionItemControllerCreateActionItem: (
      organizationId: string,
      data: CreateActionItemDto,
      params: RequestParams = {}
    ) =>
      this.request<ActionItemDto, void>({
        path: `/organization/${organizationId}/action-items`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Action Item
     * @name ActionItemControllerFindOneActionItems
     * @request GET:/organization/{organizationId}/action-items/{actionItemId}
     * @secure
     */
    actionItemControllerFindOneActionItems: (
      actionItemId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<ActionItemDto, void>({
        path: `/organization/${organizationId}/action-items/${actionItemId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Action Item
     * @name ActionItemControllerUpdateActionItem
     * @request PATCH:/organization/{organizationId}/action-items/{actionItemId}
     * @secure
     */
    actionItemControllerUpdateActionItem: (
      organizationId: string,
      actionItemId: string,
      data: UpdateActionItemDto,
      params: RequestParams = {}
    ) =>
      this.request<ActionItemDto, void>({
        path: `/organization/${organizationId}/action-items/${actionItemId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Action Item
     * @name ActionItemControllerDeleteActionItem
     * @request DELETE:/organization/{organizationId}/action-items/{actionItemId}
     * @secure
     */
    actionItemControllerDeleteActionItem: (
      actionItemId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<ActionItemDto, void>({
        path: `/organization/${organizationId}/action-items/${actionItemId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Request Spend Area
     * @name RequestSpendAreaControllerCreateRequestedSpendArea
     * @request POST:/organization/{organizationId}/request-spend-areas/{spendAreaId}
     * @secure
     */
    requestSpendAreaControllerCreateRequestedSpendArea: (
      organizationId: string,
      spendAreaId: string,
      params: RequestParams = {}
    ) =>
      this.request<any, void | RequestSpendAreaResponseDto>({
        path: `/organization/${organizationId}/request-spend-areas/${spendAreaId}`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Request Spend Area
     * @name RequestSpendAreaControllerCreateManyRequestedSpendArea
     * @request POST:/organization/{organizationId}/request-spend-areas
     * @secure
     */
    requestSpendAreaControllerCreateManyRequestedSpendArea: (
      organizationId: string,
      data: RequestSpendAreaBodyDto,
      params: RequestParams = {}
    ) =>
      this.request<any, void | RequestSpendAreaResponseDto>({
        path: `/organization/${organizationId}/request-spend-areas`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChildOrganization
     * @name ChildOrganizationControllerGetChildrenOrganizations
     * @request GET:/organization/{organizationId}/child-organizations
     * @secure
     */
    childOrganizationControllerGetChildrenOrganizations: (
      organizationId: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - id
         * - createdAt
         * - updatedAt
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | id                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | name              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | createdAt         | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | updatedAt         | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | micrositesEnabled | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<ChildOrganizationListDto, void>({
        path: `/organization/${organizationId}/child-organizations`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billings
     * @name BillingsControllerGetInvoiceFile
     * @request GET:/organization/{organizationId}/billings/netsuite/invoices/{invoiceId}/file
     * @secure
     */
    billingsControllerGetInvoiceFile: (
      invoiceId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/organization/${organizationId}/billings/netsuite/invoices/${invoiceId}/file`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billings
     * @name BillingsControllerGetNetsuiteInvoiceById
     * @request GET:/organization/{organizationId}/billings/netsuite/invoices/{invoiceId}
     * @secure
     */
    billingsControllerGetNetsuiteInvoiceById: (
      invoiceId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<NetsuiteInvoiceDto, void>({
        path: `/organization/${organizationId}/billings/netsuite/invoices/${invoiceId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billings
     * @name BillingsControllerGetInvoiceNetsuiteSummary
     * @request GET:/organization/{organizationId}/billings/netsuite/summary
     * @secure
     */
    billingsControllerGetInvoiceNetsuiteSummary: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<InvoiceSummaryDto, void>({
        path: `/organization/${organizationId}/billings/netsuite/summary`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billings
     * @name BillingsControllerExportNetsuiteInvoices
     * @request GET:/organization/{organizationId}/billings/netsuite/export
     * @secure
     */
    billingsControllerExportNetsuiteInvoices: (
      organizationId: string,
      query: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - invoiceNumber
         * - date
         * - dueDate
         * - amount
         * - balance
         * - status
         * - locationId
         * - locationName
         * - accountNumber
         * - vendorName
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | dueDate       | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | status        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | paid, unpaid, partially-paid |
         * | date          | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | vendorName    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | invoiceNumber | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | paymentAmount | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty |  |
         * | balance       | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /** JSON array of column paths. Headers are auto-generated from keys. Example: ["name","status"] */
        columns: string;
        /** Custom filename for the CSV download (without extension). */
        filename?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<StreamableFile, void>({
        path: `/organization/${organizationId}/billings/netsuite/export`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billings
     * @name BillingsControllerGetInvoiceNetsuite
     * @request GET:/organization/{organizationId}/billings/netsuite
     * @secure
     */
    billingsControllerGetInvoiceNetsuite: (
      organizationId: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - invoiceNumber
         * - date
         * - dueDate
         * - amount
         * - balance
         * - status
         * - locationId
         * - locationName
         * - accountNumber
         * - vendorName
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | dueDate       | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | status        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | paid, unpaid, partially-paid |
         * | date          | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | vendorName    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | invoiceNumber | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | paymentAmount | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty |  |
         * | balance       | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        columns?: string;
        filename?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<NetsuiteInvoiceListDto, void>({
        path: `/organization/${organizationId}/billings/netsuite`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billings
     * @name BillingsControllerGetInvoiceVectorSummary
     * @request GET:/organization/{organizationId}/billings/vector/summary
     * @secure
     */
    billingsControllerGetInvoiceVectorSummary: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<InvoiceSummaryDto, void>({
        path: `/organization/${organizationId}/billings/vector/summary`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billings
     * @name BillingsControllerExportVectorInvoices
     * @request GET:/organization/{organizationId}/billings/vector/export
     * @secure
     */
    billingsControllerExportVectorInvoices: (
      organizationId: string,
      query: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - invoiceNumber
         * - date
         * - dueDate
         * - amount
         * - balance
         * - status
         * - locationId
         * - locationName
         * - accountNumber
         * - vendorName
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | dueDate       | date | between |  |
         * | status        | string | eq,in | paid, unpaid, partially-paid |
         * | date          | date | between |  |
         * | vendorName    | string | like |  |
         * | invoiceNumber | string | like |  |
         * | paymentAmount | number | eq,between |  |
         * | balance       | number | eq,between |  |
         * | locationName  | string | like |  |
         * | locationId    | number | eq |  |
         * | accountNumber | string | like |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /** JSON array of column paths. Headers are auto-generated from keys. Example: ["name","status"] */
        columns: string;
        /** Custom filename for the CSV download (without extension). */
        filename?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<StreamableFile, void>({
        path: `/organization/${organizationId}/billings/vector/export`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billings
     * @name BillingsControllerGetInvoice
     * @request GET:/organization/{organizationId}/billings/vector
     * @secure
     */
    billingsControllerGetInvoice: (
      organizationId: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - invoiceNumber
         * - date
         * - dueDate
         * - amount
         * - balance
         * - status
         * - locationId
         * - locationName
         * - accountNumber
         * - vendorName
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | dueDate       | date | between |  |
         * | status        | string | eq,in | paid, unpaid, partially-paid |
         * | date          | date | between |  |
         * | vendorName    | string | like |  |
         * | invoiceNumber | string | like |  |
         * | paymentAmount | number | eq,between |  |
         * | balance       | number | eq,between |  |
         * | locationName  | string | like |  |
         * | locationId    | number | eq |  |
         * | accountNumber | string | like |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        columns?: string;
        filename?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<VectorInvoiceListResponseDto, void>({
        path: `/organization/${organizationId}/billings/vector`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billings
     * @name BillingsControllerCreateZipJobForBillingsNetsuite
     * @request POST:/organization/{organizationId}/billings/netsuite/zip
     * @secure
     */
    billingsControllerCreateZipJobForBillingsNetsuite: (
      organizationId: string,
      data: CreateZipNetsuiteRequestDto,
      params: RequestParams = {}
    ) =>
      this.request<CreateBillingsZipResponseDto, void>({
        path: `/organization/${organizationId}/billings/netsuite/zip`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billings
     * @name BillingsControllerGetInvoiceFileById
     * @request GET:/organization/{organizationId}/billings/netsuite/invoices/{invoiceId}/files/{fileId}
     * @secure
     */
    billingsControllerGetInvoiceFileById: (
      invoiceId: string,
      fileId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<StreamableFile, void>({
        path: `/organization/${organizationId}/billings/netsuite/invoices/${invoiceId}/files/${fileId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billings
     * @name BillingsControllerCreateZipJobForBillingsVector
     * @request POST:/organization/{organizationId}/billings/vector/zip
     * @secure
     */
    billingsControllerCreateZipJobForBillingsVector: (
      organizationId: string,
      data: CreateZipVectorRequestDto,
      params: RequestParams = {}
    ) =>
      this.request<CreateBillingsZipResponseDto, void>({
        path: `/organization/${organizationId}/billings/vector/zip`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ParcelPay
     * @name ParcelPayControllerGetInvoices
     * @request GET:/organization/{organizationId}/parcel-pay/invoices
     * @secure
     */
    parcelPayControllerGetInvoices: (
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - carrier
         * - status
         * - invoiceNo
         * - accountNumber
         * - invoiceDate
         * - dueDate
         * - netCharge
         * - paymentDate
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key           | Type   | Allowed Rules                                                                | Possible Values |
         * | ------------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | carrier       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | status        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | invoiceNo     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | accountNumber | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | invoiceDate   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | dueDate       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | netCharge     | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | paymentDate   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<ParcelPayInvoiceListDto, void>({
        path: `/organization/${organizationId}/parcel-pay/invoices`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ParcelPay
     * @name ParcelPayControllerApproveInvoices
     * @request POST:/organization/{organizationId}/parcel-pay/invoices/approve
     * @secure
     */
    parcelPayControllerApproveInvoices: (
      organizationId: string,
      data: ApproveInvoicesRequestDto,
      params: RequestParams = {}
    ) =>
      this.request<ApproveInvoicesResponseItemDto[], void>({
        path: `/organization/${organizationId}/parcel-pay/invoices/approve`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Access Share
     * @name AccessShareControllerGetInvitedUsers
     * @request GET:/organization/{organizationId}/invited-users
     * @secure
     */
    accessShareControllerGetInvitedUsers: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<InvitedUserDto[], void>({
        path: `/organization/${organizationId}/invited-users`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Access Share
     * @name AccessShareControllerInviteUsers
     * @request POST:/organization/{organizationId}/invite
     * @secure
     */
    accessShareControllerInviteUsers: (
      organizationId: string,
      data: InviteUserBodyDto,
      params: RequestParams = {}
    ) =>
      this.request<InviteUserResponseDto, void>({
        path: `/organization/${organizationId}/invite`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Access Share
     * @name AccessShareControllerResendInvitation
     * @request POST:/organization/{organizationId}/invited-users/{userId}/resend-invitation
     * @secure
     */
    accessShareControllerResendInvitation: (
      userId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/organization/${organizationId}/invited-users/${userId}/resend-invitation`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Locations
     * @name OrganizationLocationsControllerFindAllSelectList
     * @request GET:/organization/{organizationId}/locations/select-list
     * @secure
     */
    organizationLocationsControllerFindAllSelectList: (
      organizationId: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - address
         * - city
         * - state
         * - status
         * - zip
         * - taxId
         * - documentFieldStatus
         * - name
         * - locationIdentifier
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | id                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | address             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | city                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | state               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | zip                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | taxId               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | status              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | Active, Monitored, Sold, Closed, Under Construction, Not Active |
         * | documentFieldStatus | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | COMPLETE, MISSING_FIELDS, UPLOAD_INVOICES, NOT_APPLICABLE_REQUESTED, NOT_APPLICABLE |
         * | locationIdentifier  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | name                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /** JSON array of column paths. Headers are auto-generated from keys. Example: ["name","status"] */
        columns?: string;
        /** Custom filename for CSV (without extension) */
        filename?: string;
        /** Start date for filtering savings/spend (YYYY-MM-DD) */
        startOfSavingsPeriod?: string;
        /** End date for filtering savings/spend (YYYY-MM-DD) */
        endOfSavingsPeriod?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<LocationSelectListDto, void>({
        path: `/organization/${organizationId}/locations/select-list`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Document
     * @name ArchiveDocumentControllerCreateZipJob
     * @request POST:/organization/{organizationId}/document/zip
     * @secure
     */
    archiveDocumentControllerCreateZipJob: (
      organizationId: string,
      data: CreateArchiveDocumentsRequestDto,
      params: RequestParams = {}
    ) =>
      this.request<ArchiveDocumentsResponseDto, void>({
        path: `/organization/${organizationId}/document/zip`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Management
     * @name UserManagementControllerGetOrganizationUsers
     * @request GET:/organization/{organizationId}/user-management
     * @secure
     */
    userManagementControllerGetOrganizationUsers: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<OrganizationUsersGroupedDto, void>({
        path: `/organization/${organizationId}/user-management`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Management
     * @name UserManagementControllerUpdateUserRole
     * @request PATCH:/organization/{organizationId}/user-management/{userId}/role
     * @secure
     */
    userManagementControllerUpdateUserRole: (
      userId: string,
      organizationId: string,
      data: UpdateUserRoleDto,
      params: RequestParams = {}
    ) =>
      this.request<OrganizationUserDto, void>({
        path: `/organization/${organizationId}/user-management/${userId}/role`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrganizationTickets
     * @name OrganizationTicketsControllerGetTickets
     * @request GET:/organization/{organizationId}/tickets
     * @secure
     */
    organizationTicketsControllerGetTickets: (
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - vectorTicketId
         * - subject
         * - description
         * - status
         * - priority
         * - category
         * - subCategory
         * - vendorName
         * - location
         * - zip
         * - address
         * - city
         * - state
         * - subStatus
         * - assignee
         * - assigneeEmail
         * - assigneeName
         * - requestorEmail
         * - requestorName
         * - organizationId
         * - organizationName
         * - vendorId
         * - ticketNumber
         * - accessToExternalUser
         * - createdAt
         * - updatedAt
         * - dueDate
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                  | Type    | Allowed Rules                                                                | Possible Values |
         * | -------------------- | ------- | ---------------------------------------------------------------------------- | --------------- |
         * | id                   | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vectorTicketId       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subject              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | description          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | status               | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | priority             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | category             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subCategory          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorName           | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | location             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | zip                  | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | address              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | city                 | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | state                | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subStatus            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assignee             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeEmail        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeName         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestorEmail       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestorName        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationId       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationName     | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorId             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | ticketNumber         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | accessToExternalUser | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | createdAt            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | dueDate              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - subject
         * - description
         * - category
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<TicketListDto, void>({
        path: `/organization/${organizationId}/tickets`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrganizationTickets
     * @name OrganizationTicketsControllerCreateTicket
     * @request POST:/organization/{organizationId}/tickets
     * @secure
     */
    organizationTicketsControllerCreateTicket: (
      organizationId: string,
      data: CreateTicketDto,
      params: RequestParams = {}
    ) =>
      this.request<TicketWithDetailsDto, void>({
        path: `/organization/${organizationId}/tickets`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrganizationTickets
     * @name OrganizationTicketsControllerExportTickets
     * @request GET:/organization/{organizationId}/tickets/export
     * @secure
     */
    organizationTicketsControllerExportTickets: (
      organizationId: string,
      query: {
        /** JSON array of column paths. Headers are auto-generated from keys. Example: ["name","status"] */
        columns: string;
        /** Custom filename for the CSV download (without extension). */
        filename?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - vectorTicketId
         * - subject
         * - description
         * - status
         * - priority
         * - category
         * - subCategory
         * - vendorName
         * - location
         * - zip
         * - address
         * - city
         * - state
         * - subStatus
         * - assignee
         * - assigneeEmail
         * - assigneeName
         * - requestorEmail
         * - requestorName
         * - organizationId
         * - organizationName
         * - vendorId
         * - ticketNumber
         * - accessToExternalUser
         * - createdAt
         * - updatedAt
         * - dueDate
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                  | Type    | Allowed Rules                                                                | Possible Values |
         * | -------------------- | ------- | ---------------------------------------------------------------------------- | --------------- |
         * | id                   | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vectorTicketId       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subject              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | description          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | status               | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | priority             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | category             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subCategory          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorName           | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | location             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | zip                  | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | address              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | city                 | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | state                | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subStatus            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assignee             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeEmail        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeName         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestorEmail       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestorName        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationId       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationName     | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorId             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | ticketNumber         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | accessToExternalUser | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | createdAt            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | dueDate              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - subject
         * - description
         * - category
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<StreamableFile, void>({
        path: `/organization/${organizationId}/tickets/export`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrganizationTickets
     * @name OrganizationTicketsControllerGetTicket
     * @request GET:/organization/{organizationId}/tickets/{ticketId}
     * @secure
     */
    organizationTicketsControllerGetTicket: (
      ticketId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<TicketWithDetailsDto, void>({
        path: `/organization/${organizationId}/tickets/${ticketId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrganizationTickets
     * @name OrganizationTicketsControllerCreateExternalComment
     * @request POST:/organization/{organizationId}/tickets/{ticketId}/comments
     * @secure
     */
    organizationTicketsControllerCreateExternalComment: (
      ticketId: string,
      organizationId: string,
      data: CreateTicketCommentExternalDto,
      params: RequestParams = {}
    ) =>
      this.request<CreateTicketCommentResponseDto, void>({
        path: `/organization/${organizationId}/tickets/${ticketId}/comments`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  aiAgent = {
    /**
     * No description
     *
     * @tags AI Agent Integration - Documents
     * @name DocumentsControllerGetVendorSelectList
     * @request GET:/ai-agent/organizations/{organizationId}/documents/select-list/vendors
     * @secure
     */
    documentsControllerGetVendorSelectList: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SelectListDto, any>({
        path: `/ai-agent/organizations/${organizationId}/documents/select-list/vendors`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AI Agent Integration - Documents
     * @name DocumentsControllerGetSpendCategorySelectList
     * @request GET:/ai-agent/organizations/{organizationId}/documents/select-list/spend-categories
     * @secure
     */
    documentsControllerGetSpendCategorySelectList: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SelectListDto, any>({
        path: `/ai-agent/organizations/${organizationId}/documents/select-list/spend-categories`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AI Agent Integration - Documents
     * @name DocumentsControllerGetDocumentTypeSelectList
     * @request GET:/ai-agent/organizations/{organizationId}/documents/select-list/document-types
     * @secure
     */
    documentsControllerGetDocumentTypeSelectList: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SelectListDto, any>({
        path: `/ai-agent/organizations/${organizationId}/documents/select-list/document-types`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AI Agent Integration - Documents
     * @name DocumentsControllerGetContractTypeSelectList
     * @request GET:/ai-agent/organizations/{organizationId}/documents/select-list/contract-types
     * @secure
     */
    documentsControllerGetContractTypeSelectList: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SelectListDto, any>({
        path: `/ai-agent/organizations/${organizationId}/documents/select-list/contract-types`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AI Agent Integration - Documents
     * @name DocumentsControllerEnqueueDocumentSync
     * @request POST:/ai-agent/organizations/{organizationId}/documents/sync
     * @secure
     */
    documentsControllerEnqueueDocumentSync: (
      organizationId: string,
      data: SyncFranzDocumentDto,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/ai-agent/organizations/${organizationId}/documents/sync`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AI Agent Integration - Documents
     * @name DocumentsControllerGetFileUrl
     * @summary Return a time-limited SAS URL for reading the document blob
     * @request GET:/ai-agent/organizations/{organizationId}/documents/{id}/file-url
     * @secure
     */
    documentsControllerGetFileUrl: (
      id: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<DocumentFileUrlDto, any>({
        path: `/ai-agent/organizations/${organizationId}/documents/${id}/file-url`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AI Agent Integration - Documents
     * @name DocumentsControllerGetById
     * @request GET:/ai-agent/organizations/{organizationId}/documents/{id}
     * @secure
     */
    documentsControllerGetById: (
      id: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<DocumentDto, any>({
        path: `/ai-agent/organizations/${organizationId}/documents/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AI Agent Integration - Users
     * @name UsersControllerHasUserAccess
     * @request GET:/ai-agent/users/{userId}/organizations/{organizationId}
     * @secure
     */
    usersControllerHasUserAccess: (
      userId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/ai-agent/users/${userId}/organizations/${organizationId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AI Agent Integration - Users
     * @name UsersControllerCanAccessSensitiveDocuments
     * @request GET:/ai-agent/users/{userId}/organizations/{organizationId}/permissions/sensitive-documents
     * @secure
     */
    usersControllerCanAccessSensitiveDocuments: (
      userId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SensitiveDocumentsPermissionDto, any>({
        path: `/ai-agent/users/${userId}/organizations/${organizationId}/permissions/sensitive-documents`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  externalUsers = {
    /**
     * No description
     *
     * @tags External Users
     * @name ExternalUsersControllerGetAllList
     * @request GET:/external-users
     * @secure
     */
    externalUsersControllerGetAllList: (
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - emailAddress
         * - surname
         * - contactPhoneNumber
         * - title
         * - userLoginStatus
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | id                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | name               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | emailAddress       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | surname            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | contactPhoneNumber | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | title              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | userLoginStatus    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /** Search by name or email address */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<ExternalUserPartialListDto, void>({
        path: `/external-users`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags External Users
     * @name ExternalUsersControllerFindAllCoworkers
     * @request GET:/external-users/coworkers
     * @secure
     */
    externalUsersControllerFindAllCoworkers: (
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - emailAddress
         * - surname
         * - contactPhoneNumber
         * - title
         * - userLoginStatus
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | id                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | name               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | emailAddress       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | surname            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | contactPhoneNumber | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | title              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | userLoginStatus    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /** Search by name or email address */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<ExternalUserPartialListDto, void>({
        path: `/external-users/coworkers`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags External Users
     * @name ExternalUsersControllerUpdateExternalUser
     * @request PATCH:/external-users/{id}
     * @secure
     */
    externalUsersControllerUpdateExternalUser: (
      id: string,
      data: UpdateExternalUserDto,
      params: RequestParams = {}
    ) =>
      this.request<PlainExternalUserDto, void>({
        path: `/external-users/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  organizations = {
    /**
     * No description
     *
     * @tags Category Managers
     * @name CategoryManagersControllerGetCategoryManagers
     * @request GET:/organizations/{organizationId}/category-managers
     * @secure
     */
    categoryManagersControllerGetCategoryManagers: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SelectListDto, void>({
        path: `/organizations/${organizationId}/category-managers`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SIB Contract Files
     * @name SibContractFilesControllerFindAll
     * @request GET:/organizations/{organizationId}/sib-contracts/{contractId}/files
     * @secure
     */
    sibContractFilesControllerFindAll: (
      contractId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<FileListDto, void>({
        path: `/organizations/${organizationId}/sib-contracts/${contractId}/files`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SIB Contract Files
     * @name SibContractFilesControllerFindOne
     * @request GET:/organizations/{organizationId}/sib-contracts/{contractId}/files/{fileId}
     * @secure
     */
    sibContractFilesControllerFindOne: (
      contractId: string,
      fileId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<FileDto, void>({
        path: `/organizations/${organizationId}/sib-contracts/${contractId}/files/${fileId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SIB Contract Files
     * @name SibContractFilesControllerDelete
     * @request DELETE:/organizations/{organizationId}/sib-contracts/{contractId}/files/{fileId}
     * @secure
     */
    sibContractFilesControllerDelete: (
      contractId: string,
      fileId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<FileDto, void>({
        path: `/organizations/${organizationId}/sib-contracts/${contractId}/files/${fileId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SIB Contract Files
     * @name SibContractFilesControllerHandleUploadUrl
     * @request POST:/organizations/{organizationId}/sib-contracts/{contractId}/files/upload-url
     * @secure
     */
    sibContractFilesControllerHandleUploadUrl: (
      contractId: string,
      organizationId: string,
      data: GenerateBulkFileUploadUrlDto,
      params: RequestParams = {}
    ) =>
      this.request<FileBulkUploadUrlResponseDto, void>({
        path: `/organizations/${organizationId}/sib-contracts/${contractId}/files/upload-url`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SIB Contract Files
     * @name SibContractFilesControllerUploadFile
     * @request POST:/organizations/{organizationId}/sib-contracts/{contractId}/files/upload
     * @secure
     */
    sibContractFilesControllerUploadFile: (
      contractId: string,
      organizationId: string,
      data: UploadFileDto,
      params: RequestParams = {}
    ) =>
      this.request<FileUploadResultDto, void>({
        path: `/organizations/${organizationId}/sib-contracts/${contractId}/files/upload`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Power BI Reports
     * @name PowerBiReportsControllerGetPowerBiReports
     * @request GET:/organizations/{organizationId}/power-bi-reports
     * @secure
     */
    powerBiReportsControllerGetPowerBiReports: (
      organizationId: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - groupId
         * - reportId
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | name     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | groupId  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | reportId | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<PowerBiReportListDto, void>({
        path: `/organizations/${organizationId}/power-bi-reports`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Power BI Reports
     * @name PowerBiReportsControllerGetPowerBiReport
     * @request GET:/organizations/{organizationId}/power-bi-reports/{id}
     * @secure
     */
    powerBiReportsControllerGetPowerBiReport: (
      organizationId: string,
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<PowerBiReportDto, void>({
        path: `/organizations/${organizationId}/power-bi-reports/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Optimization Subjects
     * @name OptimizationSubjectsControllerFindAll
     * @request GET:/organizations/{organizationId}/optimization-subjects
     * @secure
     */
    optimizationSubjectsControllerFindAll: (
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - organization
         * - location
         * - spendCategory
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key           | Type   | Allowed Rules                                                                | Possible Values |
         * | ------------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | organization  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | location      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | spendCategory | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<OptimizationSubjectListDto, void>({
        path: `/organizations/${organizationId}/optimization-subjects`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Optimization Subjects
     * @name OptimizationSubjectsControllerCreate
     * @request POST:/organizations/{organizationId}/optimization-subjects
     * @secure
     */
    optimizationSubjectsControllerCreate: (
      organizationId: string,
      data: CreateOptimizationSubjectDto,
      params: RequestParams = {}
    ) =>
      this.request<OptimizationSubjectItemDto, void>({
        path: `/organizations/${organizationId}/optimization-subjects`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendors
     * @name OrganizationVendorsControllerGetAllVendorsByOrganizationName
     * @request GET:/organizations/{organizationId}/vendors
     * @secure
     */
    organizationVendorsControllerGetAllVendorsByOrganizationName: (
      organizationId: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - createdAt
         * - updatedAt
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | name | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        serviceCategory?: string;
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<VendorsListDto, void>({
        path: `/organizations/${organizationId}/vendors`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendors
     * @name OrganizationVendorsControllerGetAllVendorServiceCategories
     * @request GET:/organizations/{organizationId}/vendors/service-categories
     * @secure
     */
    organizationVendorsControllerGetAllVendorServiceCategories: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<ServiceCategoryDto[], void>({
        path: `/organizations/${organizationId}/vendors/service-categories`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags VectorLocations
     * @name VectorLocationsControllerGetVectorLocations
     * @request GET:/organizations/{organizationId}/locations/vector
     * @secure
     */
    vectorLocationsControllerGetVectorLocations: (
      organizationId: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - address
         * - city
         * - state
         * - zipCode
         * - status
         * - savings
         * - autoPay
         * - ledgerNo
         * - cost
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | name     | string | like |  |
         * | address  | string | like |  |
         * | city     | string | like |  |
         * | status   | boolean | eq |  |
         * | zipCode  | string | like |  |
         * | state    | string | eq |  |
         * | autoPay  | string | eq |  |
         * | ledgerNo | string | like |  |
         * | cost     | number | between |  |
         * | savings  | number | between |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /** JSON array of column paths. Headers are auto-generated from keys. Example: ["name","status"] */
        columns?: string;
        /** Custom filename for CSV (without extension) */
        filename?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<VectorLocationListDto, void>({
        path: `/organizations/${organizationId}/locations/vector`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags VectorLocations
     * @name VectorLocationsControllerExportVectorLocations
     * @request GET:/organizations/{organizationId}/locations/vector/export
     * @secure
     */
    vectorLocationsControllerExportVectorLocations: (
      organizationId: string,
      query: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - address
         * - city
         * - state
         * - zipCode
         * - status
         * - savings
         * - autoPay
         * - ledgerNo
         * - cost
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | name     | string | like |  |
         * | address  | string | like |  |
         * | city     | string | like |  |
         * | status   | boolean | eq |  |
         * | zipCode  | string | like |  |
         * | state    | string | eq |  |
         * | autoPay  | string | eq |  |
         * | ledgerNo | string | like |  |
         * | cost     | number | between |  |
         * | savings  | number | between |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /** JSON array of column paths. Headers are auto-generated from keys. Example: ["name","status"] */
        columns: string;
        /** Custom filename for the CSV download (without extension). */
        filename?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<StreamableFile, void>({
        path: `/organizations/${organizationId}/locations/vector/export`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags VectorLocations
     * @name VectorLocationsControllerGetVectorLocationByPropertyId
     * @request GET:/organizations/{organizationId}/locations/vector/{propertyId}
     * @secure
     */
    vectorLocationsControllerGetVectorLocationByPropertyId: (
      propertyId: number,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<VectorLocationDto, void>({
        path: `/organizations/${organizationId}/locations/vector/${propertyId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags VectorContracts
     * @name VectorContractsControllerGetVectorContracts
     * @request GET:/organizations/{organizationId}/vendors/{vendorId}/vector/contracts
     * @secure
     */
    vectorContractsControllerGetVectorContracts: (
      organizationId: string,
      vendorId: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - locationName
         * - effectiveDate
         * - isVetted
         * - status
         * - vendorName
         * - locationName
         * - negotiationNo
         * - id
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | id            | string | like |  |
         * | negotiationNo | string | like |  |
         * | locationName  | string | like |  |
         * | vendorName    | string | like |  |
         * | status        | string | eq | Archived, Fully Executed, Bill Processing Only |
         * | effectiveDate | date | between |  |
         * | isVetted      | boolean | eq |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<VectorContractsListDto, void>({
        path: `/organizations/${organizationId}/vendors/${vendorId}/vector/contracts`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SIB Contract Spend Categories
     * @name SibContractSpendCategoriesControllerFindAll
     * @request GET:/organizations/{organizationId}/sib-contracts/{contractId}/spend-categories
     * @secure
     */
    sibContractSpendCategoriesControllerFindAll: (
      contractId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SibContractSpendCategoryListDto, void>({
        path: `/organizations/${organizationId}/sib-contracts/${contractId}/spend-categories`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SIB Contract Spend Categories
     * @name SibContractSpendCategoriesControllerCreate
     * @request POST:/organizations/{organizationId}/sib-contracts/{contractId}/spend-categories
     * @secure
     */
    sibContractSpendCategoriesControllerCreate: (
      contractId: string,
      organizationId: string,
      data: CreateSibContractSpendCategoryDto,
      params: RequestParams = {}
    ) =>
      this.request<SibContractSpendCategoryDto, void>({
        path: `/organizations/${organizationId}/sib-contracts/${contractId}/spend-categories`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SIB Contract Spend Categories
     * @name SibContractSpendCategoriesControllerDelete
     * @request DELETE:/organizations/{organizationId}/sib-contracts/{contractId}/spend-categories/{spendCategoryId}
     * @secure
     */
    sibContractSpendCategoriesControllerDelete: (
      contractId: string,
      spendCategoryId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SibContractSpendCategoryDto, void>({
        path: `/organizations/${organizationId}/sib-contracts/${contractId}/spend-categories/${spendCategoryId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SIB Contracts
     * @name SibContractsControllerFindAll
     * @request GET:/organizations/{organizationId}/sib-contracts
     * @secure
     */
    sibContractsControllerFindAll: (
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - organization
         * - status
         * - fee
         * - startDate
         * - endDate
         * - termMonths
         * - autoRenewal
         * - autoRenewalDate
         * - auditsCount
         * - totalContractValue
         * - uploadDate
         * - fileUrl
         * - salesRepresentative
         * - salesforceId
         * - salesforceSalesId
         * - updatedAt
         * - createdAt
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                 | Type                 | Allowed Rules                                                                | Possible Values  |
         * | ------------------- | -------------------- | ---------------------------------------------------------------------------- | ---------------- |
         * | id                  | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                  |
         * | name                | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                  |
         * | organization        | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                  |
         * | status              | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | active, inactive |
         * | fee                 | number               | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                  |
         * | startDate           | date                 | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                  |
         * | endDate             | date                 | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                  |
         * | termMonths          | number               | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                  |
         * | autoRenewal         | boolean              | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                  |
         * | autoRenewalDate     | date                 | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                  |
         * | auditsCount         | number               | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                  |
         * | totalContractValue  | number               | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                  |
         * | uploadDate          | date                 | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                  |
         * | fileUrl             | object               |                                                                              |                  |
         * | salesRepresentative | plainexternaluserdto |                                                                              |                  |
         * | salesforceId        | object               |                                                                              |                  |
         * | salesforceSalesId   | object               |                                                                              |                  |
         * | updatedAt           | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                  |
         * | createdAt           | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                  |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<SibContractListDto, void>({
        path: `/organizations/${organizationId}/sib-contracts`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SIB Contracts
     * @name SibContractsControllerCreate
     * @request POST:/organizations/{organizationId}/sib-contracts
     * @secure
     */
    sibContractsControllerCreate: (
      organizationId: string,
      data: CreateSibContractDto,
      params: RequestParams = {}
    ) =>
      this.request<SibContractDto, void>({
        path: `/organizations/${organizationId}/sib-contracts`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SIB Contracts
     * @name SibContractsControllerExportContracts
     * @request GET:/organizations/{organizationId}/sib-contracts/export
     * @secure
     */
    sibContractsControllerExportContracts: (
      organizationId: string,
      query: {
        /** JSON array of column paths. Headers are auto-generated from keys. Example: ["name","status"] */
        columns: string;
        /** Custom filename for the CSV download (without extension). */
        filename?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - organization
         * - status
         * - fee
         * - startDate
         * - endDate
         * - termMonths
         * - autoRenewal
         * - autoRenewalDate
         * - auditsCount
         * - totalContractValue
         * - uploadDate
         * - fileUrl
         * - salesRepresentative
         * - salesforceId
         * - salesforceSalesId
         * - updatedAt
         * - createdAt
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                 | Type                 | Allowed Rules                                                                | Possible Values  |
         * | ------------------- | -------------------- | ---------------------------------------------------------------------------- | ---------------- |
         * | id                  | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                  |
         * | name                | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                  |
         * | organization        | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                  |
         * | status              | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | active, inactive |
         * | fee                 | number               | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                  |
         * | startDate           | date                 | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                  |
         * | endDate             | date                 | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                  |
         * | termMonths          | number               | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                  |
         * | autoRenewal         | boolean              | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                  |
         * | autoRenewalDate     | date                 | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                  |
         * | auditsCount         | number               | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                  |
         * | totalContractValue  | number               | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                  |
         * | uploadDate          | date                 | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                  |
         * | fileUrl             | object               |                                                                              |                  |
         * | salesRepresentative | plainexternaluserdto |                                                                              |                  |
         * | salesforceId        | object               |                                                                              |                  |
         * | salesforceSalesId   | object               |                                                                              |                  |
         * | updatedAt           | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                  |
         * | createdAt           | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                  |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<StreamableFile, void>({
        path: `/organizations/${organizationId}/sib-contracts/export`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SIB Contracts
     * @name SibContractsControllerExportFiles
     * @request GET:/organizations/{organizationId}/sib-contracts/files/export
     * @secure
     */
    sibContractsControllerExportFiles: (
      organizationId: string,
      query?: {
        filename?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - organization
         * - status
         * - fee
         * - startDate
         * - endDate
         * - termMonths
         * - autoRenewal
         * - autoRenewalDate
         * - auditsCount
         * - totalContractValue
         * - uploadDate
         * - fileUrl
         * - salesRepresentative
         * - salesforceId
         * - salesforceSalesId
         * - updatedAt
         * - createdAt
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                 | Type                 | Allowed Rules                                                                | Possible Values  |
         * | ------------------- | -------------------- | ---------------------------------------------------------------------------- | ---------------- |
         * | id                  | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                  |
         * | name                | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                  |
         * | organization        | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                  |
         * | status              | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | active, inactive |
         * | fee                 | number               | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                  |
         * | startDate           | date                 | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                  |
         * | endDate             | date                 | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                  |
         * | termMonths          | number               | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                  |
         * | autoRenewal         | boolean              | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                  |
         * | autoRenewalDate     | date                 | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                  |
         * | auditsCount         | number               | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                  |
         * | totalContractValue  | number               | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                  |
         * | uploadDate          | date                 | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                  |
         * | fileUrl             | object               |                                                                              |                  |
         * | salesRepresentative | plainexternaluserdto |                                                                              |                  |
         * | salesforceId        | object               |                                                                              |                  |
         * | salesforceSalesId   | object               |                                                                              |                  |
         * | updatedAt           | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                  |
         * | createdAt           | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                  |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<ArchiveDocumentsResponseDto, void>({
        path: `/organizations/${organizationId}/sib-contracts/files/export`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SIB Contracts
     * @name SibContractsControllerFindOne
     * @request GET:/organizations/{organizationId}/sib-contracts/{contractId}
     * @secure
     */
    sibContractsControllerFindOne: (
      contractId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SibContractDto, void>({
        path: `/organizations/${organizationId}/sib-contracts/${contractId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SIB Contracts
     * @name SibContractsControllerUpdate
     * @request PATCH:/organizations/{organizationId}/sib-contracts/{contractId}
     * @secure
     */
    sibContractsControllerUpdate: (
      contractId: string,
      organizationId: string,
      data: UpdateSibContractDto,
      params: RequestParams = {}
    ) =>
      this.request<SibContractDto, void>({
        path: `/organizations/${organizationId}/sib-contracts/${contractId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SIB Contracts
     * @name SibContractsControllerDelete
     * @request DELETE:/organizations/{organizationId}/sib-contracts/{contractId}
     * @secure
     */
    sibContractsControllerDelete: (
      contractId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SibContractDto, void>({
        path: `/organizations/${organizationId}/sib-contracts/${contractId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SIB Contracts
     * @name SibContractsControllerFindOneWithDetails
     * @request GET:/organizations/{organizationId}/sib-contracts/{contractId}/details
     * @secure
     */
    sibContractsControllerFindOneWithDetails: (
      contractId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SibContractDetailDto, void>({
        path: `/organizations/${organizationId}/sib-contracts/${contractId}/details`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SIB Contract Periods
     * @name SibContractPeriodsControllerFindAll
     * @request GET:/organizations/{organizationId}/sib-contracts/{contractId}/periods
     * @secure
     */
    sibContractPeriodsControllerFindAll: (
      contractId: string,
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - contract
         * - startDate
         * - term
         * - fee
         * - order
         * - updatedAt
         * - createdAt
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key       | Type   | Allowed Rules                                                                | Possible Values |
         * | --------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | contract  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | startDate | object |                                                                              |                 |
         * | term      | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | fee       | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | order     | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | updatedAt | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdAt | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<SibContractPeriodListDto, void>({
        path: `/organizations/${organizationId}/sib-contracts/${contractId}/periods`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SIB Contract Periods
     * @name SibContractPeriodsControllerCreate
     * @request POST:/organizations/{organizationId}/sib-contracts/{contractId}/periods
     * @secure
     */
    sibContractPeriodsControllerCreate: (
      contractId: string,
      organizationId: string,
      data: CreateSibContractPeriodDto,
      params: RequestParams = {}
    ) =>
      this.request<SibContractPeriodDto, void>({
        path: `/organizations/${organizationId}/sib-contracts/${contractId}/periods`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SIB Contract Periods
     * @name SibContractPeriodsControllerFindOne
     * @request GET:/organizations/{organizationId}/sib-contracts/{contractId}/periods/{id}
     * @secure
     */
    sibContractPeriodsControllerFindOne: (
      contractId: string,
      id: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SibContractPeriodDto, void>({
        path: `/organizations/${organizationId}/sib-contracts/${contractId}/periods/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SIB Contract Periods
     * @name SibContractPeriodsControllerUpdate
     * @request PATCH:/organizations/{organizationId}/sib-contracts/{contractId}/periods/{id}
     * @secure
     */
    sibContractPeriodsControllerUpdate: (
      contractId: string,
      id: string,
      organizationId: string,
      data: UpdateSibContractPeriodDto,
      params: RequestParams = {}
    ) =>
      this.request<SibContractPeriodDto, void>({
        path: `/organizations/${organizationId}/sib-contracts/${contractId}/periods/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SIB Contract Periods
     * @name SibContractPeriodsControllerDelete
     * @request DELETE:/organizations/{organizationId}/sib-contracts/{contractId}/periods/{id}
     * @secure
     */
    sibContractPeriodsControllerDelete: (
      contractId: string,
      id: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SibContractPeriodDto, void>({
        path: `/organizations/${organizationId}/sib-contracts/${contractId}/periods/${id}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  token = {
    /**
     * No description
     *
     * @tags Token
     * @name TokenControllerGetFranzOboToken
     * @request GET:/token/franz/{organizationId}
     * @secure
     */
    tokenControllerGetFranzOboToken: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<string, void>({
        path: `/token/franz/${organizationId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  task = {
    /**
     * No description
     *
     * @tags Task
     * @name TaskControllerCreate
     * @request POST:/task
     * @secure
     */
    taskControllerCreate: (data: CreateTaskDto, params: RequestParams = {}) =>
      this.request<TaskDto, void>({
        path: `/task`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task
     * @name TaskControllerFindAll
     * @request GET:/task
     * @secure
     */
    taskControllerFindAll: (
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - title
         * - description
         * - priorityLevel
         * - referenceLink
         * - referenceName
         * - category
         * - completed
         * - completedAt
         * - deadline
         * - seenAt
         * - seen
         * - subauditId
         * - timeLogged
         * - estimatedTime
         * - assignee
         * - createdByName
         * - organization
         * - organizationName
         * - vendor
         * - vendorName
         * - createdAt
         * - updatedAt
         * - project
         * - commentsCount
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | id                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | title                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | description          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | completed            | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty |  |
         * | priorityLevel        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | createdAt            | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | updatedAt            | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | deadline             | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | completedAt          | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | timeLogged           | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty |  |
         * | estimatedTime        | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty |  |
         * | category             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | referenceLink        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | referenceName        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | organizationId       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | organizationName     | string | like |  |
         * | vendorId             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | vendorName           | string | like |  |
         * | seenAt               | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | seen                 | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty |  |
         * | assignee             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | assigneeName         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | assigneeEmail        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | createdByName        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | createdByEmail       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | tagName              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | tagColor             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | tagId                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | tagCreatedBy         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | taskTagContactId     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | taskTagEmployeeId    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | taskTagType          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | taskTagEmployeeName  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | taskTagEmployeeEmail | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | taskTagContactName   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | taskTagContactEmail  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | subauditId           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | project              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | commentsCount        | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /** Search by title, description, reference, assignee, creator, organization, tag name, tag color, tag id, tag created by, task tag contact name, task tag contact email, task tag employee name, task tag employee email */
        searchTerm?: string;
        /**
         * User ID to filter tasks by assignee (overrides current user)
         * @format uuid
         */
        userId?: string;
        /**
         * User ID to filter tasks by creator
         * @format uuid
         */
        createdBy?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<TaskListDto, void>({
        path: `/task`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task
     * @name TaskControllerFindOne
     * @request GET:/task/{id}
     * @secure
     */
    taskControllerFindOne: (id: string, params: RequestParams = {}) =>
      this.request<TaskDto, void>({
        path: `/task/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task
     * @name TaskControllerUpdate
     * @request PUT:/task/{id}
     * @secure
     */
    taskControllerUpdate: (
      id: string,
      data: UpdateTaskDto,
      params: RequestParams = {}
    ) =>
      this.request<TaskDto, void>({
        path: `/task/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task
     * @name TaskControllerDeleteOne
     * @request DELETE:/task/{id}
     * @secure
     */
    taskControllerDeleteOne: (
      id: string,
      query?: {
        /** Whether to also delete all follow-up tasks */
        cascadeFollowUps?: boolean;
      },
      params: RequestParams = {}
    ) =>
      this.request<DeleteResult, void>({
        path: `/task/${id}`,
        method: 'DELETE',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task
     * @name TaskControllerGetAssignedUsersWithTaskCountsByCreator
     * @request GET:/task/assigned-users-by-creator/task-count
     * @secure
     */
    taskControllerGetAssignedUsersWithTaskCountsByCreator: (
      query?: {
        /** Sorting parameter in format property:direction. Multiple sorts separated by comma. */
        sort?: string[];
        /** Filtering parameters in format property:rule:value. Multiple filters as array. */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /**
         * Global search term.
         *
         * Searchable fields: title, description, referenceName, referenceLink, assigneeName, assigneeEmail, createdByName, createdByEmail, organizationName, tagName, taskTagEmployeeName, taskTagEmployeeEmail, taskTagContactName, taskTagContactEmail
         */
        searchTerm?: string;
        /** Filter by completion status. If true, returns only completed tasks. If false, returns only non-completed tasks. */
        completed?: boolean;
      },
      params: RequestParams = {}
    ) =>
      this.request<AssignedUserTaskSummaryListDto, void>({
        path: `/task/assigned-users-by-creator/task-count`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task
     * @name TaskControllerLogTime
     * @request PATCH:/task/{id}/log-time
     * @secure
     */
    taskControllerLogTime: (
      id: string,
      data: LogTimeDto,
      params: RequestParams = {}
    ) =>
      this.request<TaskDto, void>({
        path: `/task/${id}/log-time`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task
     * @name TaskControllerImportTasks
     * @request POST:/task/import/{userId}
     * @secure
     */
    taskControllerImportTasks: (
      userId: string,
      query: {
        ownerFilter: string;
      },
      data: ImportTasksDto,
      params: RequestParams = {}
    ) =>
      this.request<TaskDto[], void>({
        path: `/task/import/${userId}`,
        method: 'POST',
        query: query,
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task
     * @name TaskControllerCreateManyTasks
     * @request POST:/task/many
     * @secure
     */
    taskControllerCreateManyTasks: (
      data: CreateTaskDto[],
      params: RequestParams = {}
    ) =>
      this.request<TaskDto[], void>({
        path: `/task/many`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  tasks = {
    /**
     * No description
     *
     * @tags TaskHistory
     * @name TaskHistoryControllerFindAllChangeLogs
     * @request GET:/tasks/{taskUuid}/versions/changelogs
     * @secure
     */
    taskHistoryControllerFindAllChangeLogs: (
      taskUuid: string,
      params: RequestParams = {}
    ) =>
      this.request<TaskVersionChangelogList, void>({
        path: `/tasks/${taskUuid}/versions/changelogs`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subtask Versions
     * @name SubtaskVersionsControllerFindAllChangeLogs
     * @request GET:/tasks/{taskId}/subtasks/{subtaskId}/versions/changelogs
     * @secure
     */
    subtaskVersionsControllerFindAllChangeLogs: (
      taskId: string,
      subtaskId: string,
      params: RequestParams = {}
    ) =>
      this.request<SubtaskVersionChangelogList, void>({
        path: `/tasks/${taskId}/subtasks/${subtaskId}/versions/changelogs`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task Tag Versions
     * @name TaskTagVersionsControllerFindAllChangeLogs
     * @request GET:/tasks/{taskId}/task-tags/versions
     * @secure
     */
    taskTagVersionsControllerFindAllChangeLogs: (
      taskId: string,
      params: RequestParams = {}
    ) =>
      this.request<TaskTagVersionChangelogList, void>({
        path: `/tasks/${taskId}/task-tags/versions`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subtask
     * @name SubtaskControllerCreate
     * @request POST:/tasks/{taskUuid}/subtasks
     * @secure
     */
    subtaskControllerCreate: (
      taskUuid: string,
      data: CreateSubtaskDto,
      params: RequestParams = {}
    ) =>
      this.request<SubtaskDto, void>({
        path: `/tasks/${taskUuid}/subtasks`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subtask
     * @name SubtaskControllerFindAll
     * @request GET:/tasks/{taskUuid}/subtasks
     * @secure
     */
    subtaskControllerFindAll: (
      taskUuid: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - title
         * - completed
         * - priorityLevel
         * - completed
         * - createdByEmail
         * - createdByName
         * - createdAt
         * - updatedAt
         * - updatedById
         * - priorityLevel
         * - taskId
         * - description
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | title          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | completed      | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty |  |
         * | description    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | taskId         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | createdAt      | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | updatedAt      | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | updatedById    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | priorityLevel  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | low, medium, high |
         * | createdByEmail | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | createdByName  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<SubtaskListDto, void>({
        path: `/tasks/${taskUuid}/subtasks`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subtask
     * @name SubtaskControllerFindOne
     * @request GET:/tasks/{taskUuid}/subtasks/{subtaskId}
     * @secure
     */
    subtaskControllerFindOne: (
      taskUuid: string,
      subtaskId: string,
      params: RequestParams = {}
    ) =>
      this.request<SubtaskDto, void>({
        path: `/tasks/${taskUuid}/subtasks/${subtaskId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subtask
     * @name SubtaskControllerUpdate
     * @request PUT:/tasks/{taskUuid}/subtasks/{subtaskId}
     * @secure
     */
    subtaskControllerUpdate: (
      taskUuid: string,
      subtaskId: string,
      data: UpdateSubtaskDto,
      params: RequestParams = {}
    ) =>
      this.request<SubtaskDto, void>({
        path: `/tasks/${taskUuid}/subtasks/${subtaskId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subtask
     * @name SubtaskControllerDeleteOne
     * @request DELETE:/tasks/{taskUuid}/subtasks/{subtaskId}
     * @secure
     */
    subtaskControllerDeleteOne: (
      taskUuid: string,
      subtaskId: string,
      params: RequestParams = {}
    ) =>
      this.request<DeleteResult, void>({
        path: `/tasks/${taskUuid}/subtasks/${subtaskId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task Comment
     * @name TaskCommentControllerFindAll
     * @request GET:/tasks/{taskId}/comments
     * @secure
     */
    taskCommentControllerFindAll: (
      taskId: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - createdAt
         * - updatedAt
         * - comment
         * - createdByName
         * - createdByEmail
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | id             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | comment        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | createdAt      | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | taskId         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | updatedAt      | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | createdByName  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | createdByEmail | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<TaskCommentListDto, void>({
        path: `/tasks/${taskId}/comments`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task Comment
     * @name TaskCommentControllerCreate
     * @request POST:/tasks/{taskId}/comments
     * @secure
     */
    taskCommentControllerCreate: (
      taskId: string,
      data: CreateTaskCommentDto,
      params: RequestParams = {}
    ) =>
      this.request<TaskCommentDto, void>({
        path: `/tasks/${taskId}/comments`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  userSettings = {
    /**
     * No description
     *
     * @tags User Settings
     * @name UserSettingsControllerGetUserSettings
     * @summary Get user settings
     * @request GET:/user-settings
     * @secure
     */
    userSettingsControllerGetUserSettings: (params: RequestParams = {}) =>
      this.request<any, void | UserSettingsResponseDto>({
        path: `/user-settings`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Settings
     * @name UserSettingsControllerUpdateUserSettings
     * @summary Update user settings (partial update)
     * @request PATCH:/user-settings
     * @secure
     */
    userSettingsControllerUpdateUserSettings: (
      data: UpdateUserSettingsDto,
      params: RequestParams = {}
    ) =>
      this.request<any, void | UserSettingsResponseDto>({
        path: `/user-settings`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  team = {
    /**
     * No description
     *
     * @tags Team
     * @name TeamControllerFindAll
     * @request GET:/team
     * @secure
     */
    teamControllerFindAll: (
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - description
         * - subtitle
         * - createdAt
         * - updatedAt
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | name        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | description | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | subtitle    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | createdAt   | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | updatedAt   | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /** Include team members in the response */
        withUsers?: boolean;
      },
      params: RequestParams = {}
    ) =>
      this.request<TeamListDto, void>({
        path: `/team`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Team
     * @name TeamControllerFindOne
     * @request GET:/team/{teamUuid}
     * @secure
     */
    teamControllerFindOne: (teamUuid: string, params: RequestParams = {}) =>
      this.request<TeamDto, void>({
        path: `/team/${teamUuid}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Team
     * @name TeamControllerGetMembers
     * @request GET:/team/{teamUuid}/members
     * @secure
     */
    teamControllerGetMembers: (
      teamUuid: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - emailAddress
         * - surname
         * - contactPhoneNumber
         * - title
         * - userLoginStatus
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | id                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | name               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | emailAddress       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | surname            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | contactPhoneNumber | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | title              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | userLoginStatus    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /** Search by name or email address */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<TeamMemberListDto, void>({
        path: `/team/${teamUuid}/members`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Team
     * @name TeamControllerGetTaskCount
     * @request GET:/team/{teamUuid}/task-count
     * @secure
     */
    teamControllerGetTaskCount: (
      teamUuid: string,
      query?: {
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<TeamTaskCountDto, void>({
        path: `/team/${teamUuid}/task-count`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Team
     * @name TeamControllerUpdateTeamMembers
     * @request PATCH:/team/{teamUuid}/team-members
     * @secure
     */
    teamControllerUpdateTeamMembers: (
      teamUuid: string,
      data: UpdateTeamMembersDto,
      params: RequestParams = {}
    ) =>
      this.request<UpdateTeamMembersResponseDto, void>({
        path: `/team/${teamUuid}/team-members`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  contacts = {
    /**
     * No description
     *
     * @tags Contacts
     * @name ContactsControllerGetContact
     * @request GET:/contacts/{contactId}
     * @secure
     */
    contactsControllerGetContact: (
      contactId: string,
      params: RequestParams = {}
    ) =>
      this.request<ContactDto, void>({
        path: `/contacts/${contactId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contacts
     * @name ContactsControllerUpdateContact
     * @request PUT:/contacts/{contactId}
     * @secure
     */
    contactsControllerUpdateContact: (
      contactId: string,
      data: UpdateContactDto,
      params: RequestParams = {}
    ) =>
      this.request<ContactDto, void>({
        path: `/contacts/${contactId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contacts
     * @name ContactsControllerDeleteContact
     * @request DELETE:/contacts/{contactId}
     * @secure
     */
    contactsControllerDeleteContact: (
      contactId: string,
      params: RequestParams = {}
    ) =>
      this.request<ContactDto, void>({
        path: `/contacts/${contactId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contacts
     * @name ContactsControllerCreateContact
     * @request POST:/contacts
     * @secure
     */
    contactsControllerCreateContact: (
      data: CreateContactDto,
      params: RequestParams = {}
    ) =>
      this.request<ContactDto, void>({
        path: `/contacts`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  internalPortal = {
    /**
     * No description
     *
     * @tags Internal Portal - Vendor accounts
     * @name VendorAccountsControllerGetVendorAccounts
     * @request GET:/internal-portal/organizations/{organizationId}/vendor-accounts
     * @secure
     */
    vendorAccountsControllerGetVendorAccounts: (
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - accountNumber
         * - name
         * - createdAt
         * - invoiceFrequency
         * - billingType
         * - serviceType
         * - note
         * - vendorName
         * - auditsCount
         * - status
         * - spendCategories
         * - locations
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key              | Type   | Allowed Rules                                                                | Possible Values                                   |
         * | ---------------- | ------ | ---------------------------------------------------------------------------- | ------------------------------------------------- |
         * | id               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | accountNumber    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | name             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | createdAt        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | invoiceFrequency | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | bi_weekly, weekly, monthly, bi_monthly, quarterly |
         * | billingType      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | paper, email, portal                              |
         * | serviceType      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | note             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | vendorName       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | auditsCount      | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                   |
         * | status           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | active, inactive                                  |
         * | spendCategories  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | locations        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - accountNumber
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<VendorAccountListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/vendor-accounts`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Vendor accounts
     * @name VendorAccountsControllerCreateVendorAccount
     * @request POST:/internal-portal/organizations/{organizationId}/vendor-accounts
     * @secure
     */
    vendorAccountsControllerCreateVendorAccount: (
      organizationId: string,
      data: CreateVendorAccountDto,
      params: RequestParams = {}
    ) =>
      this.request<VendorAccountDto, void>({
        path: `/internal-portal/organizations/${organizationId}/vendor-accounts`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Vendor accounts
     * @name VendorAccountsControllerGetVendorAccountsForVendor
     * @request GET:/internal-portal/organizations/{organizationId}/vendors/{vendorId}/vendor-accounts
     * @secure
     */
    vendorAccountsControllerGetVendorAccountsForVendor: (
      organizationId: string,
      vendorId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - accountNumber
         * - name
         * - createdAt
         * - invoiceFrequency
         * - billingType
         * - serviceType
         * - note
         * - vendorName
         * - auditsCount
         * - status
         * - spendCategories
         * - locations
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key              | Type   | Allowed Rules                                                                | Possible Values                                   |
         * | ---------------- | ------ | ---------------------------------------------------------------------------- | ------------------------------------------------- |
         * | id               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | accountNumber    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | name             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | createdAt        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | invoiceFrequency | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | bi_weekly, weekly, monthly, bi_monthly, quarterly |
         * | billingType      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | paper, email, portal                              |
         * | serviceType      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | note             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | vendorName       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | auditsCount      | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                   |
         * | status           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | active, inactive                                  |
         * | spendCategories  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | locations        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - accountNumber
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<VendorAccountListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/vendors/${vendorId}/vendor-accounts`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Vendor accounts
     * @name VendorAccountsControllerGetVendorAccountById
     * @request GET:/internal-portal/organizations/{organizationId}/vendor-accounts/{accountId}
     * @secure
     */
    vendorAccountsControllerGetVendorAccountById: (
      organizationId: string,
      accountId: string,
      params: RequestParams = {}
    ) =>
      this.request<VendorAccountDto, void>({
        path: `/internal-portal/organizations/${organizationId}/vendor-accounts/${accountId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Vendor accounts
     * @name VendorAccountsControllerUpdateVendorAccount
     * @request PATCH:/internal-portal/organizations/{organizationId}/vendor-accounts/{accountId}
     * @secure
     */
    vendorAccountsControllerUpdateVendorAccount: (
      organizationId: string,
      accountId: string,
      data: UpdateVendorAccountDto,
      params: RequestParams = {}
    ) =>
      this.request<VendorAccountDto, void>({
        path: `/internal-portal/organizations/${organizationId}/vendor-accounts/${accountId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Vendor accounts
     * @name VendorAccountsControllerDeleteVendorAccount
     * @request DELETE:/internal-portal/organizations/{organizationId}/vendor-accounts/{accountId}
     * @secure
     */
    vendorAccountsControllerDeleteVendorAccount: (
      organizationId: string,
      accountId: string,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/internal-portal/organizations/${organizationId}/vendor-accounts/${accountId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project Files
     * @name ProjectFileControllerGetProjectFiles
     * @request GET:/internal-portal/projects/{projectId}/files
     * @secure
     */
    projectFileControllerGetProjectFiles: (
      projectId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - fileName
         * - fileType
         * - fileUrl
         * - fileSize
         * - uploadStage
         * - id
         * - createdAt
         * - createdBy
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type                 | Allowed Rules                                                                | Possible Values                    |
         * | ----------- | -------------------- | ---------------------------------------------------------------------------- | ---------------------------------- |
         * | fileName    | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                    |
         * | fileType    | object               |                                                                              |                                    |
         * | fileUrl     | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                    |
         * | fileSize    | object               |                                                                              |                                    |
         * | uploadStage | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | pending, failed, uploaded, removed |
         * | id          | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                    |
         * | createdAt   | string               | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                    |
         * | createdBy   | plainexternaluserdto |                                                                              |                                    |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<ProjectFileListDto, void>({
        path: `/internal-portal/projects/${projectId}/files`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project Files
     * @name ProjectFileControllerDeleteProjectFile
     * @request DELETE:/internal-portal/projects/{projectId}/files/{fileId}
     * @secure
     */
    projectFileControllerDeleteProjectFile: (
      projectId: string,
      fileId: string,
      params: RequestParams = {}
    ) =>
      this.request<boolean, void>({
        path: `/internal-portal/projects/${projectId}/files/${fileId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project Files
     * @name ProjectFileControllerGetUploadStatus
     * @request GET:/internal-portal/projects/{projectId}/files/batch/{batchId}/status
     * @secure
     */
    projectFileControllerGetUploadStatus: (
      batchId: string,
      projectId: string,
      params: RequestParams = {}
    ) =>
      this.request<FileBatchStatusListDto, void>({
        path: `/internal-portal/projects/${projectId}/files/batch/${batchId}/status`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project Files - Upload
     * @name ProjectFileUploadControllerHandleUploadUrl
     * @request POST:/internal-portal/projects/{projectId}/files/upload-url
     * @secure
     */
    projectFileUploadControllerHandleUploadUrl: (
      projectId: string,
      data: GenerateBulkFileUploadUrlDto,
      params: RequestParams = {}
    ) =>
      this.request<FileBulkUploadUrlResponseDto, void>({
        path: `/internal-portal/projects/${projectId}/files/upload-url`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project Files - Upload
     * @name ProjectFileUploadControllerUploadFile
     * @request POST:/internal-portal/projects/{projectId}/files/upload
     * @secure
     */
    projectFileUploadControllerUploadFile: (
      projectId: string,
      data: UploadFileDto,
      params: RequestParams = {}
    ) =>
      this.request<FileUploadResultDto, void>({
        path: `/internal-portal/projects/${projectId}/files/upload`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project Files - Upload
     * @name ProjectFileUploadControllerPostprocessFile
     * @request POST:/internal-portal/projects/{projectId}/files/postprocess
     * @secure
     */
    projectFileUploadControllerPostprocessFile: (
      projectId: string,
      data: PostprocessFileDto,
      params: RequestParams = {}
    ) =>
      this.request<FileUploadResultDto, void>({
        path: `/internal-portal/projects/${projectId}/files/postprocess`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project Files - Upload
     * @name ProjectFileUploadControllerPostprocessFiles
     * @request POST:/internal-portal/projects/{projectId}/files/postprocess-many
     * @secure
     */
    projectFileUploadControllerPostprocessFiles: (
      projectId: string,
      data: PostprocessFilesDto,
      params: RequestParams = {}
    ) =>
      this.request<PostprocessFilesResultDto, void>({
        path: `/internal-portal/projects/${projectId}/files/postprocess-many`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Projects
     * @name ProjectControllerCreate
     * @request POST:/internal-portal/projects
     * @secure
     */
    projectControllerCreate: (
      data: CreateProjectDto,
      params: RequestParams = {}
    ) =>
      this.request<ProjectDto, void>({
        path: `/internal-portal/projects`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Projects
     * @name ProjectControllerGetTeamsWithProjects
     * @request GET:/internal-portal/projects/teams
     * @secure
     */
    projectControllerGetTeamsWithProjects: (
      query?: {
        /** Search by project name within each team */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<TeamWithProjectsListDto, void>({
        path: `/internal-portal/projects/teams`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Projects
     * @name ProjectControllerFindOne
     * @request GET:/internal-portal/projects/{id}
     * @secure
     */
    projectControllerFindOne: (id: string, params: RequestParams = {}) =>
      this.request<ProjectDto, void>({
        path: `/internal-portal/projects/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Projects
     * @name ProjectControllerUpdate
     * @request PATCH:/internal-portal/projects/{id}
     * @secure
     */
    projectControllerUpdate: (
      id: string,
      data: UpdateProjectDto,
      params: RequestParams = {}
    ) =>
      this.request<ProjectDto, void>({
        path: `/internal-portal/projects/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project relations
     * @name ProjectRelationsControllerGetProjectTickets
     * @request GET:/internal-portal/projects/{id}/tickets
     * @secure
     */
    projectRelationsControllerGetProjectTickets: (
      id: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - vectorTicketId
         * - subject
         * - description
         * - status
         * - priority
         * - category
         * - subCategory
         * - vendorName
         * - location
         * - zip
         * - address
         * - city
         * - state
         * - subStatus
         * - assignee
         * - assigneeEmail
         * - assigneeName
         * - requestorEmail
         * - requestorName
         * - organizationId
         * - organizationName
         * - vendorId
         * - ticketNumber
         * - accessToExternalUser
         * - createdAt
         * - updatedAt
         * - dueDate
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                  | Type    | Allowed Rules                                                                | Possible Values |
         * | -------------------- | ------- | ---------------------------------------------------------------------------- | --------------- |
         * | id                   | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vectorTicketId       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subject              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | description          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | status               | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | priority             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | category             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subCategory          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorName           | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | location             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | zip                  | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | address              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | city                 | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | state                | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subStatus            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assignee             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeEmail        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeName         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestorEmail       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestorName        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationId       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationName     | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorId             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | ticketNumber         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | accessToExternalUser | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | createdAt            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | dueDate              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - subject
         * - description
         * - category
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<TicketListDto, void>({
        path: `/internal-portal/projects/${id}/tickets`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project relations
     * @name ProjectRelationsControllerGetProjectTasks
     * @request GET:/internal-portal/projects/{id}/tasks
     * @secure
     */
    projectRelationsControllerGetProjectTasks: (
      id: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - title
         * - description
         * - priorityLevel
         * - referenceLink
         * - referenceName
         * - category
         * - completed
         * - completedAt
         * - deadline
         * - seenAt
         * - seen
         * - subauditId
         * - timeLogged
         * - estimatedTime
         * - assignee
         * - createdByName
         * - organization
         * - organizationName
         * - vendor
         * - vendorName
         * - createdAt
         * - updatedAt
         * - project
         * - commentsCount
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | id                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | title                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | description          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | completed            | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty |  |
         * | priorityLevel        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | createdAt            | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | updatedAt            | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | deadline             | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | completedAt          | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | timeLogged           | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty |  |
         * | estimatedTime        | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty |  |
         * | category             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | referenceLink        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | referenceName        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | organizationId       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | organizationName     | string | like |  |
         * | vendorId             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | vendorName           | string | like |  |
         * | seenAt               | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | seen                 | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty |  |
         * | assignee             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | assigneeName         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | assigneeEmail        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | createdByName        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | createdByEmail       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | tagName              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | tagColor             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | tagId                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | tagCreatedBy         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | taskTagContactId     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | taskTagEmployeeId    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | taskTagType          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | taskTagEmployeeName  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | taskTagEmployeeEmail | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | taskTagContactName   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | taskTagContactEmail  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | subauditId           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | project              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | commentsCount        | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /** Search by title, description, reference, assignee, creator, organization, tag name, tag color, tag id, tag created by, task tag contact name, task tag contact email, task tag employee name, task tag employee email */
        searchTerm?: string;
        /**
         * User ID to filter tasks by assignee (overrides current user)
         * @format uuid
         */
        userId?: string;
        /**
         * User ID to filter tasks by creator
         * @format uuid
         */
        createdBy?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<TaskListDto, void>({
        path: `/internal-portal/projects/${id}/tasks`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Organizations
     * @name OrganizationsControllerGetOrganizations
     * @request GET:/internal-portal/organizations
     * @secure
     */
    organizationsControllerGetOrganizations: (
      query?: {
        isActive?: boolean;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - status
         * - clientStatus
         * - isActive
         * - primaryContact
         * - locationsCount
         * - openAuditsCount
         * - parentOrganization
         * - financialMetrics.inScopeSpend
         * - financialMetrics.savingsIdentified
         * - financialMetrics.savingsApproved
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                                | Type                          | Allowed Rules                                                                | Possible Values                                                                                                         |
         * | ---------------------------------- | ----------------------------- | ---------------------------------------------------------------------------- | ----------------------------------------------------------------------------------------------------------------------- |
         * | id                                 | string                        | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                                         |
         * | name                               | string                        | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                                         |
         * | status                             | string                        | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | active, inactive                                                                                                        |
         * | clientStatus                       | object                        |                                                                              | bill_pay, customer_success, dormant, mobilization, negotiation, post_negotiation, pre_negotiation, prospect, validation |
         * | isActive                           | boolean                       | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                                                                                         |
         * | primaryContact                     | organizationprimarycontactdto |                                                                              |                                                                                                                         |
         * | locationsCount                     | number                        | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                                         |
         * | openAuditsCount                    | number                        | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                                         |
         * | parentOrganization                 | plainorganizationdto          |                                                                              |                                                                                                                         |
         * | financialMetrics.inScopeSpend      | number                        | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                                         |
         * | financialMetrics.savingsIdentified | number                        | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                                         |
         * | financialMetrics.savingsApproved   | number                        | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                                         |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         * - primaryContact.name
         * - primaryContact.email
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<OrganizationListDto, void>({
        path: `/internal-portal/organizations`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Organizations
     * @name OrganizationsControllerCreateOrganization
     * @request POST:/internal-portal/organizations
     * @secure
     */
    organizationsControllerCreateOrganization: (
      data: CreateOrganizationDto,
      params: RequestParams = {}
    ) =>
      this.request<OrganizationListItemDto, void>({
        path: `/internal-portal/organizations`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Organizations
     * @name OrganizationsControllerExportOrganizations
     * @request GET:/internal-portal/organizations/export
     * @secure
     */
    organizationsControllerExportOrganizations: (
      query: {
        isActive?: boolean;
        /** JSON array of column paths. Headers are auto-generated from keys. Example: ["name","status"] */
        columns: string;
        /** Custom filename for the CSV download (without extension). */
        filename?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - status
         * - clientStatus
         * - isActive
         * - primaryContact
         * - locationsCount
         * - openAuditsCount
         * - parentOrganization
         * - financialMetrics.inScopeSpend
         * - financialMetrics.savingsIdentified
         * - financialMetrics.savingsApproved
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                                | Type                          | Allowed Rules                                                                | Possible Values                                                                                                         |
         * | ---------------------------------- | ----------------------------- | ---------------------------------------------------------------------------- | ----------------------------------------------------------------------------------------------------------------------- |
         * | id                                 | string                        | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                                         |
         * | name                               | string                        | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                                         |
         * | status                             | string                        | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | active, inactive                                                                                                        |
         * | clientStatus                       | object                        |                                                                              | bill_pay, customer_success, dormant, mobilization, negotiation, post_negotiation, pre_negotiation, prospect, validation |
         * | isActive                           | boolean                       | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                                                                                         |
         * | primaryContact                     | organizationprimarycontactdto |                                                                              |                                                                                                                         |
         * | locationsCount                     | number                        | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                                         |
         * | openAuditsCount                    | number                        | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                                         |
         * | parentOrganization                 | plainorganizationdto          |                                                                              |                                                                                                                         |
         * | financialMetrics.inScopeSpend      | number                        | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                                         |
         * | financialMetrics.savingsIdentified | number                        | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                                         |
         * | financialMetrics.savingsApproved   | number                        | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                                         |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         * - primaryContact.name
         * - primaryContact.email
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<StreamableFile, void>({
        path: `/internal-portal/organizations/export`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Organizations
     * @name OrganizationsControllerGetSubsidiaries
     * @request GET:/internal-portal/organizations/{organizationId}/subsidiaries
     * @secure
     */
    organizationsControllerGetSubsidiaries: (
      organizationId: string,
      query?: {
        isActive?: boolean;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - status
         * - clientStatus
         * - isActive
         * - primaryContact
         * - locationsCount
         * - openAuditsCount
         * - parentOrganization
         * - financialMetrics.inScopeSpend
         * - financialMetrics.savingsIdentified
         * - financialMetrics.savingsApproved
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                                | Type                          | Allowed Rules                                                                | Possible Values                                                                                                         |
         * | ---------------------------------- | ----------------------------- | ---------------------------------------------------------------------------- | ----------------------------------------------------------------------------------------------------------------------- |
         * | id                                 | string                        | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                                         |
         * | name                               | string                        | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                                         |
         * | status                             | string                        | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | active, inactive                                                                                                        |
         * | clientStatus                       | object                        |                                                                              | bill_pay, customer_success, dormant, mobilization, negotiation, post_negotiation, pre_negotiation, prospect, validation |
         * | isActive                           | boolean                       | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                                                                                         |
         * | primaryContact                     | organizationprimarycontactdto |                                                                              |                                                                                                                         |
         * | locationsCount                     | number                        | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                                         |
         * | openAuditsCount                    | number                        | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                                         |
         * | parentOrganization                 | plainorganizationdto          |                                                                              |                                                                                                                         |
         * | financialMetrics.inScopeSpend      | number                        | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                                         |
         * | financialMetrics.savingsIdentified | number                        | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                                         |
         * | financialMetrics.savingsApproved   | number                        | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                                         |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         * - primaryContact.name
         * - primaryContact.email
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<OrganizationListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/subsidiaries`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Organizations
     * @name OrganizationsControllerGetOrganizationOverview
     * @request GET:/internal-portal/organizations/{organizationId}/overview
     * @secure
     */
    organizationsControllerGetOrganizationOverview: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<OrganizationOverviewDto, void>({
        path: `/internal-portal/organizations/${organizationId}/overview`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Organizations
     * @name OrganizationsControllerGetMainPointOfContact
     * @request GET:/internal-portal/organizations/{organizationId}/main-point-of-contact
     * @secure
     */
    organizationsControllerGetMainPointOfContact: (
      organizationId: string,
      query?: {
        locationId?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<ContactDto, void>({
        path: `/internal-portal/organizations/${organizationId}/main-point-of-contact`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Organizations
     * @name OrganizationsControllerUpdateOrganization
     * @request PATCH:/internal-portal/organizations/{organizationId}
     * @secure
     */
    organizationsControllerUpdateOrganization: (
      organizationId: string,
      data: UpdateOrganizationDto,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/internal-portal/organizations/${organizationId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization relations
     * @name OrganizationRelationsControllerGetUnassignedOrganizationVendors
     * @request GET:/internal-portal/organizations/{organizationId}/vendors/unassigned
     * @secure
     */
    organizationRelationsControllerGetUnassignedOrganizationVendors: (
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - lastUpdated
         * - clientOrganisationsCount
         * - contactsCount
         * - openTicketsCount
         * - openTasksCount
         * - contractsCount
         * - auditsCount
         * - totalSpend
         * - status
         * - assignee
         * - spendCategories
         * - spendAreas
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                      | Type   | Allowed Rules                                                                | Possible Values |
         * | ------------------------ | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id                       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name                     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | lastUpdated              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | clientOrganisationsCount | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | contactsCount            | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | openTicketsCount         | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | openTasksCount           | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | contractsCount           | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | auditsCount              | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | totalSpend               | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | status                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assignee                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | spendCategories          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | spendAreas               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<VendorClientListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/vendors/unassigned`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization relations
     * @name OrganizationRelationsControllerGetOrganizationVendors
     * @request GET:/internal-portal/organizations/{organizationId}/vendors
     * @secure
     */
    organizationRelationsControllerGetOrganizationVendors: (
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - lastUpdated
         * - clientOrganisationsCount
         * - contactsCount
         * - openTicketsCount
         * - openTasksCount
         * - contractsCount
         * - auditsCount
         * - totalSpend
         * - status
         * - assignee
         * - spendCategories
         * - spendAreas
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                      | Type   | Allowed Rules                                                                | Possible Values |
         * | ------------------------ | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id                       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name                     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | lastUpdated              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | clientOrganisationsCount | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | contactsCount            | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | openTicketsCount         | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | openTasksCount           | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | contractsCount           | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | auditsCount              | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | totalSpend               | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | status                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assignee                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | spendCategories          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | spendAreas               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<VendorClientListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/vendors`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization relations
     * @name OrganizationRelationsControllerGetOrganizationTasks
     * @request GET:/internal-portal/organizations/{organizationId}/tasks
     * @secure
     */
    organizationRelationsControllerGetOrganizationTasks: (
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - title
         * - description
         * - category
         * - priorityLevel
         * - completed
         * - deadline
         * - assigneeName
         * - assigneeEmail
         * - referenceName
         * - ticketId
         * - ticketNumber
         * - createdAt
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key           | Type   | Allowed Rules                                                                | Possible Values |
         * | ------------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | title         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | description   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | category      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | priorityLevel | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | completed     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | deadline      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeName  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeEmail | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | referenceName | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | ticketId      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | ticketNumber  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdAt     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - title
         * - description
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<IpOrganizationTaskListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/tasks`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization relations
     * @name OrganizationRelationsControllerGetOrganizationTickets
     * @request GET:/internal-portal/organizations/{organizationId}/tickets
     * @secure
     */
    organizationRelationsControllerGetOrganizationTickets: (
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - vectorTicketId
         * - subject
         * - description
         * - status
         * - priority
         * - category
         * - subCategory
         * - vendorName
         * - location
         * - zip
         * - address
         * - city
         * - state
         * - subStatus
         * - assignee
         * - assigneeEmail
         * - assigneeName
         * - requestorEmail
         * - requestorName
         * - organizationId
         * - organizationName
         * - vendorId
         * - ticketNumber
         * - accessToExternalUser
         * - createdAt
         * - updatedAt
         * - dueDate
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                  | Type    | Allowed Rules                                                                | Possible Values |
         * | -------------------- | ------- | ---------------------------------------------------------------------------- | --------------- |
         * | id                   | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vectorTicketId       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subject              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | description          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | status               | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | priority             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | category             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subCategory          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorName           | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | location             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | zip                  | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | address              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | city                 | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | state                | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subStatus            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assignee             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeEmail        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeName         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestorEmail       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestorName        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationId       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationName     | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorId             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | ticketNumber         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | accessToExternalUser | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | createdAt            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | dueDate              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - subject
         * - description
         * - category
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<IpOrganizationTicketListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/tickets`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Vendors
     * @name VendorsControllerGetVendors
     * @request GET:/internal-portal/vendors
     * @secure
     */
    vendorsControllerGetVendors: (
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - lastUpdated
         * - clientOrganisationsCount
         * - contactsCount
         * - openTicketsCount
         * - openTasksCount
         * - contractsCount
         * - auditsCount
         * - totalSpend
         * - status
         * - assignee
         * - spendCategories
         * - spendAreas
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                      | Type   | Allowed Rules                                                                | Possible Values |
         * | ------------------------ | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id                       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name                     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | lastUpdated              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | clientOrganisationsCount | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | contactsCount            | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | openTicketsCount         | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | openTasksCount           | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | contractsCount           | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | auditsCount              | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | totalSpend               | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | status                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assignee                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | spendCategories          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | spendAreas               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<VendorListDto, void>({
        path: `/internal-portal/vendors`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Vendors
     * @name VendorsControllerCreateVendor
     * @request POST:/internal-portal/vendors
     * @secure
     */
    vendorsControllerCreateVendor: (
      data: CreateVendorDto,
      params: RequestParams = {}
    ) =>
      this.request<VendorDetailDto, void>({
        path: `/internal-portal/vendors`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Vendors
     * @name VendorsControllerListSpendCategories
     * @request GET:/internal-portal/vendors/spend-categories
     * @secure
     */
    vendorsControllerListSpendCategories: (
      query?: {
        /** When set, spend categories already linked to this vendor are excluded from the list (use when adding categories to an existing vendor). Accepts any vendor.id value. */
        excludeVendorId?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - spendAreaId
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type   | Allowed Rules                                                                | Possible Values |
         * | ----------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | spendAreaId | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<SpendCategoryListDto, void>({
        path: `/internal-portal/vendors/spend-categories`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Vendors
     * @name VendorsControllerGetImportTemplate
     * @request GET:/internal-portal/vendors/template
     * @secure
     */
    vendorsControllerGetImportTemplate: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/internal-portal/vendors/template`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Vendors
     * @name VendorsControllerGetVendorById
     * @request GET:/internal-portal/vendors/{vendorId}
     * @secure
     */
    vendorsControllerGetVendorById: (
      vendorId: string,
      params: RequestParams = {}
    ) =>
      this.request<VendorDetailDto, void>({
        path: `/internal-portal/vendors/${vendorId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Vendors
     * @name VendorsControllerUpdateVendor
     * @request PATCH:/internal-portal/vendors/{vendorId}
     * @secure
     */
    vendorsControllerUpdateVendor: (
      vendorId: string,
      data: UpdateVendorDto,
      params: RequestParams = {}
    ) =>
      this.request<VendorDetailDto, void>({
        path: `/internal-portal/vendors/${vendorId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Vendors
     * @name VendorsControllerGetVendorOrganizations
     * @request GET:/internal-portal/vendors/{vendorId}/organizations
     * @secure
     */
    vendorsControllerGetVendorOrganizations: (
      vendorId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key  | Type   | Allowed Rules                                                                | Possible Values |
         * | ---- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<VendorOrganizationSelectListDto, void>({
        path: `/internal-portal/vendors/${vendorId}/organizations`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Vendors
     * @name VendorsControllerGetVendorByIdForOrganization
     * @request GET:/internal-portal/vendors/{vendorId}/organizations/{organizationId}
     * @secure
     */
    vendorsControllerGetVendorByIdForOrganization: (
      vendorId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<VendorClientDetailDto, void>({
        path: `/internal-portal/vendors/${vendorId}/organizations/${organizationId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Vendors
     * @name VendorsControllerValidateImport
     * @request POST:/internal-portal/vendors/import
     * @secure
     */
    vendorsControllerValidateImport: (
      data: FileUploadDto,
      params: RequestParams = {}
    ) =>
      this.request<VendorImportResultDto, void>({
        path: `/internal-portal/vendors/import`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Vendors
     * @name VendorsControllerCreateMany
     * @request POST:/internal-portal/vendors/many
     * @secure
     */
    vendorsControllerCreateMany: (
      data: VendorCreateManyDto,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/internal-portal/vendors/many`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Vendors
     * @name VendorsControllerUpdateVendorBillPay
     * @summary Update vendor bill pay fields and optionally upload, replace, or remove the W9 file
     * @request PATCH:/internal-portal/vendors/{vendorId}/billpay
     * @secure
     */
    vendorsControllerUpdateVendorBillPay: (
      vendorId: string,
      data: UpdateVendorBillPayDto,
      params: RequestParams = {}
    ) =>
      this.request<VendorDetailDto, void>({
        path: `/internal-portal/vendors/${vendorId}/billpay`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contacts
     * @name VendorContactsControllerGetVendorContacts
     * @request GET:/internal-portal/internal-portal/vendors/{vendorId}/contacts
     * @secure
     */
    vendorContactsControllerGetVendorContacts: (
      vendorId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - email
         * - firstName
         * - lastName
         * - title
         * - isActive
         * - phoneNumber
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type    | Allowed Rules                                                                | Possible Values |
         * | ----------- | ------- | ---------------------------------------------------------------------------- | --------------- |
         * | id          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | email       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | firstName   | object  |                                                                              |                 |
         * | lastName    | object  |                                                                              |                 |
         * | title       | object  |                                                                              |                 |
         * | isActive    | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | phoneNumber | object  |                                                                              |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         * - email
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<ContactsListDto, void>({
        path: `/internal-portal/internal-portal/vendors/${vendorId}/contacts`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendor relations
     * @name VendorRelationsControllerCreateVendorTicket
     * @request POST:/internal-portal/vendors/{vendorId}/tickets
     * @secure
     */
    vendorRelationsControllerCreateVendorTicket: (
      vendorId: string,
      data: CreateTicketDto,
      params: RequestParams = {}
    ) =>
      this.request<TicketWithDetailsDto, void>({
        path: `/internal-portal/vendors/${vendorId}/tickets`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendor relations
     * @name VendorRelationsControllerGetVendorTickets
     * @request GET:/internal-portal/vendors/{vendorId}/tickets
     * @secure
     */
    vendorRelationsControllerGetVendorTickets: (
      vendorId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - vectorTicketId
         * - subject
         * - description
         * - status
         * - priority
         * - category
         * - subCategory
         * - vendorName
         * - location
         * - zip
         * - address
         * - city
         * - state
         * - subStatus
         * - assignee
         * - assigneeEmail
         * - assigneeName
         * - requestorEmail
         * - requestorName
         * - organizationId
         * - organizationName
         * - vendorId
         * - ticketNumber
         * - accessToExternalUser
         * - createdAt
         * - updatedAt
         * - dueDate
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                  | Type    | Allowed Rules                                                                | Possible Values |
         * | -------------------- | ------- | ---------------------------------------------------------------------------- | --------------- |
         * | id                   | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vectorTicketId       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subject              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | description          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | status               | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | priority             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | category             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subCategory          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorName           | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | location             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | zip                  | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | address              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | city                 | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | state                | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subStatus            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assignee             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeEmail        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeName         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestorEmail       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestorName        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationId       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationName     | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorId             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | ticketNumber         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | accessToExternalUser | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | createdAt            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | dueDate              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - subject
         * - description
         * - category
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<TicketListDto, void>({
        path: `/internal-portal/vendors/${vendorId}/tickets`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendor relations
     * @name VendorRelationsControllerGetVendorTasks
     * @request GET:/internal-portal/vendors/{vendorId}/tasks
     * @secure
     */
    vendorRelationsControllerGetVendorTasks: (
      vendorId: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - title
         * - description
         * - priorityLevel
         * - referenceLink
         * - referenceName
         * - category
         * - completed
         * - completedAt
         * - deadline
         * - seenAt
         * - seen
         * - subauditId
         * - timeLogged
         * - estimatedTime
         * - assignee
         * - createdByName
         * - organization
         * - organizationName
         * - vendor
         * - vendorName
         * - createdAt
         * - updatedAt
         * - project
         * - commentsCount
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | id                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | title                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | description          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | completed            | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty |  |
         * | priorityLevel        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | createdAt            | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | updatedAt            | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | deadline             | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | completedAt          | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | timeLogged           | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty |  |
         * | estimatedTime        | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty |  |
         * | category             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | referenceLink        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | referenceName        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | organizationId       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | organizationName     | string | like |  |
         * | vendorId             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | vendorName           | string | like |  |
         * | seenAt               | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | seen                 | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty |  |
         * | assignee             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | assigneeName         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | assigneeEmail        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | createdByName        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | createdByEmail       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | tagName              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | tagColor             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | tagId                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | tagCreatedBy         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | taskTagContactId     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | taskTagEmployeeId    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | taskTagType          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | taskTagEmployeeName  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | taskTagEmployeeEmail | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | taskTagContactName   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | taskTagContactEmail  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | subauditId           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | project              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | commentsCount        | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /** Search by title, description, reference, assignee, creator, organization, tag name, tag color, tag id, tag created by, task tag contact name, task tag contact email, task tag employee name, task tag employee email */
        searchTerm?: string;
        /**
         * User ID to filter tasks by assignee (overrides current user)
         * @format uuid
         */
        userId?: string;
        /**
         * User ID to filter tasks by creator
         * @format uuid
         */
        createdBy?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<TaskListDto, void>({
        path: `/internal-portal/vendors/${vendorId}/tasks`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Locations
     * @name LocationsControllerGetLocations
     * @request GET:/internal-portal/organizations/{organizationId}/locations
     * @secure
     */
    locationsControllerGetLocations: (
      organizationId: string,
      query?: {
        withSubsidiaries?: boolean;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - displayName
         * - mainPointOfContact
         * - address
         * - locationIdentifier
         * - city
         * - state
         * - zip
         * - taxId
         * - subsidiaryOrganizationName
         * - status
         * - stages
         * - savings
         * - documentFieldStatus
         * - activeAudits
         * - isMissingRow
         * - squareFootage
         * - weatherStation
         * - hoursOfOperation
         * - units
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                        | Type       | Allowed Rules                                                                | Possible Values                                                                     |
         * | -------------------------- | ---------- | ---------------------------------------------------------------------------- | ----------------------------------------------------------------------------------- |
         * | id                         | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | name                       | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | displayName                | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | mainPointOfContact         | contactdto |                                                                              |                                                                                     |
         * | address                    | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | locationIdentifier         | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | city                       | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | state                      | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | zip                        | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | taxId                      | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | subsidiaryOrganizationName | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | status                     | object     |                                                                              | Active, Monitored, Sold, Closed, Under Construction, Not Active                     |
         * | stages                     | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | savings                    | number     | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                     |
         * | documentFieldStatus        | object     |                                                                              | COMPLETE, MISSING_FIELDS, UPLOAD_INVOICES, NOT_APPLICABLE_REQUESTED, NOT_APPLICABLE |
         * | activeAudits               | number     | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                     |
         * | isMissingRow               | boolean    | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                                                     |
         * | squareFootage              | number     | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                     |
         * | weatherStation             | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | hoursOfOperation           | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | units                      | number     | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                     |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         * - address
         * - city
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<LocationsDto, void>({
        path: `/internal-portal/organizations/${organizationId}/locations`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Locations
     * @name LocationsControllerCreateLocation
     * @request POST:/internal-portal/organizations/{organizationId}/locations
     * @secure
     */
    locationsControllerCreateLocation: (
      organizationId: string,
      data: IpCreateLocationDto,
      params: RequestParams = {}
    ) =>
      this.request<LocationDetailDto, void>({
        path: `/internal-portal/organizations/${organizationId}/locations`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Locations
     * @name LocationsControllerExportLocations
     * @request GET:/internal-portal/organizations/{organizationId}/locations/export
     * @secure
     */
    locationsControllerExportLocations: (
      organizationId: string,
      query: {
        withSubsidiaries?: boolean;
        /** JSON array of column paths. Headers are auto-generated from keys. Example: ["name","status"] */
        columns: string;
        /** Custom filename for the CSV download (without extension). */
        filename?: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - displayName
         * - mainPointOfContact
         * - address
         * - locationIdentifier
         * - city
         * - state
         * - zip
         * - taxId
         * - subsidiaryOrganizationName
         * - status
         * - stages
         * - savings
         * - documentFieldStatus
         * - activeAudits
         * - isMissingRow
         * - squareFootage
         * - weatherStation
         * - hoursOfOperation
         * - units
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                        | Type       | Allowed Rules                                                                | Possible Values                                                                     |
         * | -------------------------- | ---------- | ---------------------------------------------------------------------------- | ----------------------------------------------------------------------------------- |
         * | id                         | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | name                       | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | displayName                | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | mainPointOfContact         | contactdto |                                                                              |                                                                                     |
         * | address                    | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | locationIdentifier         | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | city                       | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | state                      | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | zip                        | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | taxId                      | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | subsidiaryOrganizationName | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | status                     | object     |                                                                              | Active, Monitored, Sold, Closed, Under Construction, Not Active                     |
         * | stages                     | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | savings                    | number     | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                     |
         * | documentFieldStatus        | object     |                                                                              | COMPLETE, MISSING_FIELDS, UPLOAD_INVOICES, NOT_APPLICABLE_REQUESTED, NOT_APPLICABLE |
         * | activeAudits               | number     | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                     |
         * | isMissingRow               | boolean    | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                                                     |
         * | squareFootage              | number     | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                     |
         * | weatherStation             | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | hoursOfOperation           | string     | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                     |
         * | units                      | number     | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                     |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         * - address
         * - city
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<StreamableFile, void>({
        path: `/internal-portal/organizations/${organizationId}/locations/export`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Locations
     * @name LocationsControllerGetImportTemplate
     * @request GET:/internal-portal/organizations/{organizationId}/locations/template
     * @secure
     */
    locationsControllerGetImportTemplate: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/internal-portal/organizations/${organizationId}/locations/template`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Locations
     * @name LocationsControllerGetLocationById
     * @request GET:/internal-portal/organizations/{organizationId}/locations/{locationId}
     * @secure
     */
    locationsControllerGetLocationById: (
      locationId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<LocationDetailDto, void>({
        path: `/internal-portal/organizations/${organizationId}/locations/${locationId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Locations
     * @name LocationsControllerUpdateLocation
     * @request PATCH:/internal-portal/organizations/{organizationId}/locations/{locationId}
     * @secure
     */
    locationsControllerUpdateLocation: (
      locationId: string,
      organizationId: string,
      data: IpUpdateLocationDto,
      params: RequestParams = {}
    ) =>
      this.request<LocationDetailDto, void>({
        path: `/internal-portal/organizations/${organizationId}/locations/${locationId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Locations
     * @name LocationsControllerDeleteLocation
     * @request DELETE:/internal-portal/organizations/{organizationId}/locations/{locationId}
     * @secure
     */
    locationsControllerDeleteLocation: (
      locationId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/internal-portal/organizations/${organizationId}/locations/${locationId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Locations
     * @name LocationsControllerValidateImport
     * @request POST:/internal-portal/organizations/{organizationId}/locations/import
     * @secure
     */
    locationsControllerValidateImport: (
      organizationId: string,
      data: FileUploadDto,
      params: RequestParams = {}
    ) =>
      this.request<LocationImportResultDto, void>({
        path: `/internal-portal/organizations/${organizationId}/locations/import`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Locations
     * @name LocationsControllerCreateMany
     * @request POST:/internal-portal/organizations/{organizationId}/locations/many
     * @secure
     */
    locationsControllerCreateMany: (
      organizationId: string,
      data: LocationCreateManyDto,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/internal-portal/organizations/${organizationId}/locations/many`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Action Items
     * @name ActionItemsControllerGetActionItems
     * @request GET:/internal-portal/action-items
     * @secure
     */
    actionItemsControllerGetActionItems: (
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - assigneeName
         * - assigneeEmail
         * - assignee
         * - title
         * - description
         * - createdAt
         * - updatedAt
         * - deadline
         * - completedAt
         * - spendAreaStage
         * - priorityLevel
         * - actionType
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key            | Type   | Allowed Rules                                                                | Possible Values |
         * | -------------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeName   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeEmail  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assignee       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | title          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | description    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdAt      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | deadline       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | completedAt    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | spendAreaStage | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | priorityLevel  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | actionType     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - title
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<IPActionItemListDto, void>({
        path: `/internal-portal/action-items`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Dashboard
     * @name DashboardControllerGetMetrics
     * @request GET:/internal-portal/dashboard/metrics
     * @secure
     */
    dashboardControllerGetMetrics: (
      query: {
        /** The metric fields to include in the response. */
        fields: DashboardMetricsField[];
      },
      params: RequestParams = {}
    ) =>
      this.request<DashboardMetricsDto, void>({
        path: `/internal-portal/dashboard/metrics`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Dashboard
     * @name DashboardControllerGetPinnedOrganizations
     * @request GET:/internal-portal/dashboard/pinned/organizations
     * @secure
     */
    dashboardControllerGetPinnedOrganizations: (
      query: {
        key: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - status
         * - clientStatus
         * - isActive
         * - primaryContact
         * - locationsCount
         * - openAuditsCount
         * - parentOrganization
         * - financialMetrics.inScopeSpend
         * - financialMetrics.savingsIdentified
         * - financialMetrics.savingsApproved
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                                | Type                          | Allowed Rules                                                                | Possible Values                                                                                                         |
         * | ---------------------------------- | ----------------------------- | ---------------------------------------------------------------------------- | ----------------------------------------------------------------------------------------------------------------------- |
         * | id                                 | string                        | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                                         |
         * | name                               | string                        | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                                                         |
         * | status                             | string                        | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | active, inactive                                                                                                        |
         * | clientStatus                       | object                        |                                                                              | bill_pay, customer_success, dormant, mobilization, negotiation, post_negotiation, pre_negotiation, prospect, validation |
         * | isActive                           | boolean                       | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                                                                                                                         |
         * | primaryContact                     | organizationprimarycontactdto |                                                                              |                                                                                                                         |
         * | locationsCount                     | number                        | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                                         |
         * | openAuditsCount                    | number                        | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                                         |
         * | parentOrganization                 | plainorganizationdto          |                                                                              |                                                                                                                         |
         * | financialMetrics.inScopeSpend      | number                        | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                                         |
         * | financialMetrics.savingsIdentified | number                        | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                                         |
         * | financialMetrics.savingsApproved   | number                        | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                                                                                         |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         * - primaryContact.name
         * - primaryContact.email
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<OrganizationListDto, void>({
        path: `/internal-portal/dashboard/pinned/organizations`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Dashboard
     * @name DashboardControllerGetPinnedVendors
     * @request GET:/internal-portal/dashboard/pinned/vendors
     * @secure
     */
    dashboardControllerGetPinnedVendors: (
      query: {
        key: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - lastUpdated
         * - clientOrganisationsCount
         * - contactsCount
         * - openTicketsCount
         * - openTasksCount
         * - contractsCount
         * - auditsCount
         * - totalSpend
         * - status
         * - assignee
         * - spendCategories
         * - spendAreas
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                      | Type   | Allowed Rules                                                                | Possible Values |
         * | ------------------------ | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id                       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name                     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | lastUpdated              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | clientOrganisationsCount | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | contactsCount            | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | openTicketsCount         | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | openTasksCount           | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | contractsCount           | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | auditsCount              | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | totalSpend               | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | status                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assignee                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | spendCategories          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | spendAreas               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<VendorListDto, void>({
        path: `/internal-portal/dashboard/pinned/vendors`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Dashboard
     * @name DashboardControllerGetPinnedProjects
     * @request GET:/internal-portal/dashboard/pinned/projects
     * @secure
     */
    dashboardControllerGetPinnedProjects: (
      query: {
        key: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - projectStatus
         * - id
         * - name
         * - startDate
         * - targetEndDate
         * - assignee
         * - updatedAt
         * - createdAt
         * - team.id
         * - team.name
         * - owner.id
         * - owner.name
         * - owner.email
         * - owner.avatarUrl
         * - owner.deletedAt
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key             | Type   | Allowed Rules                                                                | Possible Values                                                                         |
         * | --------------- | ------ | ---------------------------------------------------------------------------- | --------------------------------------------------------------------------------------- |
         * | projectStatus   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | unassigned, unstarted, in-progress, on-hold, view-only, in-review, escalated, completed |
         * | id              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                         |
         * | name            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                         |
         * | startDate       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                         |
         * | targetEndDate   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                         |
         * | assignee        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                         |
         * | updatedAt       | date   | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                                                                                         |
         * | createdAt       | date   | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty   |                                                                                         |
         * | team.id         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                         |
         * | team.name       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                         |
         * | owner.id        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                         |
         * | owner.name      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                         |
         * | owner.email     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                                                         |
         * | owner.avatarUrl | object |                                                                              |                                                                                         |
         * | owner.deletedAt | object |                                                                              |                                                                                         |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<ProjectListDto, void>({
        path: `/internal-portal/dashboard/pinned/projects`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Dashboard
     * @name DashboardControllerGetPinnedTeams
     * @request GET:/internal-portal/dashboard/pinned/teams
     * @secure
     */
    dashboardControllerGetPinnedTeams: (
      query: {
        key: string;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - activeTaskCount
         * - allTaskCount
         * - userCount
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key             | Type   | Allowed Rules                                                                | Possible Values |
         * | --------------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | activeTaskCount | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | allTaskCount    | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | userCount       | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<IpTeamListDto, void>({
        path: `/internal-portal/dashboard/pinned/teams`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Teams
     * @name TeamsControllerGetTeams
     * @request GET:/internal-portal/teams
     * @secure
     */
    teamsControllerGetTeams: (
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - activeTaskCount
         * - allTaskCount
         * - userCount
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key             | Type   | Allowed Rules                                                                | Possible Values |
         * | --------------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | activeTaskCount | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | allTaskCount    | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         * | userCount       | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<IpTeamListDto, void>({
        path: `/internal-portal/teams`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audits
     * @name AuditsControllerFindAll
     * @request GET:/internal-portal/organizations/{organizationId}/audits
     * @secure
     */
    auditsControllerFindAll: (
      organizationId: string,
      query?: {
        /** Filter audits by included location ids */
        locationIds?: string[];
        withSubsidiaries?: boolean;
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - status
         * - stage
         * - vendor
         * - creator
         * - owner
         * - team
         * - createdAt
         * - spendCategory
         * - includedLocations
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key               | Type   | Allowed Rules                                                                | Possible Values |
         * | ----------------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | name              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | status            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | stage             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendor            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | creator           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | owner             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | team              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdAt         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | spendCategory     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | includedLocations | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<AuditListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audits
     * @name AuditsControllerCreate
     * @request POST:/internal-portal/organizations/{organizationId}/audits
     * @secure
     */
    auditsControllerCreate: (
      organizationId: string,
      data: CreateAuditDto,
      params: RequestParams = {}
    ) =>
      this.request<AuditItemDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audits
     * @name AuditsControllerGetAverageDuration
     * @request GET:/internal-portal/organizations/{organizationId}/audits/average-duration
     * @secure
     */
    auditsControllerGetAverageDuration: (
      organizationId: string,
      query: {
        /**
         * Spend category id to compute the average for
         * @format uuid
         */
        spendCategoryId: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<AverageAuditDurationDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/average-duration`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audits
     * @name AuditsControllerFindOne
     * @request GET:/internal-portal/organizations/{organizationId}/audits/{auditId}
     * @secure
     */
    auditsControllerFindOne: (
      auditId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<AuditItemDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audits
     * @name AuditsControllerUpdate
     * @request PATCH:/internal-portal/organizations/{organizationId}/audits/{auditId}
     * @secure
     */
    auditsControllerUpdate: (
      auditId: string,
      organizationId: string,
      data: UpdateAuditDto,
      params: RequestParams = {}
    ) =>
      this.request<AuditItemDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Documents
     * @name AuditDocumentControllerListAttachedDocuments
     * @request GET:/internal-portal/organizations/{organizationId}/audits/{auditId}/documents
     * @secure
     */
    auditDocumentControllerListAttachedDocuments: (
      organizationId: string,
      auditId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - uploadedAuditStage
         * - attachedFromDocumentsRepo
         * - stage
         * - vendor
         * - name
         * - createdAt
         * - updatedAt
         * - providedBy
         * - type
         * - spendCategory
         * - id
         * - uploadedBy
         * - startDate
         * - endDate
         * - renewalDate
         * - annualContractValue
         * - notToExceed
         * - annualPriceIncrease
         * - earlyTerminationFee
         * - contractType
         * - categoryManager
         * - categoryManagerUser
         * - paymentFrequency
         * - cancellationDateNoticePeriod
         * - autoRenewalClause
         * - autoRenewalLength
         * - notToExceedPercentage
         * - sensitive
         * - tags
         * - virtual
         * - additionalColumns.key
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                          | Type   | Allowed Rules                                                                | Possible Values |
         * | ---------------------------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | uploadedAuditStage           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | attachedFromDocumentsRepo    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | stage                        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendor                       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name                         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdAt                    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt                    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | providedBy                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | type                         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | spendCategory                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | id                           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | uploadedBy                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | startDate                    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | endDate                      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | renewalDate                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | annualContractValue          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | notToExceed                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | annualPriceIncrease          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | earlyTerminationFee          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | contractType                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | categoryManager              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | categoryManagerUser          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | paymentFrequency             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | cancellationDateNoticePeriod | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | autoRenewalClause            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | autoRenewalLength            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | notToExceedPercentage        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | sensitive                    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | tags                         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | virtual                      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | additionalColumns.key        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - document.filename
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<AuditDocumentListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/documents`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Documents
     * @name AuditDocumentControllerListPickerDocuments
     * @request GET:/internal-portal/organizations/{organizationId}/audits/{auditId}/documents/picker
     * @secure
     */
    auditDocumentControllerListPickerDocuments: (
      organizationId: string,
      auditId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - linkedToThisAudit
         * - uploadedAuditStage
         * - attachedFromDocumentsRepo
         * - stage
         * - vendor
         * - name
         * - createdAt
         * - updatedAt
         * - providedBy
         * - type
         * - spendCategory
         * - id
         * - uploadedBy
         * - startDate
         * - endDate
         * - renewalDate
         * - annualContractValue
         * - notToExceed
         * - annualPriceIncrease
         * - earlyTerminationFee
         * - contractType
         * - categoryManager
         * - categoryManagerUser
         * - paymentFrequency
         * - cancellationDateNoticePeriod
         * - autoRenewalClause
         * - autoRenewalLength
         * - notToExceedPercentage
         * - sensitive
         * - tags
         * - virtual
         * - additionalColumns.key
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                          | Type   | Allowed Rules                                                                | Possible Values |
         * | ---------------------------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | linkedToThisAudit            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | uploadedAuditStage           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | attachedFromDocumentsRepo    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | stage                        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendor                       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name                         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | createdAt                    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt                    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | providedBy                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | type                         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | spendCategory                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | id                           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | uploadedBy                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | startDate                    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | endDate                      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | renewalDate                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | annualContractValue          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | notToExceed                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | annualPriceIncrease          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | earlyTerminationFee          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | contractType                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | categoryManager              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | categoryManagerUser          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | paymentFrequency             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | cancellationDateNoticePeriod | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | autoRenewalClause            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | autoRenewalLength            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | notToExceedPercentage        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | sensitive                    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | tags                         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | virtual                      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | additionalColumns.key        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - filename
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<AuditDocumentListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/documents/picker`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Documents
     * @name AuditDocumentControllerAttachDocuments
     * @request POST:/internal-portal/organizations/{organizationId}/audits/{auditId}/documents/attach
     * @secure
     */
    auditDocumentControllerAttachDocuments: (
      auditId: string,
      organizationId: string,
      data: AttachAuditDocumentsDto,
      params: RequestParams = {}
    ) =>
      this.request<AttachAuditDocumentsResultDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/documents/attach`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Documents
     * @name AuditDocumentControllerDetachDocuments
     * @request POST:/internal-portal/organizations/{organizationId}/audits/{auditId}/documents/detach
     * @secure
     */
    auditDocumentControllerDetachDocuments: (
      auditId: string,
      organizationId: string,
      data: DetachAuditDocumentsDto,
      params: RequestParams = {}
    ) =>
      this.request<DetachAuditDocumentsResultDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/documents/detach`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Documents
     * @name AuditDocumentControllerBulkUpdateDocuments
     * @summary Update fields on multiple documents linked to this audit (same body as org bulk update)
     * @request PATCH:/internal-portal/organizations/{organizationId}/audits/{auditId}/documents/bulk-update
     * @secure
     */
    auditDocumentControllerBulkUpdateDocuments: (
      auditId: string,
      organizationId: string,
      data: BulkUpdateDocumentDto,
      params: RequestParams = {}
    ) =>
      this.request<AuditDocumentDto[], void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/documents/bulk-update`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Documents
     * @name AuditDocumentControllerUpdateDocument
     * @summary Update fields on a document linked to this audit
     * @request PATCH:/internal-portal/organizations/{organizationId}/audits/{auditId}/documents/{documentId}
     * @secure
     */
    auditDocumentControllerUpdateDocument: (
      documentId: string,
      auditId: string,
      organizationId: string,
      data: UpdateDocumentDto,
      params: RequestParams = {}
    ) =>
      this.request<AuditDocumentDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/documents/${documentId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Documents
     * @name AuditDocumentControllerDeleteDocument
     * @request DELETE:/internal-portal/organizations/{organizationId}/audits/{auditId}/documents/{documentId}
     * @secure
     */
    auditDocumentControllerDeleteDocument: (
      documentId: string,
      auditId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<DeleteAuditDocumentsResultDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/documents/${documentId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Documents
     * @name AuditDocumentControllerGetUploadUrl
     * @summary Use POST /upload with multipart streaming instead.
     * @request POST:/internal-portal/organizations/{organizationId}/audits/{auditId}/documents/upload-url
     * @deprecated
     * @secure
     */
    auditDocumentControllerGetUploadUrl: (
      auditId: string,
      organizationId: string,
      data: BulkGenerateUploadUrlDto,
      params: RequestParams = {}
    ) =>
      this.request<BulkGenerateUploadUrlResponseDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/documents/upload-url`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Documents
     * @name AuditDocumentControllerInitUploadSession
     * @summary Initialize a chunked direct-to-Azure upload session (metadata only)
     * @request POST:/internal-portal/organizations/{organizationId}/audits/{auditId}/documents/upload/init
     * @secure
     */
    auditDocumentControllerInitUploadSession: (
      auditId: string,
      organizationId: string,
      data: InitUploadDocumentsDto,
      params: RequestParams = {}
    ) =>
      this.request<InitUploadDocumentsResponseDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/documents/upload/init`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Documents
     * @name AuditDocumentControllerCompleteUploadSession
     * @summary Finalize a chunked upload after all blocks are staged in Azure
     * @request POST:/internal-portal/organizations/{organizationId}/audits/{auditId}/documents/upload/complete
     * @secure
     */
    auditDocumentControllerCompleteUploadSession: (
      auditId: string,
      organizationId: string,
      data: CompleteUploadDocumentDto,
      params: RequestParams = {}
    ) =>
      this.request<AuditDocumentDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/documents/upload/complete`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Documents
     * @name AuditDocumentControllerUploadFile
     * @summary Upload a document via multipart streaming and attach it to this audit
     * @request POST:/internal-portal/organizations/{organizationId}/audits/{auditId}/documents/upload
     * @secure
     */
    auditDocumentControllerUploadFile: (
      auditId: string,
      organizationId: string,
      data: UploadDocumentDto,
      params: RequestParams = {}
    ) =>
      this.request<AuditDocumentDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/documents/upload`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Vendor Accounts
     * @name AuditVendorAccountsControllerList
     * @request GET:/internal-portal/organizations/{organizationId}/audits/{auditId}/vendor-accounts
     * @secure
     */
    auditVendorAccountsControllerList: (
      auditId: string,
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - attachedFromVendorAccountsList
         * - id
         * - accountNumber
         * - name
         * - createdAt
         * - invoiceFrequency
         * - billingType
         * - serviceType
         * - note
         * - vendorName
         * - auditsCount
         * - status
         * - spendCategories
         * - locations
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                            | Type   | Allowed Rules                                                                | Possible Values                                   |
         * | ------------------------------ | ------ | ---------------------------------------------------------------------------- | ------------------------------------------------- |
         * | attachedFromVendorAccountsList | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | id                             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | accountNumber                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | name                           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | createdAt                      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | invoiceFrequency               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | bi_weekly, weekly, monthly, bi_monthly, quarterly |
         * | billingType                    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | paper, email, portal                              |
         * | serviceType                    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | note                           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | vendorName                     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | auditsCount                    | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                   |
         * | status                         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | active, inactive                                  |
         * | spendCategories                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | locations                      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - accountNumber
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<AuditVendorAccountListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/vendor-accounts`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Vendor Accounts
     * @name AuditVendorAccountsControllerListPicker
     * @request GET:/internal-portal/organizations/{organizationId}/audits/{auditId}/vendor-accounts/picker
     * @secure
     */
    auditVendorAccountsControllerListPicker: (
      organizationId: string,
      auditId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - linkedToThisAudit
         * - attachedFromVendorAccountsList
         * - id
         * - accountNumber
         * - name
         * - createdAt
         * - invoiceFrequency
         * - billingType
         * - serviceType
         * - note
         * - vendorName
         * - auditsCount
         * - status
         * - spendCategories
         * - locations
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                            | Type   | Allowed Rules                                                                | Possible Values                                   |
         * | ------------------------------ | ------ | ---------------------------------------------------------------------------- | ------------------------------------------------- |
         * | linkedToThisAudit              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | attachedFromVendorAccountsList | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | id                             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | accountNumber                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | name                           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | createdAt                      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | invoiceFrequency               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | bi_weekly, weekly, monthly, bi_monthly, quarterly |
         * | billingType                    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | paper, email, portal                              |
         * | serviceType                    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | note                           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | vendorName                     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | auditsCount                    | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                                   |
         * | status                         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | active, inactive                                  |
         * | spendCategories                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         * | locations                      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                                   |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - accountNumber
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<AuditVendorAccountListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/vendor-accounts/picker`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Vendor Accounts
     * @name AuditVendorAccountsControllerAttach
     * @request POST:/internal-portal/organizations/{organizationId}/audits/{auditId}/vendor-accounts/attach
     * @secure
     */
    auditVendorAccountsControllerAttach: (
      auditId: string,
      organizationId: string,
      data: AttachAuditVendorAccountsDto,
      params: RequestParams = {}
    ) =>
      this.request<AttachAuditVendorAccountsResultDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/vendor-accounts/attach`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Vendor Accounts
     * @name AuditVendorAccountsControllerDetach
     * @request POST:/internal-portal/organizations/{organizationId}/audits/{auditId}/vendor-accounts/detach
     * @secure
     */
    auditVendorAccountsControllerDetach: (
      auditId: string,
      organizationId: string,
      data: DetachAuditVendorAccountsDto,
      params: RequestParams = {}
    ) =>
      this.request<DetachAuditVendorAccountsResultDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/vendor-accounts/detach`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Spend Estimated
     * @name AuditSpendEstimatedControllerListSpends
     * @request GET:/internal-portal/organizations/{organizationId}/audits/{auditId}/spend-estimated
     * @secure
     */
    auditSpendEstimatedControllerListSpends: (
      auditId: string,
      organizationId: string,
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - vendorAccountNumber
         * - unit
         * - quantity
         * - pricePerUnit
         * - total
         * - occurrenceInterval
         * - locationName
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                 | Type   | Allowed Rules                                                                | Possible Values                        |
         * | ------------------- | ------ | ---------------------------------------------------------------------------- | -------------------------------------- |
         * | id                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                        |
         * | name                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                        |
         * | vendorAccountNumber | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                        |
         * | unit                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                        |
         * | quantity            | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                        |
         * | pricePerUnit        | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                        |
         * | total               | number | eq, neq, gt, gte, lt, lte, between, isempty, isnotempty                      |                                        |
         * | occurrenceInterval  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | one_time, monthly, quarterly, annually |
         * | locationName        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                                        |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         * - vendorAccount.accountNumber
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<SpendEstimatedListDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/spend-estimated`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Spend Estimated
     * @name AuditSpendEstimatedControllerGetImportTemplate
     * @request GET:/internal-portal/organizations/{organizationId}/audits/{auditId}/spend-estimated/template
     * @secure
     */
    auditSpendEstimatedControllerGetImportTemplate: (
      auditId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/spend-estimated/template`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Spend Estimated
     * @name AuditSpendEstimatedControllerValidateImport
     * @request POST:/internal-portal/organizations/{organizationId}/audits/{auditId}/spend-estimated/import
     * @secure
     */
    auditSpendEstimatedControllerValidateImport: (
      auditId: string,
      organizationId: string,
      data: FileUploadDto,
      params: RequestParams = {}
    ) =>
      this.request<SpendEstimatedImportResultDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/spend-estimated/import`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Spend Estimated
     * @name AuditSpendEstimatedControllerConfirmImport
     * @request POST:/internal-portal/organizations/{organizationId}/audits/{auditId}/spend-estimated/import/confirm
     * @secure
     */
    auditSpendEstimatedControllerConfirmImport: (
      auditId: string,
      organizationId: string,
      data: ConfirmSpendEstimatedDto,
      params: RequestParams = {}
    ) =>
      this.request<ConfirmSpendEstimatedResultDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/spend-estimated/import/confirm`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Spend Estimated
     * @name AuditSpendEstimatedControllerGetVendorAccountOptions
     * @request GET:/internal-portal/organizations/{organizationId}/audits/{auditId}/spend-estimated/vendor-accounts
     * @secure
     */
    auditSpendEstimatedControllerGetVendorAccountOptions: (
      auditId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SpendEstimatedVendorAccountOptionDto[], void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/spend-estimated/vendor-accounts`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Spend Estimated
     * @name AuditSpendEstimatedControllerCreateSpend
     * @request POST:/internal-portal/organizations/{organizationId}/audits/{auditId}/spend-estimated/spends
     * @secure
     */
    auditSpendEstimatedControllerCreateSpend: (
      auditId: string,
      organizationId: string,
      data: CreateSpendEstimatedSpendDto,
      params: RequestParams = {}
    ) =>
      this.request<SpendEstimatedSpendDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/spend-estimated/spends`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Spend Estimated
     * @name AuditSpendEstimatedControllerBulkUpdateSpends
     * @request PATCH:/internal-portal/organizations/{organizationId}/audits/{auditId}/spend-estimated/spends/bulk-update
     * @secure
     */
    auditSpendEstimatedControllerBulkUpdateSpends: (
      auditId: string,
      organizationId: string,
      data: BulkUpdateSpendEstimatedSpendsDto,
      params: RequestParams = {}
    ) =>
      this.request<BulkUpdateSpendEstimatedResultDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/spend-estimated/spends/bulk-update`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Spend Estimated
     * @name AuditSpendEstimatedControllerUpdateSpend
     * @request PATCH:/internal-portal/organizations/{organizationId}/audits/{auditId}/spend-estimated/spends/{spendId}
     * @secure
     */
    auditSpendEstimatedControllerUpdateSpend: (
      auditId: string,
      spendId: string,
      organizationId: string,
      data: UpdateSpendEstimatedSpendDto,
      params: RequestParams = {}
    ) =>
      this.request<SpendEstimatedSpendDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/spend-estimated/spends/${spendId}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Spend Estimated
     * @name AuditSpendEstimatedControllerDeleteSpend
     * @request DELETE:/internal-portal/organizations/{organizationId}/audits/{auditId}/spend-estimated/spends/{spendId}
     * @secure
     */
    auditSpendEstimatedControllerDeleteSpend: (
      auditId: string,
      spendId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<DeleteSpendEstimatedResultDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/spend-estimated/spends/${spendId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal Portal - Audit Spend Estimated
     * @name AuditSpendEstimatedControllerBulkDeleteSpends
     * @request POST:/internal-portal/organizations/{organizationId}/audits/{auditId}/spend-estimated/spends/bulk-delete
     * @secure
     */
    auditSpendEstimatedControllerBulkDeleteSpends: (
      auditId: string,
      organizationId: string,
      data: BulkDeleteSpendEstimatedSpendsDto,
      params: RequestParams = {}
    ) =>
      this.request<DeleteSpendEstimatedResultDto, void>({
        path: `/internal-portal/organizations/${organizationId}/audits/${auditId}/spend-estimated/spends/bulk-delete`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  spendAndAnalysis = {
    /**
     * No description
     *
     * @tags SpendAndAnalysis
     * @name SpendAndAnalysisControllerGetOrganizationSavingsSummary
     * @request GET:/spend-and-analysis/{organizationId}/spend-areas-savings-spend
     * @secure
     */
    spendAndAnalysisControllerGetOrganizationSavingsSummary: (
      organizationId: string,
      query?: {
        /**
         * Optional array of spend areas to filter the results
         * @example ["Waste","Treasury"]
         */
        spendArea?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<SpendAreasSavingsSpendResponseDto, void>({
        path: `/spend-and-analysis/${organizationId}/spend-areas-savings-spend`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SpendAndAnalysis
     * @name SpendAndAnalysisControllerGetAnnualSavingsForSpendArea
     * @request GET:/spend-and-analysis/{organizationId}/annual-savings-for-spend-area
     * @secure
     */
    spendAndAnalysisControllerGetAnnualSavingsForSpendArea: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<AnnualSavingsForSpendAreaResponseDto, void>({
        path: `/spend-and-analysis/${organizationId}/annual-savings-for-spend-area`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SpendAndAnalysis
     * @name SpendAndAnalysisControllerGetVectorClientInfo
     * @request GET:/spend-and-analysis/vector-client-info/{id}
     * @secure
     */
    spendAndAnalysisControllerGetVectorClientInfo: (
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<VectorClientInfoDto, void>({
        path: `/spend-and-analysis/vector-client-info/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  spendSavings = {
    /**
     * No description
     *
     * @tags Spend & Savings
     * @name SpendSavingsControllerGetSavingsSummary
     * @request GET:/spend-savings/{organizationId}/summary
     * @secure
     */
    spendSavingsControllerGetSavingsSummary: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SavingSummaryResponseDto, void>({
        path: `/spend-savings/${organizationId}/summary`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Spend & Savings
     * @name SpendSavingsControllerGetOrganizationSpendAreasDetailsNew
     * @request GET:/spend-savings/{organizationId}/spend-areas-details
     * @secure
     */
    spendSavingsControllerGetOrganizationSpendAreasDetailsNew: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SpendAreaDetailsDto, void>({
        path: `/spend-savings/${organizationId}/spend-areas-details`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Spend & Savings
     * @name SpendSavingsControllerGetSpendAreasOverview
     * @request GET:/spend-savings/{organizationId}/spend-areas-overview
     * @secure
     */
    spendSavingsControllerGetSpendAreasOverview: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SpendAreasOverviewResponseDto, void>({
        path: `/spend-savings/${organizationId}/spend-areas-overview`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Spend & Savings
     * @name SpendSavingsControllerGetAnnualSavingsBreakdown
     * @request GET:/spend-savings/{organizationId}/annual-savings-breakdown
     * @secure
     */
    spendSavingsControllerGetAnnualSavingsBreakdown: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<AnnualSavingsBreakdownResponseDto, void>({
        path: `/spend-savings/${organizationId}/annual-savings-breakdown`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Spend & Savings
     * @name SpendSavingsControllerGetVectorClientInfo
     * @request GET:/spend-savings/{organizationId}/vector-client-info
     * @secure
     */
    spendSavingsControllerGetVectorClientInfo: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<VectorClientInfoResponseDto, void>({
        path: `/spend-savings/${organizationId}/vector-client-info`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  spendArea = {
    /**
     * No description
     *
     * @tags Spend Area
     * @name SpendAreaControllerGetSpendAreasOverview
     * @request GET:/spend-area/{organizationId}/overview
     * @secure
     */
    spendAreaControllerGetSpendAreasOverview: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SpendAreasListResponseDto, void>({
        path: `/spend-area/${organizationId}/overview`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  spendCategories = {
    /**
     * No description
     *
     * @tags Spend Categories
     * @name SpendCategoryControllerFindAll
     * @request GET:/spend-categories
     * @secure
     */
    spendCategoryControllerFindAll: (
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - spendAreaId
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type   | Allowed Rules                                                                | Possible Values |
         * | ----------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | id          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | name        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | spendAreaId | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - name
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<SpendCategoryListDto, void>({
        path: `/spend-categories`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  tickets = {
    /**
     * No description
     *
     * @tags Ticket Files
     * @name TicketFilesControllerGetTicketFiles
     * @request GET:/tickets/{ticketId}/files
     * @secure
     */
    ticketFilesControllerGetTicketFiles: (
      ticketId: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - filename
         * - createdAt
         * - updatedAt
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | filename | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<TicketFileListDto, void>({
        path: `/tickets/${ticketId}/files`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ticket Files
     * @name TicketFilesControllerMoveToDocumentRepo
     * @request PUT:/tickets/{ticketId}/files/{fileId}/documents-repo/add
     * @secure
     */
    ticketFilesControllerMoveToDocumentRepo: (
      ticketId: string,
      fileId: string,
      params: RequestParams = {}
    ) =>
      this.request<string, void>({
        path: `/tickets/${ticketId}/files/${fileId}/documents-repo/add`,
        method: 'PUT',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ticket Files
     * @name TicketFilesControllerRemoveFromDocumentRepo
     * @request PUT:/tickets/{ticketId}/files/{fileId}/documents-repo/remove
     * @secure
     */
    ticketFilesControllerRemoveFromDocumentRepo: (
      ticketId: string,
      fileId: string,
      params: RequestParams = {}
    ) =>
      this.request<string, void>({
        path: `/tickets/${ticketId}/files/${fileId}/documents-repo/remove`,
        method: 'PUT',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ticket Files
     * @name TicketFilesControllerDeleteTicketFile
     * @request DELETE:/tickets/{ticketId}/files/{fileId}
     * @secure
     */
    ticketFilesControllerDeleteTicketFile: (
      ticketId: string,
      fileId: string,
      params: RequestParams = {}
    ) =>
      this.request<string, void>({
        path: `/tickets/${ticketId}/files/${fileId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tickets
     * @name TicketsControllerGetTickets
     * @request GET:/tickets
     * @secure
     */
    ticketsControllerGetTickets: (
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - vectorTicketId
         * - subject
         * - description
         * - status
         * - priority
         * - category
         * - subCategory
         * - vendorName
         * - location
         * - zip
         * - address
         * - city
         * - state
         * - subStatus
         * - assignee
         * - assigneeEmail
         * - assigneeName
         * - requestorEmail
         * - requestorName
         * - organizationId
         * - organizationName
         * - vendorId
         * - ticketNumber
         * - accessToExternalUser
         * - createdAt
         * - updatedAt
         * - dueDate
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                  | Type    | Allowed Rules                                                                | Possible Values |
         * | -------------------- | ------- | ---------------------------------------------------------------------------- | --------------- |
         * | id                   | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vectorTicketId       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subject              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | description          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | status               | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | priority             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | category             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subCategory          | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorName           | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | location             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | zip                  | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | address              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | city                 | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | state                | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | subStatus            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assignee             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeEmail        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | assigneeName         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestorEmail       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | requestorName        | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationId       | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | organizationName     | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorId             | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | ticketNumber         | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | accessToExternalUser | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty                              |                 |
         * | createdAt            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | updatedAt            | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | dueDate              | string  | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
        /**
         * Free-text search term. Searches across the following fields:
         *
         * - subject
         * - description
         * - category
         */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<TicketListDto, void>({
        path: `/tickets`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tickets
     * @name TicketsControllerGetTicket
     * @request GET:/tickets/{ticketId}
     * @secure
     */
    ticketsControllerGetTicket: (
      ticketId: string,
      params: RequestParams = {}
    ) =>
      this.request<TicketDto, void>({
        path: `/tickets/${ticketId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tickets
     * @name TicketsControllerUpdateTicket
     * @request PUT:/tickets/{ticketId}
     * @secure
     */
    ticketsControllerUpdateTicket: (
      ticketId: string,
      data: UpdateTicketDto,
      params: RequestParams = {}
    ) =>
      this.request<TicketDto, void>({
        path: `/tickets/${ticketId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ticket Comments
     * @name TicketsCommentsControllerCreateComment
     * @request POST:/tickets/{ticketId}/comments
     * @secure
     */
    ticketsCommentsControllerCreateComment: (
      ticketId: string,
      data: CreateTicketCommentDto,
      params: RequestParams = {}
    ) =>
      this.request<CreateTicketCommentResponseDto, void>({
        path: `/tickets/${ticketId}/comments`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ticket Comments
     * @name TicketsCommentsControllerGetCommentsByTicketId
     * @request GET:/tickets/{ticketId}/comments
     * @secure
     */
    ticketsCommentsControllerGetCommentsByTicketId: (
      ticketId: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - createdAt
         * - updatedAt
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | comment | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | scope   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /** SearchTerm allows to filter results by: comment content */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<TicketCommentListDto, void>({
        path: `/tickets/${ticketId}/comments`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ticket Grouping
     * @name TicketGroupingControllerGroupByOrganization
     * @request GET:/tickets/group/organization
     * @secure
     */
    ticketGroupingControllerGroupByOrganization: (
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - vectorTicketId
         * - subject
         * - description
         * - status
         * - priority
         * - category
         * - subCategory
         * - createdAt
         * - updatedAt
         * - requestorName
         * - assigneeName
         * - vendorName
         * - location
         * - zip
         * - address
         * - city
         * - state
         * - subStatus
         * - accessToExternalUser
         * - organizationName
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | vectorTicketId       | string | like |  |
         * | subject              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | description          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | status               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | priority             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | category             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | subCategory          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | assignee             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | assigneeEmail        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | requestor            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | requestorName        | string | like |  |
         * | assigneeName         | string | like |  |
         * | assigneeEmail        | string | like |  |
         * | updatedAt            | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | createdAt            | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | vendor               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | location             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | vendorName           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | zip                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | address              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | city                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | state                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | subStatus            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | accessToExternalUser | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty |  |
         * | ticketNumber         | string | like |  |
         * | organizationId       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | organizationName     | string | like |  |
         * | vendorId             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /** Searching by: subject, description, category */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<OrganizationTicketCountListDto, void>({
        path: `/tickets/group/organization`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ticket Grouping
     * @name TicketGroupingControllerGroupByAssignee
     * @request GET:/tickets/group/assignee
     * @secure
     */
    ticketGroupingControllerGroupByAssignee: (
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - vectorTicketId
         * - subject
         * - description
         * - status
         * - priority
         * - category
         * - subCategory
         * - createdAt
         * - updatedAt
         * - requestorName
         * - assigneeName
         * - vendorName
         * - location
         * - zip
         * - address
         * - city
         * - state
         * - subStatus
         * - accessToExternalUser
         * - organizationName
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | vectorTicketId       | string | like |  |
         * | subject              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | description          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | status               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | priority             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | category             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | subCategory          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | assignee             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | assigneeEmail        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | requestor            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | requestorName        | string | like |  |
         * | assigneeName         | string | like |  |
         * | assigneeEmail        | string | like |  |
         * | updatedAt            | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | createdAt            | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | vendor               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | location             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | vendorName           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | zip                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | address              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | city                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | state                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | subStatus            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | accessToExternalUser | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty |  |
         * | ticketNumber         | string | like |  |
         * | organizationId       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | organizationName     | string | like |  |
         * | vendorId             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /** Searching by: subject, description, category */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<AssigneeTicketGroupingListDto, void>({
        path: `/tickets/group/assignee`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ticket Grouping
     * @name TicketGroupingControllerGroupByStatus
     * @request GET:/tickets/group/status
     * @secure
     */
    ticketGroupingControllerGroupByStatus: (
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - vectorTicketId
         * - subject
         * - description
         * - status
         * - priority
         * - category
         * - subCategory
         * - createdAt
         * - updatedAt
         * - requestorName
         * - assigneeName
         * - vendorName
         * - location
         * - zip
         * - address
         * - city
         * - state
         * - subStatus
         * - accessToExternalUser
         * - organizationName
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | vectorTicketId       | string | like |  |
         * | subject              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | description          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | status               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | priority             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | category             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | subCategory          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | assignee             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | assigneeEmail        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | requestor            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | requestorName        | string | like |  |
         * | assigneeName         | string | like |  |
         * | assigneeEmail        | string | like |  |
         * | updatedAt            | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | createdAt            | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | vendor               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | location             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | vendorName           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | zip                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | address              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | city                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | state                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | subStatus            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | accessToExternalUser | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty |  |
         * | ticketNumber         | string | like |  |
         * | organizationId       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | organizationName     | string | like |  |
         * | vendorId             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /** Searching by: subject, description, category */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<any, void | StatusTicketGroupingListDto>({
        path: `/tickets/group/status`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ticket Grouping
     * @name TicketGroupingControllerGroupByCatgory
     * @request GET:/tickets/group/category
     * @secure
     */
    ticketGroupingControllerGroupByCatgory: (
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - vectorTicketId
         * - subject
         * - description
         * - status
         * - priority
         * - category
         * - subCategory
         * - createdAt
         * - updatedAt
         * - requestorName
         * - assigneeName
         * - vendorName
         * - location
         * - zip
         * - address
         * - city
         * - state
         * - subStatus
         * - accessToExternalUser
         * - organizationName
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | vectorTicketId       | string | like |  |
         * | subject              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | description          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | status               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | priority             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | category             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | subCategory          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | assignee             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | assigneeEmail        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | requestor            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | requestorName        | string | like |  |
         * | assigneeName         | string | like |  |
         * | assigneeEmail        | string | like |  |
         * | updatedAt            | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | createdAt            | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | vendor               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | location             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | vendorName           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | zip                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | address              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | city                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | state                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | subStatus            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | accessToExternalUser | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty |  |
         * | ticketNumber         | string | like |  |
         * | organizationId       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | organizationName     | string | like |  |
         * | vendorId             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /** Searching by: subject, description, category */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<any, void | CategoryTicketGroupingListDto>({
        path: `/tickets/group/category`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),
  };
  preference = {
    /**
     * No description
     *
     * @tags Preferences
     * @name PreferenceControllerUpsertPreferences
     * @request PUT:/preference/{key}
     * @secure
     */
    preferenceControllerUpsertPreferences: (
      key: string,
      query: {
        /** @example "user" */
        type: PreferenceControllerUpsertPreferencesParamsTypeEnum;
        organizationId?: string;
        key: string;
      },
      data: UpsertPreferenceBodyDto,
      params: RequestParams = {}
    ) =>
      this.request<PreferenceDto, void>({
        path: `/preference/${key}`,
        method: 'PUT',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Preferences
     * @name PreferenceControllerGetPreferences
     * @request GET:/preference
     * @secure
     */
    preferenceControllerGetPreferences: (
      query?: {
        /** @example "user" */
        type?: PreferenceControllerGetPreferencesParamsTypeEnum;
        organizationId?: string;
        key?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<PreferenceListDto, void>({
        path: `/preference`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  notifications = {
    /**
     * No description
     *
     * @tags Notifications
     * @name NotificationControllerFindAll
     * @request GET:/notifications
     * @secure
     */
    notificationControllerFindAll: (
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - createdAt
         * - updatedAt
         * - type
         * - seenAt
         * - priority
         * - description
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | createdAt   | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | updatedAt   | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | type        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | document_uploaded, task_completed, task_assigned, task_unassigned, task_edited, task_tagged, action_item_created, action_item_assigned, action_item_deadline_approaching, action_item_overdue, ticket_comment_added, ticket_status_changed, spend_area_requested, user_invited, contract_expiration |
         * | seenAt      | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | priority    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | success, error, warning, info |
         * | description | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /** Search by notification title or description */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<NotificationListDto, void>({
        path: `/notifications`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name NotificationControllerUpdate
     * @request PATCH:/notifications/{id}
     * @secure
     */
    notificationControllerUpdate: (
      id: string,
      data: UpdateNotificationDto,
      params: RequestParams = {}
    ) =>
      this.request<NotificationDto, void>({
        path: `/notifications/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name NotificationControllerGetCount
     * @request GET:/notifications/count
     * @secure
     */
    notificationControllerGetCount: (
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - createdAt
         * - updatedAt
         * - type
         * - seenAt
         * - priority
         * - description
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | createdAt   | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | updatedAt   | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | type        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | document_uploaded, task_completed, task_assigned, task_unassigned, task_edited, task_tagged, action_item_created, action_item_assigned, action_item_deadline_approaching, action_item_overdue, ticket_comment_added, ticket_status_changed, spend_area_requested, user_invited, contract_expiration |
         * | seenAt      | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | priority    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | success, error, warning, info |
         * | description | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /** Search by notification title or description */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<NotificationCountDto, void>({
        path: `/notifications/count`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Establishes a continuous SSE stream. **Note:** Swagger UI will keep loading indefinitely, because SSE does not close the connection.
     *
     * @tags Notifications (SSE)
     * @name NotificationSSeControllerSubscribe
     * @summary Subscribe to SSE notifications
     * @request GET:/notifications/{userId}
     * @secure
     */
    notificationSSeControllerSubscribe: (
      userId: string,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/notifications/${userId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),
  };
  recurringTask = {
    /**
     * No description
     *
     * @tags Recurring Task
     * @name RecurringTaskControllerCreateRecurringTask
     * @request POST:/recurring-task
     * @secure
     */
    recurringTaskControllerCreateRecurringTask: (
      data: CreateRecurringTaskDto,
      params: RequestParams = {}
    ) =>
      this.request<RecurringTaskDto, void>({
        path: `/recurring-task`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Recurring Task
     * @name RecurringTaskControllerFindAll
     * @request GET:/recurring-task
     * @secure
     */
    recurringTaskControllerFindAll: (
      query: {
        searchTerm?: string;
        userId?: string;
        /**
         * Current page number
         * @default 0
         * @example 0
         */
        page: number;
        /**
         * Number of items per page
         * @example 5
         */
        size: number;
        /**
         * Sorting parameter in the format property:direction.
         *
         * Sortable properties: title, description, priorityLevel, createdAt, updatedAt, referenceLink, referenceName, timeToComplete, timeToCompleteAmount, estimatedTime
         *
         *  Available directions: asc, desc
         */
        sort?: string;
        /**
         * Filtering parameter in the format property:rule:value.
         *
         * Filterable fields: title, description, priorityLevel, createdAt, updatedAt, category, referenceLink, referenceName, timeToComplete, timeToCompleteAmount, estimatedTime
         *
         *  Available rules: eq, neq, gt, gte, lt, lte, like, nlike, in, nin, isnull, isnotnull.
         *
         * Enum values:
         *
         *  priorityLevel: low, medium, high
         *
         * category: Vendor Call, Client Call, Internal outreach, Vendor email, Client email, Data analysis, Report build, Data gathering, Invoice Collection, Research, Proactive Client Outreach, Other
         *
         * timeToComplete: day, week, month
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<RecurringTaskListDto, void>({
        path: `/recurring-task`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Recurring Task
     * @name RecurringTaskControllerFindOne
     * @request GET:/recurring-task/{id}
     * @secure
     */
    recurringTaskControllerFindOne: (id: string, params: RequestParams = {}) =>
      this.request<RecurringTaskDto, void>({
        path: `/recurring-task/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Recurring Task
     * @name RecurringTaskControllerUpdate
     * @request PATCH:/recurring-task/{id}
     * @secure
     */
    recurringTaskControllerUpdate: (
      id: string,
      data: UpdateRecurringTaskDto,
      params: RequestParams = {}
    ) =>
      this.request<RecurringTaskDto, void>({
        path: `/recurring-task/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Recurring Task
     * @name RecurringTaskControllerDeleteOne
     * @request DELETE:/recurring-task/{id}
     * @secure
     */
    recurringTaskControllerDeleteOne: (
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/recurring-task/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Recurring Task
     * @name RecurringTaskControllerGetRecurringTaskNextOccurrences
     * @request GET:/recurring-task/{id}/preview
     * @secure
     */
    recurringTaskControllerGetRecurringTaskNextOccurrences: (
      id: string,
      query: {
        limit: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<Date[], void>({
        path: `/recurring-task/${id}/preview`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  member = {
    /**
     * No description
     *
     * @tags Member
     * @name MemberControllerFindUsersWithTaskByOrganization
     * @request GET:/member/{organizationId}
     * @secure
     */
    memberControllerFindUsersWithTaskByOrganization: (
      organizationId: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         * - emailAddress
         * - surname
         * - contactPhoneNumber
         * - title
         * - userLoginStatus
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | id                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | name               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | emailAddress       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | surname            | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | contactPhoneNumber | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | title              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | userLoginStatus    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /** Search by name or email address */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<MemberListDto, void>({
        path: `/member/${organizationId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member
     * @name MemberControllerGetOrganizationMembersSummary
     * @request GET:/member/organizations/summary
     * @secure
     */
    memberControllerGetOrganizationMembersSummary: (
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - id
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | name                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | id                     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | actionItem.completedAt | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        type?: OrganizationSpecialFilter;
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<OrganizationSummaryWithCountsListDto, void>({
        path: `/member/organizations/summary`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member
     * @name MemberControllerGetOrganizationMembersSummaryByActiveTasks
     * @request GET:/member/organizations/summary/active-tasks
     * @secure
     */
    memberControllerGetOrganizationMembersSummaryByActiveTasks: (
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - id
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | name                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | id                     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | actionItem.completedAt | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<OrganizationSummaryWithMyActiveTasksCountListDto, void>({
        path: `/member/organizations/summary/active-tasks`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Member
     * @name MemberControllerGetOrganizationMembersSummaryActionItems
     * @request GET:/member/organizations/summary/action-items
     * @secure
     */
    memberControllerGetOrganizationMembersSummaryActionItems: (
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - id
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | name                   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | id                     | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | actionItem.completedAt | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        myOrganizations?: boolean;
        inProgress?: boolean;
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<OrganizationSummaryWithActionItemsCountListDto, void>({
        path: `/member/organizations/summary/action-items`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  user = {
    /**
     * No description
     *
     * @tags User
     * @name UsersControllerGetCurrentUser
     * @request GET:/user/current
     * @secure
     */
    usersControllerGetCurrentUser: (params: RequestParams = {}) =>
      this.request<CurrentUserDto, void>({
        path: `/user/current`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name UsersControllerGetUserOrganizations
     * @request GET:/user/organizations
     * @secure
     */
    usersControllerGetUserOrganizations: (
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - id
         * - createdAt
         * - updatedAt
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | id                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | name              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | createdAt         | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | updatedAt         | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | micrositesEnabled | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<PlainOrganizationListDto, void>({
        path: `/user/organizations`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Access Share
     * @name AccessShareControllerDeleteInvitedUser
     * @request DELETE:/user/invited-users/{userId}
     * @secure
     */
    accessShareControllerDeleteInvitedUser: (
      userId: string,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/user/invited-users/${userId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Access Share
     * @name AccessShareControllerInviteUsersDeprecated
     * @summary Use organization/:organizationId/invite instead
     * @request POST:/user/{organizationId}/invite
     * @deprecated
     * @secure
     */
    accessShareControllerInviteUsersDeprecated: (
      organizationId: string,
      data: InviteUserBodyDto,
      params: RequestParams = {}
    ) =>
      this.request<InviteUserResponseDto, void>({
        path: `/user/${organizationId}/invite`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Access Share
     * @name AccessShareControllerResendInvitationDeprecated
     * @summary Use organization/:organizationId/invited-users/:userId/resend-invitation instead
     * @request POST:/user/invited-users/{userId}/resend-invitation
     * @deprecated
     * @secure
     */
    accessShareControllerResendInvitationDeprecated: (
      userId: string,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/user/invited-users/${userId}/resend-invitation`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AI Agent Integration - Users
     * @name UsersControllerHasUserAccessDeprecated
     * @request GET:/user/{userId}/organizations/{organizationId}
     * @secure
     */
    usersControllerHasUserAccessDeprecated: (
      userId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/user/${userId}/organizations/${organizationId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),
  };
  organizationId = {
    /**
     * No description
     *
     * @tags Organization Audits
     * @name OrganizationAuditsControllerGetAllAuditsByOrganizationId
     * @request GET:/{organizationId}/audits
     * @secure
     */
    organizationAuditsControllerGetAllAuditsByOrganizationId: (
      organizationId: string,
      query?: {
        /** Sorting parameter in format property:direction. Multiple sorts separated by comma. */
        sort?: string[];
        /** Filtering parameters in format property:rule:value. Multiple filters as array. */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /** Search by audit name or related fields */
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<AuditsListDto, void>({
        path: `/${organizationId}/audits`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SubauditVersions
     * @name SubauditVersionsControllerFindAllChangeLogs
     * @request GET:/{organizationId}/subaudit/{subauditId}/versions/changelogs
     * @secure
     */
    subauditVersionsControllerFindAllChangeLogs: (
      subauditId: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<SubauditVersionChangelogList, void>({
        path: `/${organizationId}/subaudit/${subauditId}/versions/changelogs`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Document Tags
     * @name DocumentTagsControllerFindAll
     * @request GET:/{organizationId}/document-tags
     * @secure
     */
    documentTagsControllerFindAll: (
      organizationId: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - createdAt
         * - updatedAt
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | name      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | createdAt | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | updatedAt | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<DocumentTagsListDto, void>({
        path: `/${organizationId}/document-tags`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Document Tags
     * @name DocumentTagsControllerCreate
     * @request POST:/{organizationId}/document-tags
     * @secure
     */
    documentTagsControllerCreate: (
      organizationId: string,
      data: CreateDocumentTagDto,
      params: RequestParams = {}
    ) =>
      this.request<DocumentTagDto, void>({
        path: `/${organizationId}/document-tags`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Document Tags
     * @name DocumentTagsControllerFindOne
     * @request GET:/{organizationId}/document-tags/{uuid}
     * @secure
     */
    documentTagsControllerFindOne: (
      uuid: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<DocumentTagDto, void>({
        path: `/${organizationId}/document-tags/${uuid}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Document Tags
     * @name DocumentTagsControllerUpdate
     * @request PATCH:/{organizationId}/document-tags/{uuid}
     * @secure
     */
    documentTagsControllerUpdate: (
      uuid: string,
      organizationId: string,
      data: UpdateDocumentTagDto,
      params: RequestParams = {}
    ) =>
      this.request<DocumentTagDto, void>({
        path: `/${organizationId}/document-tags/${uuid}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Document Tags
     * @name DocumentTagsControllerDeleteOne
     * @request DELETE:/{organizationId}/document-tags/{uuid}
     * @secure
     */
    documentTagsControllerDeleteOne: (
      uuid: string,
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<DocumentTagDto, void>({
        path: `/${organizationId}/document-tags/${uuid}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  siteList = {
    /**
     * No description
     *
     * @tags SiteList
     * @name SiteListControllerGetOrganizationSavingsSummary
     * @request GET:/site-list/{organizationId}/locations-list
     * @secure
     */
    siteListControllerGetOrganizationSavingsSummary: (
      organizationId: string,
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - address
         * - city
         * - state
         * - status
         * - zip
         * - taxId
         * - documentFieldStatus
         * - name
         * - locationIdentifier
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | id                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | address             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | city                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | state               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | zip                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | taxId               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | status              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | Active, Monitored, Sold, Closed, Under Construction, Not Active |
         * | documentFieldStatus | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | COMPLETE, MISSING_FIELDS, UPLOAD_INVOICES, NOT_APPLICABLE_REQUESTED, NOT_APPLICABLE |
         * | locationIdentifier  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | name                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /** JSON array of column paths. Headers are auto-generated from keys. Example: ["name","status"] */
        columns?: string;
        /** Custom filename for CSV (without extension) */
        filename?: string;
        /** Start date for filtering savings/spend (YYYY-MM-DD) */
        startOfSavingsPeriod?: string;
        /** End date for filtering savings/spend (YYYY-MM-DD) */
        endOfSavingsPeriod?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<LocationListDto, void>({
        path: `/site-list/${organizationId}/locations-list`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SiteList
     * @name SiteListControllerExportOrganizationLocations
     * @request GET:/site-list/{organizationId}/locations-list/export
     * @secure
     */
    siteListControllerExportOrganizationLocations: (
      organizationId: string,
      query: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - address
         * - city
         * - state
         * - status
         * - zip
         * - taxId
         * - documentFieldStatus
         * - name
         * - locationIdentifier
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | id                  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | address             | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | city                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | state               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | zip                 | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | taxId               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | status              | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | Active, Monitored, Sold, Closed, Under Construction, Not Active |
         * | documentFieldStatus | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty | COMPLETE, MISSING_FIELDS, UPLOAD_INVOICES, NOT_APPLICABLE_REQUESTED, NOT_APPLICABLE |
         * | locationIdentifier  | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | name                | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /** Start date for filtering savings/spend (YYYY-MM-DD) */
        startOfSavingsPeriod?: string;
        /** End date for filtering savings/spend (YYYY-MM-DD) */
        endOfSavingsPeriod?: string;
        /** JSON object mapping column paths to headers. Use null for auto-generated headers. Example: {"name":"Name","status":null} */
        columns: string;
        /** Custom filename for the CSV download (without extension). */
        filename?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<StreamableFile, void>({
        path: `/site-list/${organizationId}/locations-list/export`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SiteList
     * @name SiteListControllerGetFilesUnderValidation
     * @request GET:/site-list/{organizationId}/files-under-validation
     * @secure
     */
    siteListControllerGetFilesUnderValidation: (
      organizationId: string,
      params: RequestParams = {}
    ) =>
      this.request<GetFilesUnderValidationResponseDto, void>({
        path: `/site-list/${organizationId}/files-under-validation`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SiteList
     * @name SiteListControllerUploadLocationList
     * @request POST:/site-list/{organizationId}/upload
     * @secure
     */
    siteListControllerUploadLocationList: (
      organizationId: string,
      data: UploadDocumentDto,
      params: RequestParams = {}
    ) =>
      this.request<ExcelUploadResponseDto, void>({
        path: `/site-list/${organizationId}/upload`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SiteList
     * @name SiteListControllerRequestLocationStatusChange
     * @request POST:/site-list/{organizationId}/location/actions
     * @secure
     */
    siteListControllerRequestLocationStatusChange: (
      organizationId: string,
      data: LocationActionBodyDto,
      params: RequestParams = {}
    ) =>
      this.request<LocationActionResponseDto, void>({
        path: `/site-list/${organizationId}/location/actions`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SiteList
     * @name SiteListControllerGetLocationById
     * @request GET:/site-list/{id}
     * @secure
     */
    siteListControllerGetLocationById: (
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<LocationDto, void>({
        path: `/site-list/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SiteList
     * @name SiteListControllerDeleteLocation
     * @request DELETE:/site-list/{id}
     * @secure
     */
    siteListControllerDeleteLocation: (
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/site-list/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SiteList
     * @name SiteListControllerUpdateLocation
     * @request PATCH:/site-list/{id}
     * @secure
     */
    siteListControllerUpdateLocation: (
      id: string,
      data: UpdateLocationDto,
      params: RequestParams = {}
    ) =>
      this.request<LocationDto, void>({
        path: `/site-list/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  actionItemTemplate = {
    /**
     * No description
     *
     * @tags ActionItemTemplate
     * @name ActionItemTemplateControllerGetAllActionItemTemplates
     * @request GET:/action-item-template
     * @secure
     */
    actionItemTemplateControllerGetAllActionItemTemplates: (
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - id
         * - name
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | id          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | name        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | description | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<ActionItemTemplateListDto, void>({
        path: `/action-item-template`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  faqs = {
    /**
     * No description
     *
     * @tags FAQ
     * @name FaqControllerGetAllFaqs
     * @summary Get all FAQs with pagination and filtering
     * @request GET:/faqs
     * @secure
     */
    faqControllerGetAllFaqs: (
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - title
         * - description
         * - createdAt
         * - updatedAt
         * - category
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | title       | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | description | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | category    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | createdAt   | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | updatedAt   | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        /**
         * Search term to filter FAQs by title or description
         * @example "billing"
         */
        searchTerm?: string;
        /**
         * Filter FAQs by category ID
         * @example "123e4567-e89b-12d3-a456-426614174000"
         */
        categoryId?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<FaqListDto, void>({
        path: `/faqs`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  shipware = {
    /**
     * No description
     *
     * @tags Shipware
     * @name ShipwareControllerGetAccessToken
     * @request GET:/shipware/access-token
     * @secure
     */
    shipwareControllerGetAccessToken: (params: RequestParams = {}) =>
      this.request<ShipwareAccessTokenDto, void>({
        path: `/shipware/access-token`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  blobHealthCheck = {
    /**
     * @description Ensures an empty `check.txt` probe exists (via existing upload flow), then returns a time-limited read SAS URL in the JSON body so the client can open it (for example in a new window) without an HTTP redirect.
     *
     * @tags Blob health check
     * @name BlobHealthCheckControllerBrowserConnectivity
     * @summary Returns a read SAS URL for Azure Blob Storage connectivity verification
     * @request GET:/blob-health-check/browser-connectivity
     * @secure
     */
    blobHealthCheckControllerBrowserConnectivity: (
      params: RequestParams = {}
    ) =>
      this.request<BlobBrowserConnectivityResponseDto, void>({
        path: `/blob-health-check/browser-connectivity`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  spends = {
    /**
     * No description
     *
     * @tags Spends
     * @name SpendsControllerFindAll
     * @request GET:/spends
     * @secure
     */
    spendsControllerFindAll: (
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - optimizationSubject
         * - initiator
         * - stage
         * - vendorContract
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key                 | Type   | Allowed Rules                                                                | Possible Values |
         * | ------------------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | optimizationSubject | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | initiator           | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | stage               | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorContract      | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<SpendListDto, void>({
        path: `/spends`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Spends
     * @name SpendsControllerCreate
     * @request POST:/spends
     * @secure
     */
    spendsControllerCreate: (
      data: CreateSpendDto,
      params: RequestParams = {}
    ) =>
      this.request<SpendItemDto, void>({
        path: `/spends`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  contractNegotiations = {
    /**
     * No description
     *
     * @tags Contract Negotiations
     * @name ContractNegotiationsControllerFindAll
     * @request GET:/contract-negotiations
     * @secure
     */
    contractNegotiationsControllerFindAll: (
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - audit
         * - vendor
         * - vendorContract
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key            | Type   | Allowed Rules                                                                | Possible Values |
         * | -------------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | audit          | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendor         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | vendorContract | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<ContractNegotiationListDto, void>({
        path: `/contract-negotiations`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contract Negotiations
     * @name ContractNegotiationsControllerCreate
     * @request POST:/contract-negotiations
     * @secure
     */
    contractNegotiationsControllerCreate: (
      data: CreateContractNegotiationDto,
      params: RequestParams = {}
    ) =>
      this.request<ContractNegotiationItemDto, void>({
        path: `/contract-negotiations`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  invoices = {
    /**
     * No description
     *
     * @tags Invoices
     * @name InvoicesControllerFindAll
     * @request GET:/invoices
     * @secure
     */
    invoicesControllerFindAll: (
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.
         *
         * Supports nested JSON via dot notation (e.g. meta.title).
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<InvoiceListDto, void>({
        path: `/invoices`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invoices
     * @name InvoicesControllerCreate
     * @request POST:/invoices
     * @secure
     */
    invoicesControllerCreate: (
      data: CreateInvoiceDto,
      params: RequestParams = {}
    ) =>
      this.request<InvoiceItemDto, void>({
        path: `/invoices`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  spendLineItems = {
    /**
     * No description
     *
     * @tags Spend Line Items
     * @name SpendLineItemsControllerFindAll
     * @request GET:/spend-line-items
     * @secure
     */
    spendLineItemsControllerFindAll: (
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - spend
         * - invoice
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key     | Type   | Allowed Rules                                                                | Possible Values |
         * | ------- | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | spend   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         * | invoice | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<SpendLineItemListDto, void>({
        path: `/spend-line-items`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Spend Line Items
     * @name SpendLineItemsControllerCreate
     * @request POST:/spend-line-items
     * @secure
     */
    spendLineItemsControllerCreate: (
      data: CreateSpendLineItemDto,
      params: RequestParams = {}
    ) =>
      this.request<SpendLineItemItemDto, void>({
        path: `/spend-line-items`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  vendorContracts = {
    /**
     * No description
     *
     * @tags Vendor Contracts
     * @name VendorContractsControllerFindAll
     * @request GET:/vendor-contracts
     * @secure
     */
    vendorContractsControllerFindAll: (
      query?: {
        /**
         * Page number (1-based)
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page (max 1000)
         * @example 25
         */
        size?: number;
        /**
         * Sort in format **property:asc|desc**. Multiple values accepted as repeated query params or comma-separated.Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - vendor
         */
        sort?: string[];
        /**
         * Filter in format **property:rule:value**. Multiple values accepted as repeated query params.Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key    | Type   | Allowed Rules                                                                | Possible Values |
         * | ------ | ------ | ---------------------------------------------------------------------------- | --------------- |
         * | vendor | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |                 |
         */
        filter?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<VendorContractListDto, void>({
        path: `/vendor-contracts`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendor Contracts
     * @name VendorContractsControllerCreate
     * @request POST:/vendor-contracts
     * @secure
     */
    vendorContractsControllerCreate: (
      data: CreateVendorContractDto,
      params: RequestParams = {}
    ) =>
      this.request<VendorContractItemDto, void>({
        path: `/vendor-contracts`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  deviceTokens = {
    /**
     * @description Registers or updates an FCM device token for push notifications. If the token already exists, it will be reactivated and updated.
     *
     * @tags Device Tokens
     * @name DeviceTokenControllerRegister
     * @summary Register a device token
     * @request POST:/device-tokens
     * @secure
     */
    deviceTokenControllerRegister: (
      data: RegisterDeviceTokenDto,
      params: RequestParams = {}
    ) =>
      this.request<DeviceTokenDto, void>({
        path: `/device-tokens`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device Tokens
     * @name DeviceTokenControllerGetMyTokens
     * @request GET:/device-tokens
     * @secure
     */
    deviceTokenControllerGetMyTokens: (
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - platform
         * - deviceName
         * - createdAt
         * - lastUsedAt
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | platform   | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | deviceName | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | createdAt  | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | lastUsedAt | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<DeviceTokensListDto, void>({
        path: `/device-tokens`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Unregisters an FCM device token. Call this when the user logs out or disables notifications.
     *
     * @tags Device Tokens
     * @name DeviceTokenControllerUnregister
     * @summary Unregister a device token
     * @request DELETE:/device-tokens/{id}
     * @secure
     */
    deviceTokenControllerUnregister: (id: string, params: RequestParams = {}) =>
      this.request<UnregisterTokenDto, void>({
        path: `/device-tokens/${id}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  review = {
    /**
     * No description
     *
     * @tags Review
     * @name ReviewControllerCreateReview
     * @request POST:/review
     * @secure
     */
    reviewControllerCreateReview: (
      data: CreateReviewDto,
      params: RequestParams = {}
    ) =>
      this.request<CreateReviewDto, void>({
        path: `/review`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  tags = {
    /**
     * No description
     *
     * @tags Tags
     * @name TagsControllerFindAll
     * @request GET:/tags
     * @secure
     */
    tagsControllerFindAll: (
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - createdAt
         * - updatedAt
         * - color
         * - createdBy
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | name         | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | createdAt    | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | updatedAt    | date | eq, neq, gt, gte, lt, lte, between, isnull, isnotnull, isempty, isnotempty |  |
         * | color        | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | createdBy    | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         * | isPredefined | boolean | eq, neq, isnull, isnotnull, isempty, isnotempty |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<TagsListDto, void>({
        path: `/tags`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tags
     * @name TagsControllerCreate
     * @request POST:/tags
     * @secure
     */
    tagsControllerCreate: (data: CreateTagDto, params: RequestParams = {}) =>
      this.request<TagDto, void>({
        path: `/tags`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tags
     * @name TagsControllerFindOne
     * @request GET:/tags/{uuid}
     * @secure
     */
    tagsControllerFindOne: (uuid: string, params: RequestParams = {}) =>
      this.request<TagDto, void>({
        path: `/tags/${uuid}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tags
     * @name TagsControllerUpdate
     * @request PATCH:/tags/{uuid}
     * @secure
     */
    tagsControllerUpdate: (
      uuid: string,
      data: UpdateTagDto,
      params: RequestParams = {}
    ) =>
      this.request<TagDto, void>({
        path: `/tags/${uuid}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tags
     * @name TagsControllerDeleteOne
     * @request DELETE:/tags/{uuid}
     * @secure
     */
    tagsControllerDeleteOne: (uuid: string, params: RequestParams = {}) =>
      this.request<any, void>({
        path: `/tags/${uuid}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  vendors = {
    /**
     * No description
     *
     * @tags Vendors
     * @name VendorsControllerGetAllVendorsSelectList
     * @request GET:/vendors/select-list
     * @secure
     */
    vendorsControllerGetAllVendorsSelectList: (
      query?: {
        /**
         * Sorting parameter in format **property:direction**. Multiple sorts as array.
         *
         *
         * **Allowed fields:**
         *
         *
         * - name
         * - createdAt
         * - updatedAt
         */
        sort?: string[];
        /**
         * Filtering parameters in format **property:rule:values**. Multiple filters as array.
         *
         *
         * | Key         | Type | Allowed Rules | Possible Values |
         * | ------------ | ---- | ------------- | ---------------- |
         * | name | string | eq, neq, like, nlike, eqci, neqci, in, nin, inci, ninci, isempty, isnotempty |  |
         *
         *
         *
         *
         */
        filter?: string[];
        /**
         * Current page number (1-based)
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Number of items per page
         * @max 1000
         * @default 25
         * @example 25
         */
        size?: number;
        serviceCategory?: string;
        searchTerm?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<VendorSelectListDto, void>({
        path: `/vendors/select-list`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendors
     * @name VendorsControllerGetVendorById
     * @request GET:/vendors/{vendorId}
     * @secure
     */
    vendorsControllerGetVendorById: (
      vendorId: string,
      params: RequestParams = {}
    ) =>
      this.request<VendorDto, void>({
        path: `/vendors/${vendorId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  profilePicture = {
    /**
     * No description
     *
     * @tags ProfilePicture
     * @name ProfilePictureControllerUpdateTicket
     * @request PUT:/profile-picture
     * @secure
     */
    profilePictureControllerUpdateTicket: (
      data: UpdateProfilePictureDto,
      params: RequestParams = {}
    ) =>
      this.request<string, void>({
        path: `/profile-picture`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),
  };
  staticContent = {
    /**
     * No description
     *
     * @tags Static Content
     * @name StaticContentControllerGetTosContent
     * @request GET:/static-content/tos-content
     * @secure
     */
    staticContentControllerGetTosContent: (params: RequestParams = {}) =>
      this.request<TosContentResponseDto, void>({
        path: `/static-content/tos-content`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  integrations = {
    /**
     * @description Creates a support ticket on behalf of the Franz integration. Requires an Entra ID client-credentials token belonging to the Franz integration account, which holds the Global-scoped Franz Integration permission.
     *
     * @tags Franz Integration - Tickets
     * @name FranzTicketsControllerCreateTicket
     * @summary Create a ticket (Franz integration)
     * @request POST:/integrations/franz/organizations/{organizationId}/tickets
     * @secure
     */
    franzTicketsControllerCreateTicket: (
      organizationId: string,
      data: CreateIntegrationTicketDto,
      params: RequestParams = {}
    ) =>
      this.request<IntegrationTicketResponseDto, void>({
        path: `/integrations/franz/organizations/${organizationId}/tickets`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  mobile = {
    /**
     * No description
     *
     * @tags Mobile Versions
     * @name VersionsControllerGetMobileVersions
     * @request GET:/mobile/versions
     */
    versionsControllerGetMobileVersions: (params: RequestParams = {}) =>
      this.request<MobileVersionsDto, any>({
        path: `/mobile/versions`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
}
